/* eslint-disable no-unused-vars */

import axios from "axios"
import { format } from "date-fns"

import {
    onlyDateFormate
} from "../components/Utility/DateFormate.js"
import {
    DEVICE_REGISTRATION,
    DOAMIN_PATH,
    KNOWLEDGE_DOMAIN_PATH,
    LMS_DOMAIN_PATH,
    NOTIFICATION_DOMAIN_PATH,
    ORDER_MANAGEMENT,
    PRICING_DOMAIN_PATH,
    PRODUCT_AND_PARTS,
    REPORTING_SERVICE_DOMAIN_PATH,
    SERVICE_CENTER_DOMAIN_PATH,
    UPLOAD_PATH,
    USER_MANAGEMENT_DOMAIN_PATH,
    WARRANTY_MANAGEMENT } from "../config"

const localStorageData = sessionStorage.getItem("loginDetails") || null // TO get only MFA Token
const localUserDetailsData = sessionStorage.getItem("userDetails") || null // TO get All User Details
const selecteLangId = localStorage.getItem("selectedLanguageId")
const loggedInUserDetails = localUserDetailsData
    ? JSON.parse(localUserDetailsData)?.user_details
    : {}
// Check user Type for Service Center Or P&G
const userType = loggedInUserDetails?.user_type || 0
const userDetailsStoredData = localUserDetailsData
let accessToken, userDetailsData

if (localStorageData !="" && localStorageData != null && localStorageData != undefined) {
    if(userType == 2) accessToken = sessionStorage.getItem("id_token") || JSON.parse(localStorageData)?.access_token
    else accessToken = sessionStorage.getItem("id_token") || JSON.parse(localStorageData)?.mfaTokenData?.access_token
}

if(userDetailsStoredData !="" && userDetailsStoredData != null && userDetailsStoredData != undefined){
    userDetailsData = JSON.parse(userDetailsStoredData)?.user_details
}
const userInfo = {
    ...userDetailsData,
    salesOrgs:""
}

export const commonHeaders = {
    headers: {
        locale: "en-US", //navigator.language
        tenantid: 1
    }
}


const domainHeaders = {
    DOAMIN_PATH: {
        "Ocp-Apim-subscription-key": process.env.REACT_APP_DOAMIN_PATH_KEY
    },
    LMS_DOMAIN_PATH: {
        "Ocp-Apim-subscription-key": process.env.REACT_APP_LMS_DOMAIN_PATH_KEY
    },
    SERVICE_CENTER_DOMAIN_PATH: {
        "Ocp-Apim-subscription-key": process.env.REACT_APP_SERVICE_CENTER_DOMAIN_PATH_KEY
    },
    USER_MANAGEMENT_DOMAIN_PATH: {
        "Ocp-Apim-subscription-key": process.env.REACT_APP_USER_MANAGEMENT_DOMAIN_PATH_KEY
    },
    REPORTING_SERVICE_DOMAIN_PATH: {
        "Ocp-Apim-subscription-key": process.env.REACT_APP_REPORTING_SERVICE_DOMAIN_PATH_KEY
    },
    PRODUCT_AND_PARTS: {
        "Ocp-Apim-subscription-key": process.env.REACT_APP_PRODUCT_AND_PARTS_KEY
    },
    NOTIFICATION_DOMAIN_PATH: {
        "Ocp-Apim-subscription-key": process.env.REACT_APP_NOTIFICATION_DOMAIN_PATH_KEY
    },
    PRICING_DOMAIN_PATH: {
        "Ocp-Apim-subscription-key": process.env.REACT_APP_PRICING_DOMAIN_PATH_KEY
    },
    KNOWLEDGE_DOMAIN_PATH: {
        "Ocp-Apim-subscription-key": process.env.REACT_APP_KNOWLEDGE_DOMAIN_PATH_KEY
    },
    WARRANTY_MANAGEMENT: {
        "Ocp-Apim-subscription-key": process.env.REACT_APP_WARRANTY_MANAGEMENT_KEY
    },
    ORDER_MANAGEMENT: {
        "Ocp-Apim-subscription-key": process.env.REACT_APP_ORDER_MANAGEMENT_KEY
    },
    UPLOAD_PATH: {
        "Ocp-Apim-subscription-key": process.env.REACT_APP_UPLOAD_PATH_KEY
    },
    DEVICE_REGISTRATION: {
        "Ocp-Apim-subscription-key": process.env.REACT_APP_DEVICE_REGISTRATION_KEY
    }
    // Add other domain-specific headers here
}


const checkFields = (field, url, fallbackUrl) => {
    if(field)
        return url
    else
        return fallbackUrl
}

const appendQueryParam = (url, param, value) => {
    if (value) {
        url += `${url[url.length - 1] === "?" ? "" : "&"}${param}=${value}`
    }
    return url
}

const setHeaders = (config) => {
    if (config.url.includes(DOAMIN_PATH)) {
        config.headers = { ...config.headers, ...domainHeaders.DOAMIN_PATH }
    } else if(config.url.includes(LMS_DOMAIN_PATH)) {
        config.headers = { ...config.headers,  ...domainHeaders.LMS_DOMAIN_PATH }
    } else if(config.url.includes(SERVICE_CENTER_DOMAIN_PATH)) {
        config.headers = { ...config.headers, ...domainHeaders.SERVICE_CENTER_DOMAIN_PATH }
    } else if(config.url.includes(USER_MANAGEMENT_DOMAIN_PATH)) {
        config.headers = { ...config.headers, ...domainHeaders.USER_MANAGEMENT_DOMAIN_PATH }
    } else if(config.url.includes(PRODUCT_AND_PARTS)) {
        config.headers = { ...config.headers, ...domainHeaders.PRODUCT_AND_PARTS }
    } else if(config.url.includes(NOTIFICATION_DOMAIN_PATH)) {
        config.headers = { ...config.headers,  ...domainHeaders.NOTIFICATION_DOMAIN_PATH }
    } else if(config.url.includes(PRICING_DOMAIN_PATH)) {
        config.headers = { ...config.headers, ...domainHeaders.PRICING_DOMAIN_PATH }
    } else if(config.url.includes(KNOWLEDGE_DOMAIN_PATH)) {
        config.headers = { ...config.headers,  ...domainHeaders.KNOWLEDGE_DOMAIN_PATH }
    } else if(config.url.includes(WARRANTY_MANAGEMENT)) {
        config.headers = { ...config.headers,  ...domainHeaders.WARRANTY_MANAGEMENT }
    } else if(config.url.includes(ORDER_MANAGEMENT)) {
        config.headers = { ...config.headers, ...domainHeaders.ORDER_MANAGEMENT }
    } else if(config.url.includes(UPLOAD_PATH)) {
        config.headers = { ...config.headers, ...domainHeaders.UPLOAD_PATH }
    } else if(config.url.includes(DEVICE_REGISTRATION)) {
        config.headers = { ...config.headers, ...domainHeaders.DEVICE_REGISTRATION }
    } else if(config.url.includes(REPORTING_SERVICE_DOMAIN_PATH)) {
        config.headers = { ...config.headers, ...domainHeaders.REPORTING_SERVICE_DOMAIN_PATH }
    }
    else {
        config.headers = { config }
    }
}
axios.interceptors.request.use(
    (config) => {
        if(config.url.includes("token.oauth2")){
            config.headers["Content-Type"] = "application/x-www-form-urlencoded"
            config.headers["Authorization"] = "Basic" + " " + btoa("After sales 365:NOZfSk64uHIZOlrtgw6If4TsMGCJ7jeyqTGHWySX31qKIrkH4t11ej7FuBMnavb7")
            return config
        }
        if(sessionStorage.getItem("id_token") !="") {
            config.headers["tenantid"] = 1
            config.headers["locale"] = "en-US"
            config.headers["env"] = process.env.REACT_APP_ENVIROMENT
            config.headers["Authorization"] = "Bearer " + sessionStorage.getItem("id_token")
            if(config.url.includes("user-context")) {
                config.headers["Ocp-Apim-subscription-key"] = process.env.REACT_APP_USER_CONTEXT_KEY
                return config
            }
            let userDetailsData = JSON.parse(sessionStorage.getItem("userDetails"))
            let userInfo = {
                ...userDetailsData?.user_details,
                salesOrgs: ""
            }
            config.headers["userDetails"] = JSON.stringify(userInfo)
            
            if(sessionStorage.getItem("userDetails") !="") {
                setHeaders(config)
            }
        }
        // Add other domain-specific conditions here
        return config
    },
    (error) => {
        return Promise.reject(error)
    }
)

// Without authToken for Login and External Registraton
export const commonHeadersWithoutAuth = {
    headers: {
        tenantid: 1
    }
}

export const handleAPIRequests = async ({ queryKey }) => {
    let result = null
    const [method, baseUrl, url, data] = queryKey
    const setUrl =
        baseUrl === "base"
            ? `${DOAMIN_PATH}${url}`
            : baseUrl === "user"
                ? `${USER_MANAGEMENT_DOMAIN_PATH}${url}`
                : baseUrl === "service"
                    ? `${SERVICE_CENTER_DOMAIN_PATH}${url}`
                    : baseUrl === "lms"
                        ? `${LMS_DOMAIN_PATH}${url}`
                        : null
    if (method === "GET") {
        result = await axios.get(setUrl, commonHeaders)
    } else if (method === "POST") {
        result = await axios.post(setUrl, data, commonHeaders)
    } else if (method === "PATCH") {
        result = await axios.patch(setUrl, data, commonHeaders)
    }
    return result.data
}

export const generateCommonHeaders = () => {
    const selectedLanguage = localStorage.getItem("selectedLanguage")
    const currentHeaders = structuredClone(commonHeaders)
    if (selectedLanguage && selectedLanguage !== "en") {
        currentHeaders.headers.locale = `${selectedLanguage}`
    }
    return currentHeaders
}

export const commonHeadersService = {
    headers: {
        tenantid: 1,
        locale: "en-US",
        Authorization: "Bearer " + accessToken,
        userDetails: JSON.stringify(userDetailsData)
    }
}

export const getLanguageList = async () => {
    let result = await axios.get(`${DOAMIN_PATH}language`, commonHeaders)
    return result.data
}

export const getPsIndicatorList = async ({ queryKey }) => {
    const [, language_id] = queryKey
    let result = await axios.get(
        `${DOAMIN_PATH}ps-indicator?language_id=${language_id}`,
        commonHeaders
    )
    return result.data
}
export const getPsIndicatorListOnEdit = async ({ queryKey }) => {
    const [, code] = queryKey
    let result = await axios.get(
        `${DOAMIN_PATH}ps-indicator/${code}`,
        commonHeaders
    )
    return result.data
}

export const getFailureCodeListOnEdit = async ({ queryKey }) => {
    const [, code] = queryKey
    let result = await axios.get(
        `${DOAMIN_PATH}failure-code/${code}`,
        commonHeaders
    )
    return result.data
}

export const getExchangeRateOnEdit = async ({ queryKey }) => {
    const [, code] = queryKey
    let result = await axios.get(
        `${DOAMIN_PATH}exchange-rate/${code}`,
        commonHeaders
    )
    return result.data
}

export const getFailureCodeList = async ({ queryKey }) => {
    const [, language_id, customsearchtext, filter] = queryKey
    let selectedFilter = ""
    Object.keys(filter).forEach((key) => {
        if (filter[key].length > 0) {
            const commaSeparatedFilterValues = filter[key].join(",")

            let filterKey = ""
            switch (key) {
            case "failurecodeId":
                filterKey = "failurecodeId"
                break
            case "status":
                filterKey = "status"
                break
            }
            if (selectedFilter === "")
                selectedFilter += `${filterKey}=${commaSeparatedFilterValues}`
            else
                selectedFilter += `&${filterKey}=${commaSeparatedFilterValues}`
        }
    })
    let result = await axios.get(
        `${DOAMIN_PATH}failure-code?language_id=${language_id}&search=${customsearchtext}&${selectedFilter}`,
        commonHeaders
    )
    return result.data
}

export const getGgIndicator = async ({ queryKey }) => {
    const [, language_id] = queryKey
    let result = await axios.get(
        `${DOAMIN_PATH}gg-indicator?language_id=${language_id}`,
        commonHeaders
    )
    return result.data
}

export const getGgIndicatorList = async ({ queryKey }) => {
    const [, page, limit, language_id, customsearchtext] = queryKey
    let result = await axios.get(
        `${DOAMIN_PATH}gg-indicator?page=${page}&limit=${limit}&language_id=${language_id}&code=${customsearchtext}`,
        commonHeaders
    )
    return result.data
}

export const updatePsIndicatorList = async (id, updatedData) => {
    const response = await axios.patch(
        `${DOAMIN_PATH}ps-indicator/${id}`,
        updatedData,
        commonHeaders
    )
    return response.data
}

export const updateFailureCodeList = async (id, updatedData) => {
    const response = await axios.patch(
        `${DOAMIN_PATH}failure-code/${id}`,
        updatedData,
        commonHeaders
    )
    return response.data
}

export const updateGgIndicatorList = async (id, updatedData) => {
    const response = await axios.patch(
        `${DOAMIN_PATH}gg-indicator/${id}`,
        updatedData,
        commonHeaders
    )
    return response.data
}

export const addPsIndicatorList = async (newData) => {
    return await axios.post(`${DOAMIN_PATH}ps-indicator`, newData, commonHeaders)
}
  
export const addFailureCodeList = async (newData) => {
    return await axios.post(`${DOAMIN_PATH}failure-code`, newData, commonHeaders)
}

export const addGgIndicatorList = async (newData) => {
    return await axios.post(`${DOAMIN_PATH}gg-indicator`, newData, commonHeaders)
}

// sales org inside ps indicator
export const getSalesOrgList = async () => {
    let result = await axios.get(`${DOAMIN_PATH}common/salesOrgs?sales_org_required=false`, commonHeaders)
    return result.data
}

export const getHubDetails = async ({ queryKey }) => {
    const [, filter] = queryKey
    let selectedFilter = ""

    Object.keys(filter).forEach((key) => {
        if (filter[key].length > 0) {
            const commaSeparatedFilterValues = filter[key].join(",")

            if (key === "hubId") {
                const filterKey = "hubId"
                selectedFilter += selectedFilter === ""
                    ? `${filterKey}=${commaSeparatedFilterValues}`
                    : `&${filterKey}=${commaSeparatedFilterValues}`
            }
        }
    })

    if (filter?.approved) {
        selectedFilter += "&approved=true"
    }
    if (filter?.pending) {
        selectedFilter += "&pending=true"
    }
    if (filter?.rejected) {
        selectedFilter += "&rejected=true"
    }

    const url = `${DOAMIN_PATH}hub/all?${selectedFilter}`
    const result = await axios.get(url, commonHeaders)
    return result.data
}

export const createHubContinent = async (body) => {
    return await axios.post(
        `${DOAMIN_PATH}hub/create/hub_contient`,
        body,
        commonHeaders
    )
}

export const getCountries = async () => {
    let result = await axios.get(`${DOAMIN_PATH}country`, commonHeaders)
    return result.data
}

export const getCountryFromSalesOrg = async ({ queryKey }) => {
    const [, salesOrg] = queryKey
    let result = await axios.post(
        `${DOAMIN_PATH}common/countryBasedOnSalesOrg`,
        salesOrg,
        commonHeaders
    )
    return result.data
}

export const getCurrencies = async () => {
    let result = await axios.get(`${DOAMIN_PATH}currency`, commonHeaders)
    return result.data
}

export const getSapBoxIds = async () => {
    let result = await axios.get(`${PRICING_DOMAIN_PATH}tmc-mapping/sap-box-ids`, commonHeaders)
    return result.data
}

export const getPriceListNames = async ({ queryKey }) => {
    try {
        const [, country_id] = queryKey
        const contryIdValues = country_id ?
            Array.isArray(country_id) ? country_id?.map(obj => obj?.value).join(",") : country_id?.value
            : ""
        const qry = contryIdValues ? `?country_id=${contryIdValues}` : ""

        let result = await axios.get(`${PRICING_DOMAIN_PATH}price-list/names${qry}`, commonHeaders)
        return result.data
    } catch (error) {
        return error
    }
}

export const getPriceListBySalesOrg = async ({ queryKey }) => {
    try {
        const [, org_id] = queryKey
        let qry =""
        if(org_id !=""){
            if(org_id.length>1){
                const orgIdValues = org_id?.map((item)=>{
                    return item
                }).join(",")
                qry = orgIdValues ? `?org_id=${orgIdValues}` : ""
            } else {
                qry =`?org_id=${org_id[0]}`
            }
        }
        let result = ""
        if(qry ) {
            result = await axios.get(`${PRICING_DOMAIN_PATH}price-list/org${qry}`, commonHeaders)
        } else {
            result = await axios.get(`${PRICING_DOMAIN_PATH}price-list/names${qry}`, commonHeaders)
        }
        
        return result.data
    } catch (error) {
        return error
    }
}

export const getPriceListHistory = async ({ queryKey }) => {
    const [, id] = queryKey
    try {
        let result = await axios.get(`${PRICING_DOMAIN_PATH}price-derivation/history/${id}`, commonHeaders)
        return result.data
    }
    catch (error) {
        return error
    }
}

export const addLumsumPrice = async (newData) => {
    return await axios.post(`${PRICING_DOMAIN_PATH}price-derivation/lumpsum`, newData, commonHeaders)
}

export const getPriceListAllData = async ({ queryKey }) => {
    const [, country_id] = queryKey
    const contryIdValues = country_id ?
        Array.isArray(country_id) ? country_id?.map(obj => obj?.value).join(",") : country_id?.value
        : ""
    const qry = contryIdValues ? `?country_id=${contryIdValues}` : ""

    try {
        let result = await axios.get(`${PRICING_DOMAIN_PATH}price-list${qry}`, commonHeaders)
        return result.data
    }
    catch (error) {
        return error
    }
}
export const getPriceTableIds = async () => {
    try {
        let result = await axios.get(`${PRICING_DOMAIN_PATH}list-price-upload/price_table_id`, commonHeaders)
        return result.data
    } catch (error) {
        return error
    }
}

export const getPriceLevelIdentifiers = async () => {
    try {
        let result = await axios.get(`${PRICING_DOMAIN_PATH}list-price-upload/identifiers`, commonHeaders)
        return result.data
    } catch (error) {
        return error
    }
}

export const getEanNumbers = async () => {
    try {
        let result = await axios.get(`${PRICING_DOMAIN_PATH}list-price-upload/ean`, commonHeaders)
        return result.data
    } catch (error) {
        return error
    }
}

export const getPartNumbers = async ({ queryKey }) => {
    const [_, filterByLang] = queryKey
    try {
        let result = await axios.get(`${PRODUCT_AND_PARTS}part_number?language_id=${filterByLang}`, commonHeaders)
        return result.data
    } catch (error) {
        return error
    }
}
// Get ProductionCode
export const getProductionCode = async () => {
    try {
        let result = await axios.get(`${PRODUCT_AND_PARTS}productionCode`, commonHeaders)
        return result.data
    } catch (error) {
        return error
    }
}

export const getAllPartNumbers = async () => {
    try {
        let result = await axios.get(`${PRODUCT_AND_PARTS}part-association-type?page=1&limit=10&filterByTypeNumber=8&language_id=12`, commonHeaders)
        return result.data
    } catch (error) {
        return error
    }
}

export const getPartNumber = async ({ queryKey }) => {
    const [_, part] = queryKey
    try {
        let result = await axios.get(`${PRODUCT_AND_PARTS}search-part-number?part=${part}`, commonHeaders)
        return result.data
    } catch (error) {
        return error
    }
}

export const getArticleNumber = async ({ queryKey }) => {
    const [_, articleNo] = queryKey
    try {
        let result = await axios.get(`${PRODUCT_AND_PARTS}part-number/searchArticles/${articleNo}`, commonHeaders)
        return result.data
    } catch (error) {
        return error
    }
}

export const getPriceList = async ({ queryKey }) => {
    const [_, page, limit, customsearchtext, filter, orderBy,orderByField] = queryKey
    // get partial page data or full page data
    let url = checkFields(page, `${PRICING_DOMAIN_PATH}price-list?page=${page}&limit=${limit}&search=${customsearchtext}`, `${PRICING_DOMAIN_PATH}price-list`)
    url = appendQueryParam(url, "orderby", orderBy)
    url = appendQueryParam(url, "orderbyField", orderByField)
    url = appendQueryParam(url, "price_list_id", filter?.price_list_id?.join(","))
    url = appendQueryParam(url, "country_id", filter?.country_id?.join(","))
    url = appendQueryParam(url, "currency_id", filter?.currency_id?.join(","))
    url = appendQueryParam(url, "sales_org_id", filter?.sales_org_id?.join(","))
    let result = await axios.get(
        `${url}`,
        commonHeaders
    )
    return result.data
}

export const getAllPriceList = async () => {
    try {
        let result = await axios.get(`${PRICING_DOMAIN_PATH}price-list/names`, commonHeaders)
        return result.data
    } catch (error) {
        return error
    }
}

export const downloadPriceList = async (customsearchtext, filter, orderBy,orderByField) => {
    // get partial page data or full page data
    let url = `${PRICING_DOMAIN_PATH}price-list?`
    url = appendQueryParam(url, "search", customsearchtext)
    url = appendQueryParam(url, "orderby", orderBy)
    url = appendQueryParam(url, "orderbyField", orderByField)
    url = appendQueryParam(url, "price_list_id", filter?.price_list_id?.join(","))
    url = appendQueryParam(url, "country_id", filter?.country_id?.join(","))
    url = appendQueryParam(url, "currency_id", filter?.currency_id?.join(","))
    url = appendQueryParam(url, "sales_org_id", filter?.sales_org_id?.join(","))
    let result = await axios.get(
        url,
        commonHeaders
    )

    return result.data
}

export const downloadListPrice = async (customsearchtext, filter) => {
    // get partial page data or full page data
    let url = `${PRICING_DOMAIN_PATH}list-price-upload?`
    url = appendQueryParam(url, "search", customsearchtext)
    url = appendQueryParam(url, "currency", filter?.currencyList?.join(","))
    url = appendQueryParam(url, "sales_org", filter?.salesOrgList?.join(","))
    url = appendQueryParam(url, "part_no", filter?.partNumberList?.join(","))
    url = appendQueryParam(url, "price_level_identifier", filter?.priceTableIdList?.join(","))
    url = appendQueryParam(url, "price_table_id", filter?.priceLevelIdentifierList?.join(","))
    url = appendQueryParam(url, "ean", filter?.eanNumberList?.join(","))
    url = appendQueryParam(url, "validity_from", filter?.validityFrom ? format(filter?.validityFrom, "yyyy-MM-dd") : "")
    url = appendQueryParam(url, "validity_to", filter?.validityTo ? format(filter?.validityTo, "yyyy-MM-dd") : "")
    url = appendQueryParam(url, "is_deleted", filter?.is_deleted ? filter?.is_deleted : "")
    let result = await axios.get(
        url,
        commonHeaders
    )

    return result.data
}

export const getAllAllListPrice = async ({ queryKey }) => {
    const [, page, limit, order = "ASC", customsearchtext, filter] = queryKey
    let selectedFilter = ""

    Object.keys(filter).forEach((key) => {
        if (filter[key].length > 0 || filter[key] != "") {
            let commaSeparatedFilterValues = ""
            let filterKey = ""
            switch (key) {
            case "currencyList":
                filterKey = "currency"
                commaSeparatedFilterValues = filter[key].map((val) => `${val.trim()}`).join(",")
                break
            case "salesOrgList":
                filterKey = "sales_org"
                commaSeparatedFilterValues = filter[key].map((val) => `${val.trim()}`).join(",")
                break
            case "partNumberList":
                filterKey = "part_no"
                commaSeparatedFilterValues = filter[key].join(",")
                break
            case "priceLevelIdentifierList":
                filterKey = "price_level_identifier"
                commaSeparatedFilterValues = filter[key].join(",")
                break
            case "priceTableIdList":
                filterKey = "price_table_id"
                commaSeparatedFilterValues = filter[key].join(",")
                break
            case "eanNumberList":
                filterKey = "ean"
                commaSeparatedFilterValues = filter[key].join(",")
                break
            case "validityFrom":
                filterKey = "validity_from"
                commaSeparatedFilterValues = format(filter[key], "yyyy-MM-dd")
                break
            case "validityTo":
                filterKey = "validity_to"
                commaSeparatedFilterValues = format(filter[key], "yyyy-MM-dd")
                break
            case "is_deleted":
                filterKey = "is_deleted"
                commaSeparatedFilterValues = filter[key] ? filter[key] : ""
                break
            }
        
            if (selectedFilter === "")
                selectedFilter += `${filterKey}=${commaSeparatedFilterValues}`
            else
                selectedFilter += `&${filterKey}=${commaSeparatedFilterValues}`
        }
    })
    

    let result = await axios.get(
        `${PRICING_DOMAIN_PATH}list-price-upload?page=${page}&limit=${limit}&orderby=${order}&search=${customsearchtext}&${selectedFilter}`,
        commonHeaders
    )
    return result.data
}

export const getAllListPriceNos = async ({ queryKey }) => {
    const [, page, limit, order = "ASC", customsearchtext, filter] = queryKey
    let selectedFilter = ""

    Object.keys(filter).forEach((key) => {
        if (filter[key].length > 0 || filter[key] != "") {
            let commaSeparatedFilterValues = ""

            let filterKey = ""
            switch (key) {
            case "currencyList":
                filterKey = "currency"
                commaSeparatedFilterValues = filter[key].map((val) => `${val.trim()}`).join(",")
                break
            case "salesOrgList":
                filterKey = "sales_org"
                commaSeparatedFilterValues = filter[key].map((val) => `${val.trim()}`).join(",")
                break
            case "partNumberList":
                filterKey = "part_no"
                commaSeparatedFilterValues = filter[key].join(",")
                break
            case "priceLevelIdentifierList":
                filterKey = "price_level_identifier"
                commaSeparatedFilterValues = filter[key].join(",")
                break
            case "priceTableIdList":
                filterKey = "price_table_id"
                commaSeparatedFilterValues = filter[key].join(",")
                break
            case "eanNumberList":
                filterKey = "ean"
                commaSeparatedFilterValues = filter[key].join(",")
                break
            case "validityFrom":
                filterKey = "validity_from"
                commaSeparatedFilterValues = format(filter[key], "yyyy-MM-dd")
                break
            case "validityTo":
                filterKey = "validity_to"
                commaSeparatedFilterValues = format(filter[key], "yyyy-MM-dd")
                break
            }

            if (selectedFilter === "")
                selectedFilter += `${filterKey}=${commaSeparatedFilterValues}`
            else
                selectedFilter += `&${filterKey}=${commaSeparatedFilterValues}`
        }
    })

    let result = await axios.get(
        `${PRICING_DOMAIN_PATH}nos-list-price?page=${page}&limit=${limit}&orderby=${order}&search=${customsearchtext}&${selectedFilter}`,
        commonHeaders
    )
    return result.data
}

export const updatePriceList = async (data) => {
    let { id } = data
    delete data.id
    let result = await axios.patch(
        `${PRICING_DOMAIN_PATH}price-list/${id}`,
        data,
        commonHeaders
    )
    return result.data
}

export const addPriceList = async (data) => {
    let result = await axios.post(
        `${PRICING_DOMAIN_PATH}price-list`,
        data,
        commonHeaders
    )
    return result.data
}


export const UpdatePriceDerivation = async (data) => {
    let result = await axios.patch(
        `${PRICING_DOMAIN_PATH}price-derivation/${data.pid}`,
        data,
        commonHeaders
    )
    return result.data
}

export const UpdateOriginalNOS = async (data) => {
    let result = await axios.patch(
        `${PRICING_DOMAIN_PATH}nos-price-derivation/${data.pid}`,
        data,
        commonHeaders
    )
    return result.data
}

export const UpdateOriginalNOSCurrency = async (data) => {
    let result = await axios.post(
        `${PRICING_DOMAIN_PATH}nos-price-derivation/convert-to-eur`,
        data,
        commonHeaders
    )
    return result.data
}

export const updateHubContinent = async (id, body) => {
    let result = await axios.patch(
        `${DOAMIN_PATH}hub/update/hub?id=${id}`,
        body,
        commonHeaders
    )
    return result.data
}

export const getHubRegDetails = async ({ queryKey }) => {
    const [, filter] = queryKey
    let selectedFilter = ""
    Object.keys(filter).forEach((key) => {
        if (filter[key].length > 0) {
            const commaSeparatedFilterValues = filter[key].join(",")

            let filterKey = ""
            switch (key) {
            case "regionalContinentId":
                filterKey = "regionalContinentId"
                break
            }
            if (selectedFilter === "")
                selectedFilter += `${filterKey}=${commaSeparatedFilterValues}`
            else
                selectedFilter += `&${filterKey}=${commaSeparatedFilterValues}`
        }
    })
    if(filter?.approved){
        selectedFilter += "&approved=true"
    }
    if(filter?.pending){
        selectedFilter += "&pending=true"
    }
    if(filter?.rejected){
        selectedFilter += "&rejected=true"
    }
    let url = `${DOAMIN_PATH}hub/regional_continent/all?${selectedFilter}`
    let result = await axios.get(url, commonHeaders)
    return result.data
}

export const createHubRegContinent = async (body) => {
    let result = await axios.post(
        `${DOAMIN_PATH}hub/create/regional_contient`,
        body,
        commonHeaders
    )
    return result.data
}

export const updateHubRegContinent = async (id, body) => {
    let result = await axios.patch(
        `${DOAMIN_PATH}hub/update/regional_continent?id=${id}`,
        body,
        commonHeaders
    )
    return result.data
}

export const getHubSubDetails = async ({ queryKey }) => {
    const [, filter] = queryKey
    let selectedFilter = ""
    Object.keys(filter).forEach((key) => {
        if (filter[key].length > 0) {
            const commaSeparatedFilterValues = filter[key].join(",")

            let filterKey = ""
            switch (key) {
            case "hubSubContinentId":
                filterKey = "hubSubContinentId"
                break
            }
            if (selectedFilter === "")
                selectedFilter += `${filterKey}=${commaSeparatedFilterValues}`
            else
                selectedFilter += `&${filterKey}=${commaSeparatedFilterValues}`
        }
    })
    if(filter?.approved){
        selectedFilter += "&approved=true"
    }
    if(filter?.pending){
        selectedFilter += "&pending=true"
    }
    if(filter?.rejected){
        selectedFilter += "&rejected=true"
    }
    let url = `${DOAMIN_PATH}hub/sub_continent/all?${selectedFilter}`
    let result = await axios.get(url, commonHeaders)
    return result.data
}

export const createHubSubContinent = async (body) => {
    let result = await axios.post(
        `${DOAMIN_PATH}hub/create/sub_contient`,
        body,
        commonHeaders
    )
    return result.data
}

export const updateHubSubContinent = async (id, body) => {
    let result = await axios.patch(
        `${DOAMIN_PATH}hub/update/sub_continent?id=${id}`,
        body,
        commonHeaders
    )
    return result.data
}

export const getShipToDetails = async ({ queryKey }) => {
    const [, id] = queryKey
    let result = await axios.get(
        `${ORDER_MANAGEMENT}orders/get-service-center-detail/${id}`,
        commonHeaders
    )
    return result.data
}

export const getAllOrderCartView = async ({ queryKey }) => {
    const [, functionDetailsLoggedInUser,scNameList, orderId] = queryKey
    let url = `${ORDER_MANAGEMENT}orders?`
    if (functionDetailsLoggedInUser !==undefined) {
        url += `${(url[url.length - 1] === "?" ? "" : "&") + "service_center_function=" + functionDetailsLoggedInUser}`
    }
    if (scNameList > 0) {
        url += `${(url[url.length - 1] === "?" ? "" : "&") + "serviceCenterid=" + scNameList}`
    }
    if (orderId) {
        url += `${(url[url.length - 1] === "?" ? "" : "&") + "order_id=" + orderId}`
    }
    const result = await axios.get(url, commonHeaders)
    return await result.data
}

export const getOrderUploadReview = async () => {
    let url = `${ORDER_MANAGEMENT}orders/order-upload-review`
    const result = await axios.get(url, commonHeaders)
    return await result.data
}

export const getEANBasedOnPart = async ({ queryKey }) => {
    const [, partNo] = queryKey
    if (partNo) {
        let result = await axios.get(
            `${ORDER_MANAGEMENT}orders/part-ean/${partNo}`,
            commonHeaders
        )
        return result.data
    } else {
        return []
    }
}

export const getEANByPartNo = async ({ queryKey }) => {
    const [, partNo] = queryKey
    if (partNo) {
        let result = await axios.get(
            `${PRODUCT_AND_PARTS}part-number/eanByPart?part_ids=${partNo}`,
            commonHeaders
        )
        return result.data
    } else {
        return []
    }
}

export const getEANByPartNoList = async ({ queryKey }) => {
    const [, partNoList] = queryKey
    if (partNoList?.length>0) {
        let result = await axios.get(
            `${ORDER_MANAGEMENT}orders/getMultiPartEanAssociations?partNumber=${partNoList}`,
            commonHeaders
        )
        return result.data
    } else {
        return []
    }
}

export const validateBasket = async (fileData) => {
    let checkInterUser = fileData[0]?.serviceCenterID
    let emailCheck = fileData[0]?.function?.currentServiceCenter
    let functionCheck = fileData[0]?.function?.currentServiceCenter || fileData[0]?.function?.currentServiceCenter == "" ? "" : "email"
    if(emailCheck === false || emailCheck === "email"){
        functionCheck = "email"
    }
    let response = ""
    if(checkInterUser === undefined){
        response = await axios.post(
            `${ORDER_MANAGEMENT}orders/validate-bucket-part`,
            fileData,
            commonHeaders
        )
    }
    else{
        response = await axios.post(
            `${ORDER_MANAGEMENT}orders/validate-bucket-part?serviceCenterid=${fileData[0]?.serviceCenterID}&function=${functionCheck}`,
            fileData[0]?.payloadData,
            commonHeaders
        )
    }
   
    return response.data
}

export const getPartNoByEAN = async ({ queryKey }) => {
    const [, ean] = queryKey
    if (ean) {
        let result = await axios.get(
            `${ORDER_MANAGEMENT}orders/lookup?ean=${ean}`,
            commonHeaders
        )
        return result.data
    } else {
        return []
    }
}

export const getPartNoByEANList = async ({ queryKey }) => {
    const [, ean] = queryKey
    if (ean?.length>0) {
        let result = await axios.get(
            `${ORDER_MANAGEMENT}orders/getMultiPartEanAssociations?ean=${ean}`,
            commonHeaders
        )
        return result.data
    } else {
        return []
    }
}

export const getOrderUploadEnable = async () => {
    let result = await axios.get(
        `${ORDER_MANAGEMENT}orders/check-order-upload-process`,
        commonHeaders
    )
    return result.data
}

export const checkMaxOrderQuantity = async (partId, serviceCenterId, qty, isCatalogue = false) => {
    const catalogueParam = isCatalogue ? "?catalogue=true" : "";
    let result = await axios.get(
        `${ORDER_MANAGEMENT}orders/check-max-order/${partId}/${serviceCenterId}/${qty}${catalogueParam}`,
        commonHeaders
    )
    return result.data
}

export const checkMinOrderQuantity = async (serviceCenterId) => {
    let result = await axios.get(
        `${ORDER_MANAGEMENT}orders/check-min-order-quantity/${serviceCenterId}`,
        commonHeaders
    )
    return result.data
}

export const createOrderParts = async (body) => {
    let checkInterUser = body[0]?.serviceCenterID
    let functionCheck = body[0]?.function?.currentServiceCenter == "order" || body[0]?.function?.currentServiceCenter ? "" : "email"
    let result = ""
    if(checkInterUser === undefined){
        let internalfunctionCheck = body[0]?.function?.currentServiceCenter == "order" || body[0]?.function?.currentServiceCenter ? "" : "email"
        result = await axios.post(
            `${ORDER_MANAGEMENT}orders/add?function=${internalfunctionCheck}`,
            body[0]?.payloadData,
            commonHeaders
        )
    }
    else{
        result = await axios.post(
            `${ORDER_MANAGEMENT}orders/add?serviceCenterid=${body[0]?.serviceCenterID}&function=${functionCheck}`,
            body[0]?.payloadData,
            commonHeaders
        )
    }
    
    return result.data
}

export const updateOrderParts = async (id, body) => {
    let functionchkOrder = body[0]?.function?.currentServiceCenter
    let orderFunChk
    if (userType == 1) {
        if (functionchkOrder == "warranty") {
            orderFunChk = "email"
        }
        else {
            orderFunChk = ""
        }
    }
    else{
        if (!functionchkOrder) {
            orderFunChk = "email"
        }
        else {
            orderFunChk = ""
        }
    }
    let result = await axios.patch(
        `${ORDER_MANAGEMENT}orders/update/${id}?function=${orderFunChk}`,
        body[0]?.payloadData,
        commonHeaders
    )
    return result.data
}

export async function deleteOrderCartViewById(id) {
    try {
        const result = await axios.delete(
            `${ORDER_MANAGEMENT}orders/${id}`,
            commonHeaders
        )
        return await result.data
    } catch (error) {
        return error
    }
}

export const deleteOrderUploadById = async (orderId) => {
    try {
        const result = await axios.delete(
            `${ORDER_MANAGEMENT}orders/delete-upload-order/${orderId}`,
            commonHeaders
        )
        return await result.data
    } catch (error) {
        return error
    }
}

export async function deleteAllOrderCartViews(payload) {
    try {
        let result = ""
        if(payload?.length === 0 ){
            result = await axios.delete(
                `${ORDER_MANAGEMENT}orders/basket/clear`,
                commonHeaders
            )
        }
        else{
            result = await axios.delete(
                `${ORDER_MANAGEMENT}orders/basket/clear?serviceCenterid=${payload[0]?.serviceCenterID}`,
                commonHeaders
            )
        }
       
        return await result.data
    } catch (error) {
        return error
    }
}

export const uploadCartViews = async (fileData) => {
    const headers = { ...commonHeaders }
    headers["Content-Type"] = "multipart/form-data"
    let checkInterUser = fileData[0]?.serviceCenterID
    let functionChk = loggedInUserDetails?.service_center_details.filter((item => { return item?.function.includes("order") }))
    let uploadFlag = functionChk.length > 0 ? "" : "email"
    let flagchk = fileData[0]?.function?.currentServiceCenter ? "" : "email"
    let response = ""
    if(checkInterUser === undefined){
        response = await axios.post(
            `${ORDER_MANAGEMENT}orders/bucket-upload?function=${uploadFlag}`,
            fileData,
            headers
        )
    }
    else{
        response = await axios.post(
            `${ORDER_MANAGEMENT}orders/bucket-upload?serviceCenterid=${fileData[0]?.serviceCenterID}&function=${flagchk}`,
            fileData[0]?.payloadData,
            headers
        )
    }
   
    return response.data
}

export const sendOrder = async (body) => {
    let chkInterUser = localStorage.getItem("serviceCenterID")
    let result = ""
    if(chkInterUser == 0){
        result = await axios.post(
            `${ORDER_MANAGEMENT}orders/create-order`,
            body,
            commonHeaders
        )
    }
    else{
        result = await axios.post(
            `${ORDER_MANAGEMENT}orders/create-order?serviceCenterid=${chkInterUser}`,
            body,
            commonHeaders
        )
    }
   
    return result.data
}

export const sendOrderUpload = async (body) => {
    let result = await axios.post(
        `${ORDER_MANAGEMENT}orders/create-order?orderId=${body[0]?.orderId}`,
        body[0]?.payload,
        commonHeaders
    )
    return result.data
}

export const getSalesOrgDetails = async ({ queryKey }) => {
    const [, filterValue] = queryKey
    let filter = { ...filterValue }
    let selectedFilter = ""
    delete filter.salesOrgId
    Object.keys(filter).forEach((key) => {
        if (filter[key].length > 0) {
            const commaSeparatedFilterValues = filter[key].join(",")

            let filterKey = ""
            switch (key) {
            case "salesOrgLabel":
                filterKey = "filterBySalesOrg"
                break
            case "country":
                filterKey = "filterByCountry"
                break
            case "status":
                filterKey = "filterByStatus"
                break
            }

            if (selectedFilter === "")
                selectedFilter += `${filterKey}=${commaSeparatedFilterValues}`
            else
                selectedFilter += `&${filterKey}=${commaSeparatedFilterValues}`
        }
    })

    let url = `${DOAMIN_PATH}salesorganization/all?${selectedFilter}`
    let result = await axios.get(url, commonHeaders)
    return result.data
}

export const createSalesOrg = async (body) => {
    return await axios.post(
        `${DOAMIN_PATH}salesorganization/create`,
        body,
        commonHeaders
    )
}

export const updateSalesOrg = async (id, body) => {
    let result = await axios.patch(
        `${DOAMIN_PATH}salesorganization/update/${id}`,
        body,
        commonHeaders
    )
    return result.data
}

export const getSalesType = async () => {
    let result = await axios.get(
        `${DOAMIN_PATH}common/sales_type`,
        commonHeaders
    )
    return result.data
}

export const getExchangeRate = async ({ queryKey }) => {
    const [, page, limit, search, appliedFilter, orderBy,orderByField] = queryKey
    let url = `${DOAMIN_PATH}exchange-rate?page=${page}&limit=${limit}`
    if (search) {
        url += `&search=${search}`
    }
    if (appliedFilter?.startDate) {
        url += `&validity_from=${appliedFilter?.startDate}`
    }
    if (appliedFilter?.endDate) {
        url += `&validity_to=${appliedFilter?.endDate}`
    }
    if (appliedFilter?.salesOrg) {
        url += `&sales_org=${appliedFilter?.salesOrg}`
    }
    if (appliedFilter?.status) {
        url += `&status=${appliedFilter?.status}`
    }
    if (orderBy) {
        url += `${(url[url.length - 1] === "?" ? "" : "&") + "orderby=" + orderBy }`
    }
    if (orderByField) {
        url += `${(url[url.length - 1] === "?" ? "" : "&") + "orderbyField=" + orderByField }`
    }
    if (appliedFilter?.fromCurrency) {
        url += `&from_currency=${appliedFilter?.fromCurrency}`
    }
    if (appliedFilter?.toCurrency) {
        url += `&to_currency=${appliedFilter?.toCurrency}`
    }
    let result = await axios.get(
        url,
        commonHeaders
    )
    return result.data
}

export const getExceptionApprovers = async ({ queryKey }) => {
    const [, lang] = queryKey
    let result = await axios.get(
        `${DOAMIN_PATH}approver?language_id=${lang}`,
        commonHeaders
    )
    return result.data
}

export const createApprover = async (body) => {
    await axios.post(`${DOAMIN_PATH}approver`, body, commonHeaders)
}

export const updateApprover = async (id, body) => {
    await axios.patch(`${DOAMIN_PATH}approver/${id}`, body, commonHeaders)
}

// Country Hub Association
export async function getCountryHub({ queryKey }) {
    const [, { filter }, page, limit, column, order, search ] = queryKey
    let url = new URL(`${DOAMIN_PATH}hub-country/all`)

    // Add query parameters
    const params = new URLSearchParams()

    if (page) params.append("page", page)
    if (limit) params.append("limit", limit)
    if (column) params.append("orderbyField", column)
    if (order) params.append("orderby", order)
    if (search) params.append("search", search)

    // Add filter parameters
    const addFilterParams = (key, values) => {
        if (values.length > 0) {
            params.append(key, values.join(","))
        }
    }

    Object.keys(filter).forEach((key) => {
        switch (key) {
        case "hubCountryId":
        case "subContinentId":
            addFilterParams(key, filter[key])
            break
        }
    })

    if (filter.approved) params.append("approved", "true")
    if (filter.pending) params.append("pending", "true")
    if (filter.rejected) params.append("rejected", "true")

    url.search = params
    try {
        const result1 = await axios.get(
            `${DOAMIN_PATH}hub-country/all?${params ? params.toString() : ""}`,
            commonHeaders
        )
        return await result1.data
    } catch (error) {
        return error
    }
   
}


export async function getCountryHubALl() {
    try {
        const result1 = await axios.get(
            `${DOAMIN_PATH}hub-country/getAllHubInfo`,
            commonHeaders
        )
        return await result1.data
    } catch (error) {
        return error
    }
}

export async function createCountryHub(data) {
    const result1 = await axios.post(
        `${DOAMIN_PATH}hub-country/create`,
        data,
        commonHeaders
    )
    return await result1.data
}

export async function updateCountryHub(id, data) {
    try {
        const result1 = await axios.patch(
            `${DOAMIN_PATH}hub-country/update?id=${id}`,
            data,
            commonHeaders
        )
        return await result1.data
    } catch (error) {
        return error
    }
}

export async function deletCountryHubRecord(id) {
    try {
        const result1 = await axios.delete(
            `${DOAMIN_PATH}hub-country/delete?Id=${id}`,
            commonHeaders
        )
        return await result1.data
    } catch (error) {
        return error
    }
}

export const downloadCountryHubRecord = async () => {
    let result = await axios.get(`${DOAMIN_PATH}hub-country/all`, commonHeaders)
    return result
}

// Failure Codes Mapping

export async function getFailureCodeMapping({ queryKey }) {
    const [, filter] = queryKey
    let selectedFilter = ""
    Object.keys(filter).forEach((key) => {
        if (filter[key].length > 0 || filter[key] != "") {
            let commaSeparatedFilterValues = ""

            let filterKey = ""
            switch (key) {
            case "typeNo":
                filterKey = "typeNo"
                commaSeparatedFilterValues = filter[key].join(",")
                break
            case "failureCode":
                filterKey = "failureCode"
                commaSeparatedFilterValues = filter[key].join(",")
                break
            case "ggIndicator":
                filterKey = "ggIndicator"
                commaSeparatedFilterValues = filter[key].join(",")
                break
            case "failureCodeType":
                filterKey = "failureCodeType"
                commaSeparatedFilterValues = filter[key].join(",")
                break
            case "validityTo":
                filterKey = "validityTo"
                commaSeparatedFilterValues = format(filter[key], "yyyy-MM-dd")
                break
            case "validityFrom":
                filterKey = "validityFrom"
                commaSeparatedFilterValues = format(filter[key], "yyyy-MM-dd")
                break
            }

            if (selectedFilter === "")
                selectedFilter += `${filterKey}=${commaSeparatedFilterValues}`
            else
                selectedFilter += `&${filterKey}=${commaSeparatedFilterValues}`
        }
    })
   
    let url = `${DOAMIN_PATH}reason-code-device?${selectedFilter}`

    const result1 = await axios.get(url, commonHeaders)
    return await result1.data
}

export const getSalesOrgs = async ({ queryKey }) => {
    const [_, isSalesOrgRequired] = queryKey
    const URL = isSalesOrgRequired ? "common/salesOrgs?sales_org_required=true" : "common/salesOrgs?sales_org_required=false"
    let result = await axios.get(`${DOAMIN_PATH}${URL}`, commonHeaders)
    return result.data
}

export const getExceptionCodeList = async ({ queryKey }) => {
    const [, lang] = queryKey
    let result = await axios.get(
        `${DOAMIN_PATH}exception-code?language_id=${lang}`,
        commonHeaders
    )
    return result.data
}

export const updateExceptionCodeList = async (id, updatedData) => {
    const response = await axios.patch(
        `${DOAMIN_PATH}exception-code/${id}`,
        updatedData,
        commonHeaders
    )
    return response.data
}

export const addToExceptionCodeList = async (newData) => {
    return await axios.post(
        `${DOAMIN_PATH}exception-code`,
        newData,
        commonHeaders
    )
}

export const getProductFromList = async ({ queryKey }) => {
    const [, lang] = queryKey
    let result = await axios.get(
        `${DOAMIN_PATH}product-from-code?language_id=${lang}`,
        commonHeaders
    )
    return result.data
}

export const updateProductFromList = async (id, updatedData) => {
    const response = await axios.patch(
        `${DOAMIN_PATH}product-from-code/${id}`,
        updatedData,
        commonHeaders
    )
    return response.data
}

export const addToProductFromList = async (newData) => {
    return await axios.post(
        `${DOAMIN_PATH}product-from-code`,
        newData,
        commonHeaders
    )
}

export const getActionCodeList = async ({ queryKey }) => {
    const [, lang, customsearchtext] = queryKey
    let url = `${DOAMIN_PATH}action-code?`
    if (lang) {
        url += `${(url[url.length - 1] === "?" ? "" : "&") + "language_id=" + lang
        }`
    }
    if (customsearchtext) {
        url += `${(url[url.length - 1] === "?" ? "" : "&") + "search=" + customsearchtext
        }`
    }
    let result = await axios.get(url, commonHeaders)
    return result.data
}

export const createExchangeRate = async (body) => {
    return await axios.post(`${DOAMIN_PATH}exchange-rate`, body, commonHeaders)
}

export const updateExchangeRate = async (id, body) => {
    return await axios.patch(`${DOAMIN_PATH}exchange-rate/${id}`, body, commonHeaders)
}

export const updateActionCodeList = async (id, updatedData) => {
    const response = await axios.patch(
        `${DOAMIN_PATH}action-code/${id}`,
        updatedData,
        commonHeaders
    )
    return response.data
}

export const addToActionCodeList = async (newData) => {
    return await axios.post(`${DOAMIN_PATH}action-code`, newData, commonHeaders)
}

export const getAllPriceMatrix = async ({ queryKey }) => {
    const [, page, limit, column, order = "ASC", customsearchtext, filter] = queryKey
    let selectedFilter = ""
    Object.keys(filter).forEach((key) => {
        if (filter[key].length > 0) {
            const commaSeparatedFilterValues = filter[key].join(",")

            let filterKey = ""
            switch (key) {
            case "priceList":
                filterKey = "price_list_id"
                break
            case "currency":
                filterKey = "currency_id"
                break
            case "brand":
                filterKey = "brand_id"
                break
            case "materialClass":
                filterKey = "material_class_id"
                break
            }

            if (selectedFilter === "")
                selectedFilter += `${filterKey}=${commaSeparatedFilterValues}`
            else
                selectedFilter += `&${filterKey}=${commaSeparatedFilterValues}`
        }
    })

    let result = await axios.get(
        `${PRICING_DOMAIN_PATH}price-matrix?page=${page}&limit=${limit}&orderbyField=${column}&orderby=${order}&search=${customsearchtext}&${selectedFilter}`,
        commonHeaders
    )
    return result.data
}

export const getAllPriceMatrixException = async ({ queryKey }) => {
    const [, page, limit, customsearchtext, filter, orderBy, orderByField] = queryKey

    let selectedFilter = ""
    Object.keys(filter).forEach((key) => {
        if (filter[key].length > 0) {
            const commaSeparatedFilterValues = filter[key].join(",")

            let filterKey = ""
            switch (key) {
            case "priceList":
                filterKey = "price_list_id"
                break
            case "countryList":
                filterKey = "country_id"
                break
            case "typeNumberList":
                filterKey = "type_number_id"
                break
            case "materialClassList":
                filterKey = "material_class_id"
                break
            case "fpcList":
                filterKey = "product_id"
                break
            }

            if (selectedFilter === "")
                selectedFilter += `${filterKey}=${commaSeparatedFilterValues}`
            else
                selectedFilter += `&${filterKey}=${commaSeparatedFilterValues}`
        }
    })
    
    let result = await axios.get(
        `${PRICING_DOMAIN_PATH}price-matrix-exception?page=${page}&limit=${limit}&search=${customsearchtext}&orderby=${orderBy}&orderbyField=${orderByField}&${selectedFilter}`,
        commonHeaders
    )
    return result.data
}
export const getMasterMappingTMC = async ({ queryKey }) => {
    const [, page, limit, customsearchtext, filter] = queryKey

    let selectedFilter = ""
    Object.keys(filter).forEach((key) => {
        if (filter[key].length > 0) {
            const commaSeparatedFilterValues = filter[key].join(",")

            let filterKey = ""
            switch (key) {
            case "sapboxId":
                filterKey = "sapboxId"
                break
            case "plantId":
                filterKey = "plantId"
                break
            case "countryId":
                filterKey = "filterByCountry"
                break
            case "salesorgId":
                filterKey = "filterBySalesOrg"
                break
            case "status":
                filterKey = "status"
                break
            case "materialClass":
                filterKey = "filterByMaterialClass"
                break
            case "currencyId":
                filterKey = "filterByCurrency"
                break
            }
            if (selectedFilter === "")
                selectedFilter += `${filterKey}=${commaSeparatedFilterValues}`
            else
                selectedFilter += `&${filterKey}=${commaSeparatedFilterValues}`
        }
    })
    let result = await axios.get(
        `${PRICING_DOMAIN_PATH}tmc-mapping?page=${page}&limit=${limit}&search=${customsearchtext}&${selectedFilter}`,
        commonHeaders
    )
    return result.data
}

export const exportMasterMappingTMC = async ({ queryKey }) => {
    const [, filter, customsearchtext] = queryKey
    let selectedFilter = ""
    Object.keys(filter).forEach((key) => {
        if (filter[key].length > 0) {
            const commaSeparatedFilterValues = filter[key].join(",")

            let filterKey = ""
            switch (key) {
            case "sapboxId":
                filterKey = "sapboxId"
                break
            case "plantId":
                filterKey = "plantId"
                break
            case "countryId":
                filterKey = "filterByCountry"
                break
            case "salesorgId":
                filterKey = "filterBySalesOrg"
                break
            case "status":
                filterKey = "status"
                break
            case "materialClass":
                filterKey = "filterByMaterialClass"
                break
            case "currencyId":
                filterKey = "filterByCurrency"
                break
            }
            if (selectedFilter === "")
                selectedFilter += `${filterKey}=${commaSeparatedFilterValues}`
            else
                selectedFilter += `&${filterKey}=${commaSeparatedFilterValues}`
        }
    })
    let result = await axios.get(
        `${PRICING_DOMAIN_PATH}tmc-mapping?${selectedFilter}&search=${customsearchtext}`,
        commonHeaders
    )
    return result.data
}


export const getAllPriceEngineSimulation = async ({ queryKey }) => {
    const [, page, limit, customsearchtext, filter] = queryKey

    let selectedFilter = ""
    if (filter.priceList.length > 0 && page && limit) {
        Object.keys(filter).forEach((key) => {
            if (filter[key].length > 0) {
                const commaSeparatedFilterValues = filter[key].join(",")

                let filterKey = ""
                switch (key) {
                case "priceList":
                    filterKey = "pricelist_id"
                    break
                case "typeNumber":
                    filterKey = "type_id"
                    break
                case "articleNo":
                    filterKey = "part_id"
                    break
                case "materialClass":
                    filterKey = "material_class"
                    break
                }

                if (selectedFilter === "")
                    selectedFilter += `${filterKey}=${commaSeparatedFilterValues}`
                else
                    selectedFilter += `&${filterKey}=${commaSeparatedFilterValues}`
            }
        })

        let result = await axios.get(
            `${PRICING_DOMAIN_PATH}price-engine/simulate?page=${page}&limit=${limit}&search=${customsearchtext}&${selectedFilter}`,
            commonHeaders
        )
        return result.data
    }
    else {
        return {}
    }
}

export const downloadPriceEngineSimulation = async (filter) => {
    let selectedFilter = ""
    if (filter.priceList.length > 0) {
        Object.keys(filter).forEach((key) => {
            if (filter[key].length > 0) {
                const commaSeparatedFilterValues = filter[key].join(",")
                let filterKey = ""
                switch (key) {
                case "priceList":
                    filterKey = "pricelist_id"
                    break
                case "typeNumber":
                    filterKey = "type_id"
                    break
                case "articleNo":
                    filterKey = "part_id"
                    break
                case "materialClass":
                    filterKey = "material_class"
                    break
                }
                if (selectedFilter === "")
                    selectedFilter += `${filterKey}=${commaSeparatedFilterValues}`
                else
                    selectedFilter += `&${filterKey}=${commaSeparatedFilterValues}`
            }
        })
        let result = await axios.get(
            `${PRICING_DOMAIN_PATH}price-engine/simulate?${selectedFilter}`,
            commonHeaders
        )
        return result.data
    }
    else {
        return {}
    }
}

export const getHubAll = async () => {
    let result = await axios.get(`${DOAMIN_PATH}hub/download/hub`, commonHeaders)
    return result.data && result.data.data ? result.data.data : result.data
}

export const getSalesOrgAll = async () => {
    let result = await axios.get(
        `${DOAMIN_PATH}salesorganization/downloadFile`,
        commonHeaders
    )
    return result.data && result.data.data ? result.data.data : result.data
}

export const downloadPsIndicatorRecord = async ({ queryKey }) => {
    const [, lang] = queryKey
    let result = await axios.get(`${DOAMIN_PATH}ps-indicator?language_id=${lang}`, commonHeaders)
    return result
}

export const updatePriceMatrixApi = async (updatedData) => {
    const response = await axios.patch(
        `${PRICING_DOMAIN_PATH}price-matrix/${updatedData.id}`,
        updatedData,
        commonHeaders
    )
    return response.data
}

export const getPriceMatrixFormula = async () => {
    let result = await axios.get(
        `${DOAMIN_PATH}formula`,
        commonHeaders
    )
    return result.data
}
export const downloadGgIndicatorRecord = async ({ queryKey }) => {
    const [, lang] = queryKey
    let result = await axios.get(`${DOAMIN_PATH}gg-indicator?language_id=${lang}`, commonHeaders)
    return result
}

export const downloadFailureCodeRecord = async ({ queryKey }) => {
    const [, lang] = queryKey
    let result = await axios.get(`${DOAMIN_PATH}failure-code?language_id=${lang}`, commonHeaders)
    return result
}

export const downloadExchangeRateRecord = async (search, appliedFilter) => {
    let url = `${DOAMIN_PATH}exchange-rate?`
    url = appendQueryParam(url, "search", search)
    url = appendQueryParam(url, "validity_from", appliedFilter?.startDate)
    url = appendQueryParam(url, "validity_to", appliedFilter?.endDate)
    url = appendQueryParam(url, "sales_org", appliedFilter?.salesOrg)
    url = appendQueryParam(url, "status", appliedFilter?.status)
    url = appendQueryParam(url, "from_currency", appliedFilter?.fromCurrency)
    url = appendQueryParam(url, "to_currency", appliedFilter?.toCurrency)
    let result = await axios.get(
        url,
        commonHeaders
    )
    return result
}

export const getExceptionsForCode = async ({ queryKey }) => {
    const [, code] = queryKey
    let result = await axios.get(
        `${DOAMIN_PATH}exception-code/${code}`,
        commonHeaders
    )
    return result.data
}

export const getProductsForCode = async ({ queryKey }) => {
    const [, code] = queryKey
    let result = await axios.get(
        `${DOAMIN_PATH}product-from-code/${code}`,
        commonHeaders
    )
    return result.data
}

export const getExceptionApproverForCode = async ({ queryKey }) => {
    const [, code] = queryKey
    let result = await axios.get(`${DOAMIN_PATH}approver/${code}`, commonHeaders)
    return result.data
}

export const getGgForCode = async ({ queryKey }) => {
    const [, code] = queryKey
    let result = await axios.get(
        `${DOAMIN_PATH}gg-indicator/${code}`,
        commonHeaders
    )
    return result.data
}

export const getActionsForCode = async ({ queryKey }) => {
    const [, code] = queryKey
    let result = await axios.get(
        `${DOAMIN_PATH}action-code/${code}`,
        commonHeaders
    )
    return result.data
}

export const getCountryConfiguration = async ({ queryKey }) => {
    const [, filter] = queryKey
    let selectedFilter = ""
    Object.keys(filter).forEach((key) => {
        if (filter[key] && filter[key].length > 0) {
            const commaSeparatedFilterValues = filter[key].join(",")
            let filterKey = ""
            switch (key) {
            case "country_id":
                filterKey = "country_id"
                break
            case "currency_id":
                filterKey = "currency_id"
                break
            case "sales_org_id":
                filterKey = "sales_org_id"
                break
            }

            if (selectedFilter === "")
                selectedFilter += `${filterKey}=${commaSeparatedFilterValues}`
            else
                selectedFilter += `&${filterKey}=${commaSeparatedFilterValues}`
        }
        else {
            selectedFilter += ""
        }

    })
    let url = `${DOAMIN_PATH}country-config/all?${selectedFilter}`
    const result1 = await axios.get(url, commonHeaders)
    return await result1.data
}

export const downloadCountryConfigRecords = async () => {
    let result = await axios.get(
        `${DOAMIN_PATH}country-config/all`,
        commonHeaders
    )
    return result
}

export const getCountryConfigInfo = async () => {
    let result = await axios.get(
        `${DOAMIN_PATH}country-config/getCountryConfigInfo`,
        commonHeaders
    )
    return result.data
}

export const downloadExceptionApproverRecords = async ({ queryKey }) => {
    const [, lang] = queryKey
    let result = await axios.get(`${DOAMIN_PATH}approver?language_id=${lang}`, commonHeaders)
    return result
}
export const downloadExceptionCodeRecords = async ({ queryKey }) => {
    const [, lang] = queryKey
    let result = await axios.get(`${DOAMIN_PATH}exception-code?language_id=${lang}`, commonHeaders)
    return result
}
export const downloadActionCodeRecords = async ({ queryKey }) => {
    const [, lang] = queryKey
    let result = await axios.get(`${DOAMIN_PATH}action-code?language_id=${lang}`, commonHeaders)
    return result
}
export const downloadProductFromCodeRecords = async ({ queryKey }) => {
    const [, lang] = queryKey
    let result = await axios.get(
        `${DOAMIN_PATH}product-from-code?language_id=${lang}`,
        commonHeaders
    )
    return result
}
// Failure Code Mapping to Type Number
export const getFailureCodeMappingCodeList = async () => {
    let result = await axios.get(`${DOAMIN_PATH}failure-code`, commonHeaders)
    return result.data
}

export const getFailureCodeMappingGGIndicatorList = async () => {
    let result = await axios.get(`${DOAMIN_PATH}gg-indicator`, commonHeaders)
    return result.data
}

export async function createAssociation(data) {
    try {
        const result1 = await axios.post(
            `${DOAMIN_PATH}reason-code-device`,
            data,
            commonHeaders
        )
        return await result1.data
    } catch (error) {
        return error
    }
}

export async function updateAssociation(id, data) {
    try {
        const result1 = await axios.patch(
            `${DOAMIN_PATH}reason-code-device/${id}`,
            data,
            commonHeaders
        )
        return await result1.data
    } catch (error) {
        return error
    }
}

export async function deletAssociation(id) {
    try {
        const result1 = await axios.delete(
            `${DOAMIN_PATH}reason-code-device/${id}`,
            commonHeaders
        )
        return await result1.data
    } catch (error) {
        return error
    }
}

export const downloadAssociation = async () => {
    let result = await axios.get(
        `${DOAMIN_PATH}reason-code-device`,
        commonHeaders
    )
    return result
}

export async function createCountryConfiguration(data) {
    const result1 = await axios.post(
        `${DOAMIN_PATH}country-config/create`,
        data,
        commonHeaders
    )
    return await result1.data
}

export async function updateCountryConfiguration(id, data) {
    try {
        const result1 = await axios.patch(
            `${DOAMIN_PATH}country-config/update?id=${id}`,
            data,
            commonHeaders
        )
        return await result1.data
    } catch (error) {
        return error
    }
}

export async function getHubInfo() {
    try {
        const result1 = await axios.get(`${DOAMIN_PATH}hub/hubinfo`, commonHeaders)
        return await result1.data
    } catch (error) {
        return error
    }
}

export async function getHubReginalInfo() {
    try {
        const result1 = await axios.get(
            `${DOAMIN_PATH}hub/regionalContinentInfo`,
            commonHeaders
        )
        return await result1.data
    } catch (error) {
        return error
    }
}

export const getSearchActionCodeList = async ({ queryKey }) => {
    const [, search = ""] = queryKey
    let result = await axios.get(
        `${DOAMIN_PATH}action-code?search=${search}`,
        commonHeaders
    )
    return result.data
}

export const getSearchProductFromCodeList = async ({ queryKey }) => {
    const [, search] = queryKey
    let result = await axios.get(
        `${DOAMIN_PATH}product-from-code?search=${search}`,
        commonHeaders
    )
    return result.data
}

export const createPriceMatrixApi = async (updatedData) => {
    const response = await axios.post(
        `${PRICING_DOMAIN_PATH}price-matrix/create`,
        updatedData,
        {
            headers: {
                tenantid: 1
            }
        }
    )
    return response.data
}

export const getPriceMatrixInfo = async () => {
    let result = await axios.get(
        `${PRICING_DOMAIN_PATH}getPriceMatrixInfo`,
        commonHeaders
    )
    return result.data
}
export const addTrainingSchedule = async (newData) => {
    let result = await axios.post(
        `${LMS_DOMAIN_PATH}schedule-training`,
        newData,
        commonHeaders
    )
    return result.data
}
//order Min max

export const getOrderMinMaxDetails = async ({ queryKey }) => {
    const [, column, order, search, isMin] = queryKey
    let url = `${DOAMIN_PATH}order-min-max-config?`
    if (column) {
        url += `${url[url.length - 1] === "?" ? "" : "&"}orderbyField=${column}`
    }
    if (order) {
        url += `${url[url.length - 1] === "?" ? "" : "&"}orderby=${order}`
    }
    if (search) {
        url += `${url[url.length - 1] === "?" ? "" : "&"}search_code=${search}`
    }
    url += `${url[url.length - 1] === "?" ? "" : "&"}is_min_value=${isMin ? true : false
    }`
    let result = await axios.get(url, commonHeaders)
    return result.data
}


export const downloadOrderMinMaxDetails = async (isMin, search) => {
    let url = `${DOAMIN_PATH}order-min-max-config?`
    if (search) {
        url += `${url[url.length - 1] === "?" ? "" : "&"}search_code=${search}`
    }
    url += `${url[url.length - 1] === "?" ? "" : "&"}is_min_value=${isMin ? true : false
    }`
    let result = await axios.get(url, commonHeaders)
    return result.data
}

export const createOrderMinMax = async (body) => {
    let result = await axios.post(
        `${DOAMIN_PATH}order-min-max-config`,
        body,
        commonHeaders
    )
    return result.data
}

export const validateEANandArticle = async (body) => {
    let result = await axios.post(
        `${PRODUCT_AND_PARTS}verify_ean_part_number`,
        body,
        commonHeaders
    )
    return result.data
}

export const getWorkListApprovals = async ({ queryKey }) => {
    const [
        _,
        page,
        limit,
        customsearchtext = "",
        sortValue = "",
        order = "ASC"
    ] = queryKey
    let result = await axios.get(
        // `${DOAMIN_PATH}work-list-approval?page=${page}&limit=${limit}&search=${customsearchtext}&orderbyField=status&orderby=${order}`,
        `${DOAMIN_PATH}work-list-approval?page=${page}&limit=${limit}&search=${customsearchtext}&orderbyField=${sortValue}`,
        commonHeaders
    )
    return result.data
}

export const updateWorkListApproval = async (id, updatedData) => {
    const response = await axios.patch(
        `${DOAMIN_PATH}work-list-approval/${id}`,
        updatedData,
        commonHeaders
    )
    return response?.data
}

export const getWorkListHubData = async (hub_code) => {
    let result = await axios.get(`${DOAMIN_PATH}hub/${hub_code}`, commonHeaders)
    return result.data
}

export const getWorkListCountryConfigData = async (id) => {
    let result = await axios.get(
        `${DOAMIN_PATH}country-config/${id}`,
        commonHeaders
    )
    return result.data
}

export const getWorkListExchangeRate = async (id) => {
    let result = await axios.get(
        `${DOAMIN_PATH}work-list-approval/${id}`,
        commonHeaders
    )
    return result.data
}

export const updateOrderMinMax = async (id, body , method) => {
    let result
    if(method === "PATCH"){
        result = await axios.patch(
            `${DOAMIN_PATH}order-min-max-config/${id}`,
            body,
            commonHeaders
        )
    }else{
        result = await axios.get(
            `${DOAMIN_PATH}order-min-max-config/${id}`,
            commonHeaders
        )
    }
    return result.data
}

// LMS Trainig Request API

export const getTrainingRequest = async ({ queryKey }) => {
    const [, page, limit, filter, order, search, orderbyField] = queryKey
    let url = `${LMS_DOMAIN_PATH}training-request?`
    if (page && limit) {
        url = appendQueryParam(url, "page", page)
        url = appendQueryParam(url, "limit", limit)
    }
    url = appendQueryParam(url, "orderbyField", orderbyField)
    url = appendQueryParam(url, "orderby", order)
    url = appendQueryParam(url, "search", search)
    if (Object.keys(filter).length > 0) {
        url += `${url[url.length - 1] === "?" ? "" : "&"}filter=${JSON.stringify(
            filter
        )}`
    }
    let result = await axios.get(url, generateCommonHeaders())
    return result.data
}

export const getMyTrainings = async ({ queryKey }) => {
    const [, page, limit, filter, order, search, orderbyField] = queryKey
    let url = `${LMS_DOMAIN_PATH}view-attend-training/my-training-list?`
    if (page && limit) {
        url = appendQueryParam(url, "page", page)
        url = appendQueryParam(url, "limit", limit)
    }
    url = appendQueryParam(url, "orderbyField", orderbyField)
    url = appendQueryParam(url, "orderby", order)
    url = appendQueryParam(url, "search", search)
    if (Object.keys(filter).length > 0) {
        url += `${url[url.length - 1] === "?" ? "" : "&"}filter=${JSON.stringify(
            filter
        )}`
    }
    let result = await axios.get(url, generateCommonHeaders())
    return result.data
}

export const getMyTrainingRequestById = async ({ queryKey }) => {
    const [, trainingId, userId, type] = queryKey
    let url = `${LMS_DOMAIN_PATH}view-attend-training/${trainingId}${userId ? "/" + userId : ""}`
    if (type) { url = `${url}/${type}` }
    let result = await axios.get(url, generateCommonHeaders())
    return result.data
}

export const getMyTrainingRequest = async ({ queryKey }) => {
    const [, page, limit, filter, order, search, orderbyField, userId] = queryKey
    let url = `${LMS_DOMAIN_PATH}view-attend-training/user/${userId}?`
    if (page && limit) {
        url = appendQueryParam(url, "page", page)
        url = appendQueryParam(url, "limit", limit)
    }
    url = appendQueryParam(url, "orderbyField", orderbyField)
    url = appendQueryParam(url, "orderby", order)
    url = appendQueryParam(url, "search", search)
    if (Object.keys(filter).length > 0) {
        url += `${url[url.length - 1] === "?" ? "" : "&"}filter=${JSON.stringify(
            filter
        )}`
    }
    let result = await axios.get(url, generateCommonHeaders())
    return result.data
}

export const getuserRoles = async () => {
    let url = `${LMS_DOMAIN_PATH}roles?roletype=0`
    let result = await axios.get(url, commonHeaders)
    return result.data
}

export const getTrainerOptions = async () => {
    let url = `${LMS_DOMAIN_PATH}trainer`
    let result = await axios.get(url, commonHeaders)
    return result.data
}

export const getServiceCenterBySalesOrg = async ({ queryKey }) => {
    const [, countryIds, SalesOrgIds] = queryKey
    if (countryIds && SalesOrgIds) {
        let url = `${SERVICE_CENTER_DOMAIN_PATH}common/service-center-by-salesOrg?country_ids=${countryIds}&sales_org_ids=${SalesOrgIds}`
        let result = await axios.get(url, commonHeaders)
        return result.data
    } else {
        return []
    }
}

export const getScheduledTrainingById = async ({ queryKey }) => {
    const [, trainingId] = queryKey
    if (trainingId) {
        let url = `${LMS_DOMAIN_PATH}schedule-training/${trainingId}`
        let result = await axios.get(url, commonHeaders)
        return result.data
    }
}

export const getScheduledParitcipants = async ({ queryKey }) => {
    const [, propsObj] = queryKey
    const { scheduledTrainingId, page, limit, filter, search } = propsObj
    if (scheduledTrainingId) {
        let url = `${LMS_DOMAIN_PATH}schedule-training/participants/${scheduledTrainingId}?`
        if (page && limit) {
            url = appendQueryParam(url, "page", page)
            url = appendQueryParam(url, "limit", limit)
        }
        url = appendQueryParam(url, "search", search)
        if (filter) {
            if (Object.keys(filter).length > 0) {
                url += `${url[url.length - 1] === "?" ? "" : "&"
                }filter=${JSON.stringify(filter)}`
            }
        }
        let result = await axios.get(url, commonHeaders)
        return result.data
    }
    return null
}

export const updateParticipantCompletion = async (id, body) => {
    let result = await axios.patch(
        `${LMS_DOMAIN_PATH}schedule-training/${id}`,
        body,
        commonHeaders
    )
    return result.data
}

export const getSalesOrgByCountry = async ({ queryKey }) => {
    const [, countries] = queryKey
    if (countries) {
        let result = await axios.get(
            `${DOAMIN_PATH}common/salesOrgsByCountry?country_id=${countries}`,
            commonHeaders
        )
        return result.data
    } else {
        return []
    }
}

export const getServiceCenterByCountry = async ({ queryKey }) => {
    const [, countries] = queryKey
    if (countries) {
        let result = await axios.get(
            `${SERVICE_CENTER_DOMAIN_PATH}common/service-center-by-country?country_id=${countries}`,
            commonHeaders
        )
        return result.data
    }
}

// manage users

export const addRegistrationData = async (newData) => {
    return await axios.post(
        `${USER_MANAGEMENT_DOMAIN_PATH}user-registration/external`,
        newData, commonHeadersWithoutAuth

    )
}

export const getExternalMangeUsersList = async ({ queryKey }) => {
    const [, page, limit, customsearchtext, filter, appliedFilter, orderBy="asc", orderByField=""] = queryKey
    let url = `${USER_MANAGEMENT_DOMAIN_PATH}user-registration?`
    if (page && limit) {
        url += `${url[url.length - 1] === "?" ? "" : "&"}page=${page}`
        url += `${url[url.length - 1] === "?" ? "" : "&"
        }limit=${limit}&user_type=1`
    }
    
    url = appendQueryParam(url, "filterText", customsearchtext)
    url = appendQueryParam(url, "country", filter?.country?.join(","))
    url = appendQueryParam(url, "role", filter?.role?.join(","))
    url = appendQueryParam(url, "service_center", filter?.serviceCenter?.join(","))
    url = appendQueryParam(url, "filterText", filter?.filterText?.join(","))
    url = appendQueryParam(url, "orderby", orderBy?.toLowerCase())
    url = appendQueryParam(url, "orderbyField", orderByField)
    let result = await axios.get(url, commonHeaders)
    return result.data
}

export const getInternalMangeUsersList = async ({ queryKey }) => {
    const [_, page, limit, customsearchtext, filter, roleType, appliedFilter, orderBy="asc", orderByField=""] = queryKey
    let url = `${USER_MANAGEMENT_DOMAIN_PATH}user-registration?`
    if (page && limit && !customsearchtext) {
        url += `${url[url.length - 1] === "?" ? "" : "&"}page=${page}`
        url += `${url[url.length - 1] === "?" ? "" : "&"
        }limit=${limit}&user_type=2`
    }
    if (customsearchtext) {
        url += `${url[url.length - 1] === "?" ? "" : "&"
        }filterText=${customsearchtext}&user_type=2`
    }


    url = appendQueryParam(url, "country", filter?.country?.join(","))
    url = appendQueryParam(url, "user_name", filter?.user_name?.join(","))
    url = appendQueryParam(url, "role", filter?.role?.join(","))
    url = appendQueryParam(url, "salesorg", filter?.default_sales_org?.join(","))
    url = appendQueryParam(url, "orderby", orderBy?.toLowerCase())
    url = appendQueryParam(url, "orderbyField", orderByField)
    let result = await axios.get(url, commonHeaders)
    return result.data
}

export const getRoleList = async ({ queryKey }) => {
    const [, roletype] = queryKey
    let result = await axios.get(
        `${USER_MANAGEMENT_DOMAIN_PATH}roles?roletype=${roletype}`,
        commonHeaders
    )
    return result.data
}

export const getexternalUserIdData = async ({ queryKey }) => {
    const [, id] = queryKey
    let result = await axios.get(
        `${USER_MANAGEMENT_DOMAIN_PATH}user-registration/${id}`,
        commonHeaders
    )
    return result.data
}

export const getInternalUserIdData = async ({ queryKey }) => {
    const [, id] = queryKey
    let result = await axios.get(
        `${USER_MANAGEMENT_DOMAIN_PATH}user-registration/${id}/2`,
        commonHeaders
    )
    return result.data
}

export const updateExternalUsersList = async (id, updatedData) => {
    try {
        const response = await axios.patch(
            `${USER_MANAGEMENT_DOMAIN_PATH}user-registration/${id}`,
            updatedData,
            commonHeaders
        )
        return response.data
    } catch (error) {
        return error
    }
}

export const updateInternalUsersList = async (id, updatedData) => {
    const response = await axios.patch(
        `${USER_MANAGEMENT_DOMAIN_PATH}user-registration/${id}`,
        updatedData,
        commonHeaders
    )
    return response.data
}

export const addInternalUserList = async (newData) => {
    return await axios.post(
        `${USER_MANAGEMENT_DOMAIN_PATH}user-registration`,
        newData,
        commonHeaders
    )
}

export const addPriceMatrixException = async (newData) => {
    return await axios.post(
        `${PRICING_DOMAIN_PATH}price-matrix-exception`,
        newData,
        commonHeaders
    )
}
export const addMasterMappingTMC = async (newData) => {
    return await axios.post(
        `${PRICING_DOMAIN_PATH}tmc-mapping`,
        newData,
        commonHeaders
    )
}
export const updateMasterMappingTMC = async (id, updatedData) => {
    try {
        const response = await axios.patch(
            `${PRICING_DOMAIN_PATH}tmc-mapping/${id}`,
            updatedData,
            commonHeaders
        )
        return response.data
    } catch (error) {
        return error
    }
}
export const getConsumerDocument = async ({ queryKey }) => {
    try {
        const [, ticket_id] = queryKey
        if( !ticket_id ) {
            return
        }
        let result = await axios.get(
            `${WARRANTY_MANAGEMENT}consumer-invoice/${ticket_id}`, commonHeaders
        )
        return result.data
    } catch (error) {
        return error
    }
}
export const getConsumerPdf = async ( ticket_id ) => {
    try {
        if( !ticket_id ) {
            return
        }
        let result = await axios.get(
            `${WARRANTY_MANAGEMENT}consumer-invoice/generateConsumerPrintout/${ticket_id}`, commonHeaders
        )
        return result.data
    } catch (error) {
        return error
    }
}
export const getConsumerFinalPdf = async ( ticket_id ) => {
    try {
        if( !ticket_id ) {
            return
        }
        let result = await axios.get(
            `${WARRANTY_MANAGEMENT}consumer-invoice/generateFinalPrintout/${ticket_id}`, commonHeaders
        )
        return result.data
    } catch (error) {
        return error
    }
}

export const getProformaInvoicePdf = async (invoice_id, languageId, invoiceHistoryPage) => {
    try {
        if (!invoice_id) {
            return
        }
        let url = invoiceHistoryPage ? `${WARRANTY_MANAGEMENT}warranty-invoice/generate_html/${invoice_id}/${languageId}?is_invoice_rejected=${invoiceHistoryPage}`
            : `${WARRANTY_MANAGEMENT}warranty-invoice/generate_html/${invoice_id}/${languageId}`
        let result = await axios.get(
            url,  { ...commonHeaders, responseType: "blob" }
        )
        return result
    } catch (error) {
        return error
    }
}

export const getCertificateShopPdf = async ( ticket_id) => {
    try {
        if( !ticket_id ) {
            return
        }
        let url = `${WARRANTY_MANAGEMENT}warranty/certificate-to-shop/${ticket_id}`
        let result = await axios.get(
            url, commonHeaders
        )
        return result?.data
    } catch (error) {
        return error
    }
}

export const getApproverReportPdf = async ( invoice_id, languageId, invoiceHistoryPage ) => {
    try {
        if( !invoice_id ) {
            return
        }
        let url = invoiceHistoryPage ? `${WARRANTY_MANAGEMENT}warranty-invoice/generate_approver_html/${invoice_id}/${languageId}?is_invoice_rejected=${invoiceHistoryPage}`
            : `${WARRANTY_MANAGEMENT}warranty-invoice/generate_approver_html/${invoice_id}/${languageId}`
        let result = await axios.get(
            url, commonHeaders
        )
        return result?.data
    } catch (error) {
        return error
    }
}

export const getApprovalReportExcel = async ( invoice_id, invoiceHistoryPage ) => {
    try {
        if( !invoice_id ) {
            return
        }
        let url = invoiceHistoryPage ? `${WARRANTY_MANAGEMENT}warranty-invoice/generate_report_excel/${invoice_id}?is_invoice_rejected=${invoiceHistoryPage}` 
            : `${WARRANTY_MANAGEMENT}warranty-invoice/generate_report_excel/${invoice_id}`
        let result = await axios.get(
            url, commonHeaders
        )
        return result?.data
    } catch (error) {
        return error
    }
}

export const getPrfExcel = async ( invoice_id, invoiceHistoryPage ) => {
    try {
        if( !invoice_id ) {
            return
        }
        let url = invoiceHistoryPage ? `${WARRANTY_MANAGEMENT}warranty-invoice/generate_prf_excel/${invoice_id}?is_invoice_rejected=${invoiceHistoryPage}` 
            : `${WARRANTY_MANAGEMENT}warranty-invoice/generate_prf_excel/${invoice_id}`
        let result = await axios.get(
            url, commonHeaders
        )
        return result?.data
    } catch (error) {
        return error
    }
}

export const getWarrantyPerformaCSV = async (data) => {
    let result = await axios.post(
        `${WARRANTY_MANAGEMENT}/warranty-invoice/generate_service_center_report_excel`,
        data,
        commonHeaders
    )
    return result.data
}

export const addConsumerDocument = async (newData) => {
    return await axios.post(
        `${WARRANTY_MANAGEMENT}consumer-invoice`,
        newData,
        commonHeaders
    )
}
export const updateConsumerDocument = async (ticket_id, updatedData) => {
    try {
        const response = await axios.patch(
            `${WARRANTY_MANAGEMENT}consumer-invoice/${ticket_id}`,
            updatedData,
            commonHeaders
        )
        return response.data
    } catch (error) {
        return error
    }
}

export const updatePriceMatrixException = async (id, updatedData) => {    
    const response = await axios.patch(
        `${PRICING_DOMAIN_PATH}price-matrix-exception/${id}`,
        updatedData,
        commonHeaders
    )
    return response.data    
}

//order Min max

export const fetchRecordList = async (endPoint) => {
    let result = await axios.get(
        `${SERVICE_CENTER_DOMAIN_PATH}${endPoint}`,
        commonHeaders
    )
    return result.data
}
/**
 * Service Center POST,
 */
export const createRecordList = async (data) => {
    let result = await axios.post(
        `${SERVICE_CENTER_DOMAIN_PATH}service-center`,
        data,
        commonHeaders
    )
    return result.data
}

/**
 * Service Center Get,
 */
export const fetchServiceCenter = async (id) => {
    let result = await axios.get(
        `${SERVICE_CENTER_DOMAIN_PATH}service-center/${id}`,
        commonHeaders
    )
    return result.data
}

export const fetchServiceCenterMultiple = async (ids) => {
    const serviceCenterIds = ids.split(",")
    let fetchedRecords = []
    for (const serviceCenterId of serviceCenterIds) {
        let result = await axios.get(
            `${SERVICE_CENTER_DOMAIN_PATH}service-center/${serviceCenterId}`,
            commonHeaders
        )
        fetchedRecords.push(result?.data)
    }
    return fetchedRecords
}

/**
 * Service Center UPDATE,
 */
export const updateServiceCenter = async (id, data) => {
    let result = await axios.patch(
        `${SERVICE_CENTER_DOMAIN_PATH}service-center/${id}`,
        data,
        commonHeaders
    )
    return result.data
}
/**
 * Service Center Get Price List based on Org ID
 */

export const getPriceListBasedOnSalesOrg = async (sales_org_id) => {
    let result = await axios.get(
        `${DOAMIN_PATH}salesorganization/${sales_org_id}`,
        commonHeaders
    )
    return result.data
}

export const getMonthlyBookingRateData = async ({ queryKey }) => {
    const [, page, limit, customsearchtext, fromCurrency, toCurrency, fromDate, toDate] = queryKey
    let url = `${PRICING_DOMAIN_PATH}monthly-booking-rate?`
    if (page && limit) {
        url = appendQueryParam(url, "page", page)
        url = appendQueryParam(url, "limit", limit)
    }
    url = appendQueryParam(url, "search", customsearchtext)
    url = appendQueryParam(url, "fromCurrency", fromCurrency)
    url = appendQueryParam(url, "toCurrency", toCurrency)
    url = appendQueryParam(url, "fromDate", fromDate)
    url = appendQueryParam(url, "toDate", toDate)
    let result = await axios.get(url, commonHeaders)
    return result.data
}

export const downloadMonthlyRateList = async () => {
    let result = await axios.get(
        `${PRICING_DOMAIN_PATH}monthly-booking-rate`,
        commonHeaders
    )
    return result
}

export const getFirmRateData = async ({ queryKey }) => {
    const [, page, limit, customsearchtext, fromCurrency, toCurrency, fromYear, toYear] = queryKey
    let url = `${PRICING_DOMAIN_PATH}firm-rate?`
    if (page && limit) {
        url = appendQueryParam(url, "page", page)
        url = appendQueryParam(url, "limit", limit)
    }
    url = appendQueryParam(url, "search", customsearchtext)
    url = appendQueryParam(url, "fromCurrency", fromCurrency)
    url = appendQueryParam(url, "toCurrency", toCurrency)
    url = appendQueryParam(url, "fromYear", fromYear)
    url = appendQueryParam(url, "toYear", toYear)
    let result = await axios.get(url, commonHeaders)
    return result.data
}

export const downloadFirmRateList = async () => {
    let result = await axios.get(
        `${PRICING_DOMAIN_PATH}firm-rate`,
        commonHeaders
    )
    return result
}

export const getServiceCenterListOnView = async ({ queryKey }) => {
    const [, code] = queryKey
    let result = await axios.get(
        `${SERVICE_CENTER_DOMAIN_PATH}service-center/${code}`,
        commonHeadersService
    )
    return result.data
}

export const getServiceCenterList = async ({ queryKey }) => {
    const [, page, limit, customsearchtext, brands, countries,isBlockOrder,functionType] = queryKey
    let url = `${SERVICE_CENTER_DOMAIN_PATH}service-center?`
    if (page && limit) {
        url = appendQueryParam(url, "page", page)
        url = appendQueryParam(url, "limit", limit)
    }
    url = appendQueryParam(url, "search", customsearchtext)
    url = appendQueryParam(url, "brand_id", brands)
    url = appendQueryParam(url, "country_id", countries)
    url = appendQueryParam(url, "block_order", isBlockOrder)
    url = appendQueryParam(url, "function_type", functionType)
    const result = await axios.get(url, commonHeaders)
    return result.data
}

export const getServiceCenterFilteredList = async ({ queryKey }) => {
    const [, page, limit,  brands, countries] = queryKey
    const brandsFilter = `&brand_id=${brands}`
    const countriesFilter = `&country_id=${countries}`
    let result = await axios.get(
        `${SERVICE_CENTER_DOMAIN_PATH}service-center?page=${page}&limit=${limit}${brands ? brandsFilter : ""
        }${countries ? countriesFilter : ""}`,
        commonHeadersService
    )
    return result.data
}

export const downloadServiceCenterRecord = async (customsearchtext, brands, countries) => {
    let url = `${SERVICE_CENTER_DOMAIN_PATH}service-center/get-all-records?`
    if (customsearchtext) {
        url += `${(url[url.length - 1] === "?" ? "" : "&") + "search=" + customsearchtext
        }`
    }
    if (brands) {
        url += `${(url[url.length - 1] === "?" ? "" : "&") + "brand_id=" + brands}`
    }
    if (countries) {
        url += `${(url[url.length - 1] === "?" ? "" : "&") + "country_id=" + countries
        }`
    }
    const result = await axios.get(url, commonHeadersService)
    return result
}

export const getAllComments = async ({ queryKey }) => {
    const [, id] = queryKey
    let url = `${SERVICE_CENTER_DOMAIN_PATH}service-center/get/comment/get-all-comment?`
    if (id?.serviceCenterID !==undefined) {
        url += `${(url[url.length - 1] === "?" ? "" : "&") + "service_center_id="+id?.serviceCenterID
        }`
    
        const result = await axios.get(url, commonHeadersService)
        return result
    }
}

export const getUploadDownloadError = async (id) => {
    let bodyData = { "id": id, type: "error_url", }
    let url = `${DOAMIN_PATH}common/download`
    if (id !== undefined) {
        let result = await axios.post(
            url,
            bodyData,
            {
                ...commonHeaders, responseType: 'blob',
                headers: {
                    'Accept': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
                    'Content-Type': 'application/json',
                },
            }
        )
        return result
    }
}

export const generateSCNmber = async ({ queryKey }) => {
    const [, id] = queryKey
    let url = `${SERVICE_CENTER_DOMAIN_PATH}/service-center/generate/secondary-sc-number?`
    if (id !== "" || undefined) {
        url += `${(url[url.length - 1] === "?" ? "" : "&") + "Primary_sc_id="+id
        }`
    
        const result = await axios.get(url, commonHeadersService)
        return result
    }
}

export const postAllComments = async (body) => {
    let url = `${SERVICE_CENTER_DOMAIN_PATH}service-center/post/comment/create`
    let result = await axios.post(
        url,
        body,
        commonHeaders
    )
    return result.data
}

export const getBrands = async () => {
    let result = await axios.get(
        `${SERVICE_CENTER_DOMAIN_PATH}common/brands`,
        commonHeadersService
    )
    return result.data
}

export const getDeeplinkData = async () => {
    let result = await axios.get(
        `${SERVICE_CENTER_DOMAIN_PATH}deeplink-url-sc`,
        commonHeadersService
    )
    return result.data
}

export const updateTrainingCompletionStatus = async (updatedData) => {
    try {
        const response = await axios.patch(
            `${LMS_DOMAIN_PATH}schedule-training/${updatedData.scheduled_training_id}`,
            updatedData.payload,
            commonHeaders
        )
        return response.data
    } catch (error) {
        throw new Error("Error updating the training status")
    }
}

export const addNewParticipant = async (data) => {
    const response = await axios.post(
        `${LMS_DOMAIN_PATH}schedule-training/addUser`,
        data,
        commonHeaders
    )
    return response.data
}

export const getTrainingParticipantsList = async ({ queryKey }) => {
    const [, training_id, page, limit, filter, search] = queryKey
    let url = `${LMS_DOMAIN_PATH}schedule-training/participants/${training_id}?`
    if (page && limit) {
        url += `${(url[url.length - 1] === "?" ? "" : "&") + "page=" + page}`
        url += `${(url[url.length - 1] === "?" ? "" : "&") + "limit=" + limit}`
    }
    if (search) {
        url += `${(url[url.length - 1] === "?" ? "" : "&") + "search=" + search}`
    }
    if (filter && Object.keys(filter).length) {
        url += `${url[url.length - 1] === "?" ? "" : "&"}filter=${JSON.stringify(
            filter
        )}`
    }
    let result = await axios.get(url, commonHeaders)
    return result.data
}

export const downloadParticipantRecords = async (training_id) => {
    let url = `${LMS_DOMAIN_PATH}schedule-training/participants/${training_id}?`
    let result = await axios.get(url, commonHeaders)
    return result
}

export const getScheduledTrainingDetails = async ({ queryKey }) => {
    const [, trainingId] = queryKey
    if (trainingId) {
        let url = `${LMS_DOMAIN_PATH}schedule-training/${trainingId}`
        let result = await axios.get(url, commonHeaders)
        return result.data
    }
}

export const getUserList = async ({ queryKey }) => {
    const [, scheduledTrainingId] = queryKey
    if (scheduledTrainingId) {
        let url = `${LMS_DOMAIN_PATH}schedule-training/userByCountry?scheduled_training_id=${scheduledTrainingId}`
        let result = await axios.get(url, commonHeaders)
        return result.data
    }
}

//login api call
export const getUser = async (data) => {
    let url = `${USER_MANAGEMENT_DOMAIN_PATH}login`
    let result = await axios.post(url, data, commonHeadersWithoutAuth)
    return result.data
}

export const refreshExternalToken = async (data) => {
    let url = `${USER_MANAGEMENT_DOMAIN_PATH}refresh-auth`
    let result = await axios.post(url, data, commonHeadersWithoutAuth)
    return result.data
}

export const getInterUser = async (data) => {
    let newHeader = ""
    if(data.token !==""){
        newHeader = commonHeadersWithoutAuth
        newHeader.headers.Authorization = "Bearer " + data.token
    }
    else{
        newHeader = commonHeadersWithoutAuth
        newHeader.headers.userContext = JSON.stringify ({ "userId": "" })
    }
    let url = `${USER_MANAGEMENT_DOMAIN_PATH}user-context`
    let result = await axios.get(url, { headers:newHeader.headers })
    return result.data
}

export const forgetPasswordRequest = async (data) => {
    let result = await axios.post(
        `${USER_MANAGEMENT_DOMAIN_PATH}user-registration/forget-password`,
        data,
        commonHeaders
    )
    return result.data
}

export const userLoginVerification = async (data) => {
    let result = await axios.post(
        `${USER_MANAGEMENT_DOMAIN_PATH}user-registration/verify-user`,
        data,
        commonHeaders
    )
    return result.data
}

export const resetPassword = async (data) => {
    let result = await axios.post(
        `${USER_MANAGEMENT_DOMAIN_PATH}user-registration/reset-password`,
        data,
        commonHeaders
    )
    return result.data
}

export const getTrainingDetailsByTrainingId = async ({ queryKey }) => {
    const [, trainingId] = queryKey
    let extractTrainID = trainingId?.split("&")[0]
    let url = `${LMS_DOMAIN_PATH}view-attend-training/training-list/${extractTrainID}`
    let result = await axios.get(url, generateCommonHeaders())
    return result.data
}

export const getSalesorg = async () => {
    let result = await axios.get(
        `${DOAMIN_PATH}common/salesOrgs?sales_org_required=false`,
        commonHeaders
    )
    return result.data
}

/**
 * SalesOrg With Price List Get,
 */
export const getSalesorgWithPriceList = async () => {
    let result = await axios.get(
        `${DOAMIN_PATH}salesorganization/getSalesOrgAndPriceList`,
        commonHeaders
    )
    return result.data
}

//Notification API Call

export const getuserNotification = async ({ queryKey }) => {
    const [, userId, page, limit] = queryKey
    let url = `${NOTIFICATION_DOMAIN_PATH}notificationsByUser/${userId}?`
    if (page && limit) {
        url += `${url[url.length - 1] === "?" ? "" : "&"}page=${page}`
        url += `${url[url.length - 1] === "?" ? "" : "&"}limit=${limit}`
    }
    let result = await axios.get(url, generateCommonHeaders())
    return result.data
}

export const getNotificationCount = async ({ queryKey }) => {
    const [, userId] = queryKey
    let result = await axios.get(
        `${NOTIFICATION_DOMAIN_PATH}notificationCountByUser/${userId}`,
        generateCommonHeaders()
    )
    return result.data
}

export const getFpcList = async ({ queryKey }) => {
    try {
        const [, type_ids, material_class_ids, country_id] = queryKey

        if (type_ids.length == 0 || material_class_ids == "" || country_id == "")
            return []

        let result = await axios.post(
            `${PRICING_DOMAIN_PATH}price-matrix-exception/fpcDetails`,
            {
                type_ids: Array.isArray(type_ids) ? type_ids : [type_ids],
                mc_ids: Array.isArray(material_class_ids) ? material_class_ids : [material_class_ids],
                country_id: Array.isArray(country_id) ? country_id : [country_id]
            },
            generateCommonHeaders()
        )
        return result.data
    } catch (error) {
        return error
    }
}

export const updateNotificationAsRead = async (id) => {
    let result = await axios.patch(
        `${NOTIFICATION_DOMAIN_PATH}/updateNotification/${id}`,
        {},
        generateCommonHeaders()
    )
    return result.data
}
export const getsalesOrgsWithCountries = async ({ queryKey }) => {
    const [_, isSalesOrgRequired] = queryKey
    const URL = isSalesOrgRequired ? "common/salesOrgsWithCountries?sales_org_required=true" : "common/salesOrgsWithCountries?sales_org_required=false"
    let result = await axios.get(`${DOAMIN_PATH}${URL}`, commonHeaders)
    return result.data
}

export const getsalesOrgsWithImportCountries = async ({ queryKey }) => {
    const [_ ] = queryKey
    const URL = "common/salesOrgsWithCountriesAndImportCountries"
    let result = await axios.get(`${DOAMIN_PATH}${URL}`, commonHeaders)
    return result.data
}

export const getserviceCenterDetails = async () => {
    let result = await axios.get(`${SERVICE_CENTER_DOMAIN_PATH}common/service-center-details`, commonHeaders)
    return result.data
}

/* Finished Goods */

export const createFinsihedGood = async (newData) => {
    return await axios.post(`${PRODUCT_AND_PARTS}finished-goods`, newData, commonHeaders)
}

export const getPlantList = async ({ queryKey }) => {
    let result = await axios.get(
        `${PRODUCT_AND_PARTS}plant`, commonHeaders

    )
    return result
}

export const getfinsihedGoodsByID = async ({ queryKey }) => {
    const [, ID] = queryKey
    let result = await axios.get(
        `${PRODUCT_AND_PARTS}finished-goods/${ID}`,
        commonHeaders
    )
    return result.data
}

export const updateFinishedGoodsByID = async (ID, data) => {
    try {
        const result = await axios.patch(
            `${PRODUCT_AND_PARTS}finished-goods/${ID}`,
            data,
            commonHeaders
        )
        return await result.data
    } catch (error) {
        return error
    }
}

export const getFinishedGoodsList = async ({ queryKey }) => {
    const [, page, limit, language_id, search, orderBy,orderByField, filterByCategory, filterBySubCategory, filterByInProgress, filterByfinishedActive, filterTypeNo,
        filterRegionID] = queryKey
    let url = `${PRODUCT_AND_PARTS}finished-goods?`
    if (page && limit) {
        url = appendQueryParam(url, "page", page)
        url = appendQueryParam(url, "limit", limit)
    }
    url = appendQueryParam(url, "language_id", language_id)
    url = appendQueryParam(url, "search", search)
    url = appendQueryParam(url, "orderby", orderBy)
    url = appendQueryParam(url, "orderbyField", orderByField)
    url = appendQueryParam(url, "intern_group_id", filterByCategory)
    url = appendQueryParam(url, "intern_sub_group_id", filterBySubCategory)
    url = appendQueryParam(url, "in_progress", filterByInProgress)
    url = appendQueryParam(url, "is_active", filterByfinishedActive)
    url = appendQueryParam(url, "region", filterRegionID)
    url = appendQueryParam(url, "type_no", filterTypeNo)
    const result = await axios.get(url, commonHeaders)
    return await result.data
}
/**
 * getTypeNumberList() // Get Type Number List Record
 * @param {Onject} queryKey 
 * @returns Objects Either Success or Reject
 */

export const getTypeNumberList = async ({ queryKey }) => {
    const [, page, limit, languageId, search,orderBy,orderByField, filterByCategory, filterBySubCategory, filterByActiveStatus] = queryKey
    let url = `${PRODUCT_AND_PARTS}type-number?`
    if (page && limit) {
        url = appendQueryParam(url, "page", page)
        url = appendQueryParam(url, "limit", limit)
    }
    url = appendQueryParam(url, "language_id", languageId)
    url = appendQueryParam(url, "search", search)
    url = appendQueryParam(url, "orderby", orderBy)
    url = appendQueryParam(url, "orderbyField", orderByField)
    url = appendQueryParam(url, "filterByCategory", filterByCategory)
    url = appendQueryParam(url, "filterBySubCategory", filterBySubCategory)
    url = appendQueryParam(url, "filterByActiveStatus", filterByActiveStatus)
    const result = await axios.get(url, commonHeaders)
    return await result.data
}


export const getWarrantyTicket = async (data, endPoint) => {
    let result = await axios.post(
        `${WARRANTY_MANAGEMENT}warranty/${endPoint}`,
        data,
        commonHeaders
    )
    return result.data
}

export const getWarrantyTicketByStatus = async (data) => {
    let result = await axios.post(
        `${WARRANTY_MANAGEMENT}Warranty/warranty_find_by_status`,
        data,
        commonHeaders
    )
    return result.data
}

export const getWarrantyPerformaInvoiceTicket = async (data) => {
    let result = await axios.post(
        `${WARRANTY_MANAGEMENT}warranty-invoice/findAll-invoice-warranty`,
        data,
        commonHeaders
    )
    return result.data
}

export const updateWarrantyTicketStatus = async (data) => {
    let result = await axios.post(
        `${WARRANTY_MANAGEMENT}Warranty/update_status`,
        data,
        commonHeaders
    )
    return result.data
}

export const getActionReason = async ({ queryKey }) => {
    const [, type, salesOrgIDs, languageId] = queryKey
    let result = await axios.get(
        `${DOAMIN_PATH}user-action-reasons?type=${type}&sales_orgs=${salesOrgIDs}&language_id=${languageId}`,
        commonHeaders
    )
    return result.data
}
export const getApproverDetails = async ({ queryKey }) => {
    const [, salesOrg, user_id] = queryKey
    let result = await axios.get(
        `${USER_MANAGEMENT_DOMAIN_PATH}user-registration/get-approver_details?sales_org=${salesOrg}&user_id=${user_id}`,
        commonHeaders
    )
    return result.data
}

export const getPromaDetail = async ({ queryKey }) => {
    const [,  invoice_id, page, limit, orderBy, orderByField ] = queryKey
    let result = await axios.get(
        `${WARRANTY_MANAGEMENT}warranty-invoice/${invoice_id}?page=${page}&limit=${limit}&orderBy=${orderBy}&orderByField=${orderByField}`,
        commonHeaders
    )
    return result.data
}


/**
 * getComplaintsWithoutTechnicalDefectsList() // Get Complaints Without Technical Defects List Record
 * @param {Onject} queryKey 
 * @returns Objects Either Success or Reject
 */

export const getComplaintsWithoutTechnicalDefectsList = async ({ queryKey }) => {
    const [, page, limit, languageId, search, orderBy, orderByField, internGroupId, internSubGroupId] = queryKey
    let url = `${PRODUCT_AND_PARTS}add-examples-complaints?`
    if (page && limit) {
        url = appendQueryParam(url, "page", page)
        url = appendQueryParam(url, "limit", limit)
    }
    url = appendQueryParam(url, "language_id", languageId)
    url = appendQueryParam(url, "search", search)
    url = appendQueryParam(url, "orderby", orderBy)
    url = appendQueryParam(url, "orderbyField", orderByField)
    url = appendQueryParam(url, "intern_group_id", internGroupId)
    url = appendQueryParam(url, "intern_sub_group_id", internSubGroupId)
    const result = await axios.get(url, commonHeaders)
    return await result.data
}

/**
 * getComplaintsWithoutTechnicalDefectsList() // Get Complaints Without Technical Defects List Record
 * @param {Onject} queryKey 
 * @returns Objects Either Success or Reject
 */

export async function getComplaintsWithoutTechnicalDefects({ queryKey }) {
    const [, id] = queryKey

    let url = `${PRODUCT_AND_PARTS}add-examples-complaints/${id}`
    const result = await axios.get(url, commonHeaders)
    return await result.data
}

//Common API END Point

export const commonAPIEndpoint = async (endPoint) => {
    let result = await axios.get(
        `${PRODUCT_AND_PARTS}${endPoint}`,
        commonHeaders
    )
    return result.data
}

/**
 * getCategory() // Get Category (Intern Group)
 * @param {Number} ID 
 * @returns Objects
 */
export const getCategory = async () => {
    let result = await axios.get(
        `${PRODUCT_AND_PARTS}category`,
        commonHeaders
    )
    return result.data
}

/**
 * getSubcategory() // Get Subcategory (Intern Sub Group) based on category id
 * @param {Number} ID 
 * @returns Objects
 */
export const getSubcategory = async ({ queryKey }) => {
    const [, ID] = queryKey
    let result = await axios.get(
        `${PRODUCT_AND_PARTS}subCategory/${ID}`,
        commonHeaders
    )

    return result.data
}

export const getAllSubcategories = async ({ queryKey }) => {
    let result = await axios.get(
        `${PRODUCT_AND_PARTS}allSubCategories`,
        commonHeaders
    )

    return result.data
}

export const getSubcategoryProduct = async ({ queryKey }) => {
    const [, ID, groomingGrp] = queryKey
    let updatedIdId = (groomingGrp === "M" && ID === 3) ? 1 : ID
    let result = await axios.get(
        `${PRODUCT_AND_PARTS}subCategory/${updatedIdId}?grooming_grp=${groomingGrp}`,
        commonHeaders
    )
    return result.data
}

export const gettypeNumberList = async () => {

    let result = await axios.get(
        `${PRODUCT_AND_PARTS}type_number`, commonHeaders
    )
    return result.data

}

export const getTypeNumberListByCountry = async ({ queryKey }) => {
    try {
        const [, country_id] = queryKey

        const qry = country_id ? `?country_id=${country_id?.value}` : "?country_id=0"

        let result = await axios.get(
            `${PRODUCT_AND_PARTS}type-country-block/by-country${qry}`, commonHeaders
        )
        return result.data
    } catch (error) {
        return error
    }
}

export const priceMatrixExceptionByID = async ({ queryKey }) => {
    try {
        const [, exception_id] = queryKey
        if (!exception_id) {
            return
        }
        let result = await axios.get(
            `${PRICING_DOMAIN_PATH}price-matrix-exception/${exception_id}`, commonHeaders
        )
        return result.data
    } catch (error) {
        return error
    }
}
export const masterMappingByID = async ({ queryKey }) => {
    try {
        const [, exception_id] = queryKey
        if( !exception_id ) {
            return
        }
        let result = await axios.get(
            `${PRICING_DOMAIN_PATH}tmc-mapping/getdata/${exception_id}`, commonHeaders
        )
        return result.data
    } catch (error) {
        return error
    }
}


/**
 * GetBrandAndOtherCategory() // Get Brand , PDF Group, operating Modes and washableWetDry based
 *  on subcategory (Intern Sub Group) id
 * @param {Number} ID 
 * @returns Objects
 */
export const getBrandAndOtherCategory = async ({ queryKey }) => {
    const [, ID] = queryKey
    let result = await axios.get(
        `${PRODUCT_AND_PARTS}brandAndOthersBySubCategory/${ID}`,
        commonHeaders
    )
    return result.data
}


/** 
 * createTypeNumber() // Create Type Number
 * @param {Object} data
 * @returns Objects
 */

export const createTypeNumber = async (data) => {
    let result = await axios.post(
        `${PRODUCT_AND_PARTS}type-number`,
        data,
        commonHeaders
    )
    return result.data
}

/** 
 * getTypeNumber() // Edit Type Number - Get By ID
 * @param {Number} id
 * @returns Objects
 */

export const getTypeNumber = async ({ queryKey }) => {
    const [, id] = queryKey
    let result = await axios.get(
        `${PRODUCT_AND_PARTS}type-number/${id}`,
        commonHeaders
    )
    return result.data
}

export const getTypeNumberOnSalesOrg = async ({ queryKey }) => {
    const [, ids] = queryKey
    let result = await axios.get(
        `${PRODUCT_AND_PARTS}type-number/bySalesOrg?org_codes=${ids}`,
        commonHeaders
    )
    return result.data
}

export const getConsumerDetailOnSalesOrgAndServiceCenterNumber = async ({ queryKey }) => {
    const [, sales_org, srNumber, functionNumberSecondary] = queryKey
    let url = srNumber ? `${WARRANTY_MANAGEMENT}warranty/warranty_consumer_details?sales_org=${sales_org}&primary_service_center_Number=${srNumber}`
        : `${WARRANTY_MANAGEMENT}warranty/warranty_consumer_details?sales_org=DE40&secondary_service_center_Number=${functionNumberSecondary}`
    let result = await axios.get(
        url,
        commonHeaders
    )
    return result.data
}

export const getCityBySalesOrg = async ({ queryKey }) => {
    const [, ids] = queryKey
    let result = await axios.get(
        `${SERVICE_CENTER_DOMAIN_PATH}common/city-by-salesOrg?sales_org_ids=${ids}`,
        commonHeaders
    )
    return result.data
}

export const getCustomerNumberBySalesOrg = async ({ queryKey }) => {
    const [, ids] = queryKey
    let result = await axios.get(
        `${SERVICE_CENTER_DOMAIN_PATH}common/customer-number-by-salesOrg?sales_org_ids=${ids}`,
        commonHeaders
    )
    return result.data
}

export const getSecondaryServiceCenterOnSalesOrg = async ({ queryKey }) => {
    const [, ids] = queryKey
    let result = await axios.get(
        `${SERVICE_CENTER_DOMAIN_PATH}common/secondary-service_center/${ids}`,
        commonHeaders
    )
    return result.data
}

/** 
 * createComplaintsWithoutTechnicalDefects() // Create Type Number
 * @param {Object} data
 * @returns Objects
 */

export const createComplaintsWithoutTechnicalDefects = async (data) => {
    let result = await axios.post(
        `${PRODUCT_AND_PARTS}add-examples-complaints`,
        data,
        commonHeaders
    )
    return result.data
}

/** 
 * downloadTypeNumberList() // View Type Number list
 * @returns Objects
 */
export const downloadTypeNumberList = async (languageId, search,orderBy,orderByField, filterByCategory, filterBySubCategory, filterByActiveStatus) => {
    let url = `${PRODUCT_AND_PARTS}type-number?`
    url = appendQueryParam(url, "language_id", languageId)
    url = appendQueryParam(url, "search", search)
    url = appendQueryParam(url, "orderby", orderBy)
    url = appendQueryParam(url, "orderbyField", orderByField)
    url = appendQueryParam(url, "filterByCategory", filterByCategory)
    url = appendQueryParam(url, "filterBySubCategory", filterBySubCategory)
    url = appendQueryParam(url, "filterByActiveStatus", filterByActiveStatus)
    const result = await axios.get(url, commonHeaders)
    return result
}
export const downloadFinishedGoodsList = async (language_id, search, orderBy, orderByField, filterByCategory, filterBySubCategory, filterByInProgress, filterByfinishedActive, filterTypeNo, filterRegionID) => {
    let url = `${PRODUCT_AND_PARTS}finished-goods?`
    url = appendQueryParam(url, "language_id", language_id)
    url = appendQueryParam(url, "search", search)
    url = appendQueryParam(url, "orderby", orderBy)
    url = appendQueryParam(url, "orderbyField", orderByField)
    url = appendQueryParam(url, "intern_group_id", filterByCategory)
    url = appendQueryParam(url, "intern_sub_group_id", filterBySubCategory)
    url = appendQueryParam(url, "in_progress", filterByInProgress)
    url = appendQueryParam(url, "is_active", filterByfinishedActive)
    url = appendQueryParam(url, "region", filterRegionID)
    url = appendQueryParam(url, "type_no", filterTypeNo)
    const result = await axios.get(url, commonHeaders)
    return result
}
export const downloadComplaintsWithoutTechnicalDefectsList = async (languageId, search, orderBy, orderByField, internGroupId, internSubGroupId) => {
    let url = `${PRODUCT_AND_PARTS}add-examples-complaints?`
    url = appendQueryParam(url, "language_id", languageId)
    url = appendQueryParam(url, "search", search)
    url = appendQueryParam(url, "orderby", orderBy)
    url = appendQueryParam(url, "orderbyField", orderByField)
    url = appendQueryParam(url, "intern_group_id", internGroupId)
    url = appendQueryParam(url, "intern_sub_group_id", internSubGroupId)
    const result = await axios.get(url, commonHeaders)
    return result
}
export const downloadPsIndicatorList = async (currentLanguage) => {
    let result = await axios.get(
        `${DOAMIN_PATH}ps-indicator?language_id=${currentLanguage}`,
        commonHeaders
    )
    return result
}
export const downloadProductFormList = async (currentLanguage) => {
    let result = await axios.get(
        `${DOAMIN_PATH}product-from-code?language_id=${currentLanguage}`,
        commonHeaders
    )
    return result
}
export const downloadExceptionCodeList = async (currentLanguage) => {
    let result = await axios.get(
        `${DOAMIN_PATH}exception-code?language_id=${currentLanguage}`,
        commonHeaders
    )
    return result
}

export const downloadPriceDerivation = async (download) => {
    let { search, filter } = download
    let selectedFilter = ""
    if(filter?.articleName || filter?.articleNo ||
        filter?.eanNumber || filter?.materialClass || filter?.priceList ||
        filter?.saleOrg || filter?.typeNumber
    ) {
        Object.keys(filter).forEach((key) => {
            if (filter[key] && filter[key].length > 0) {
                const commaSeparatedFilterValues = filter[key].join(",")
                let filterKey = ""
                switch (key) {
                case "country":
                    filterKey = "country_id"
                    break
                case "salesOrg":
                    filterKey = "org_id"
                    break
                case "priceList":
                    filterKey = "pricelist_id"
                    break
                case "typeNumber":
                    filterKey = "type_id"
                    break
                case "materialClass":
                    filterKey = "material_class"
                    break
                case "articleName":
                    filterKey = "article_name"
                    break
                case "articleNo":
                    filterKey = "article_no"
                    break
                case "eanNumber":
                    filterKey = "part_id"
                    break
                }

                if (selectedFilter === "")
                    selectedFilter += `${filterKey}=${commaSeparatedFilterValues}`
                else
                    selectedFilter += `&${filterKey}=${commaSeparatedFilterValues}`
            }
            else {
                selectedFilter += ""
            }

        })
        let result = await axios.get(
            `${PRICING_DOMAIN_PATH}price-derivation?page=${1}&limit=${9999}&search=${search}&${selectedFilter}`,
            commonHeaders
        )
        return result
    }
    
}

export const downloadOriginalNOS = async (download) => {
    let { search, filter } = download
    let selectedFilter = ""
    if(filter?.articleName || filter?.articleNo ||
        filter?.eanNumber || filter?.materialClass || filter?.priceList ||
        filter?.saleOrg || filter?.typeNumber
    ) {
        Object.keys(filter).forEach((key) => {
            if (filter[key] && filter[key].length > 0) {
                const commaSeparatedFilterValues = filter[key].join(",")
                let filterKey = ""
                switch (key) {
                case "country":
                    filterKey = "country_id"
                    break
                case "salesOrg":
                    filterKey = "org_id"
                    break
                case "priceList":
                    filterKey = "pricelist_id"
                    break
                case "typeNumber":
                    filterKey = "type_id"
                    break
                case "materialClass":
                    filterKey = "material_class"
                    break
                case "articleName":
                    filterKey = "article_name"
                    break
                case "articleNo":
                    filterKey = "article_no"
                    break
                case "eanNumber":
                    filterKey = "part_id"
                    break
                }

                if (selectedFilter === "")
                    selectedFilter += `${filterKey}=${commaSeparatedFilterValues}`
                else
                    selectedFilter += `&${filterKey}=${commaSeparatedFilterValues}`
            }
            else {
                selectedFilter += ""
            }

        })
        let result = await axios.get(
            `${PRICING_DOMAIN_PATH}nos-price-derivation?page=${1}&limit=${9999}&search=${search}&${selectedFilter}`,
            commonHeaders
        )
        return result
    }
    
}

export const downloadExceptionApproverCodeList = async (currentLanguage) => {
    let result = await axios.get(
        `${DOAMIN_PATH}approver?language_id=${currentLanguage}`,
        commonHeaders
    )
    return result
}
export const downloadGgIndicatorList = async (currentLanguage) => {
    let result = await axios.get(
        `${DOAMIN_PATH}gg-indicator?language_id=${currentLanguage}`,
        commonHeaders
    )
    return result
}

export const downloadFailureCodeList = async (currentLanguage) => {
    let result = await axios.get(
        `${DOAMIN_PATH}failure-code?language_id=${currentLanguage}`,
        commonHeaders
    )
    return result
}
export const downloadActionCodeList = async (currentLanguage) => {
    let result = await axios.get(
        `${DOAMIN_PATH}action-code?language_id=${currentLanguage}`,
        commonHeaders
    )
    return result
}

export const downloadPriceMatrixList = async (column, customsearchtext, filter, order = "ASC") => {
    let selectedFilter = ""
    Object.keys(filter).forEach((key) => {
        if (filter[key].length > 0) {
            const commaSeparatedFilterValues = filter[key].join(",")
            let filterKey = ""
            switch (key) {
            case "priceList":
                filterKey = "price_list_id"
                break
            case "currency":
                filterKey = "currency_id"
                break
            case "brand":
                filterKey = "brand_id"
                break
            case "materialClass":
                filterKey = "material_class_id"
                break
            }

            if (selectedFilter === "")
                selectedFilter += `${filterKey}=${commaSeparatedFilterValues}`
            else
                selectedFilter += `&${filterKey}=${commaSeparatedFilterValues}`
        }
    })

    let result = await axios.get(
        `${PRICING_DOMAIN_PATH}price-matrix?orderbyField=${column}&orderby=${order}&search=${customsearchtext}&${selectedFilter}`,
        commonHeaders
    )
    return result
}

export const downloadPriceMatrixExceptionList = async (customsearchtext, filter) => {
    let selectedFilter = ""
    Object.keys(filter).forEach((key) => {
        if (filter[key].length > 0) {
            const commaSeparatedFilterValues = filter[key].join(",")
            let filterKey = ""
            switch (key) {
            case "priceList":
                filterKey = "price_list_id"
                break
            case "countryList":
                filterKey = "country_id"
                break
            case "typeNumberList":
                filterKey = "type_number_id"
                break
            case "materialClassList":
                filterKey = "material_class_id"
                break
            case "fpcList":
                filterKey = "product_id"
                break
            }

            if (selectedFilter === "")
                selectedFilter += `${filterKey}=${commaSeparatedFilterValues}`
            else
                selectedFilter += `&${filterKey}=${commaSeparatedFilterValues}`
        }
    })

    let result = await axios.get(
        `${PRICING_DOMAIN_PATH}price-matrix-exception?search=${customsearchtext}&${selectedFilter}`,
        commonHeaders
    )
    return result
}

/** 
 * getPartsSpecificOfType() // Get Parts Number of specific Type Number
 * @param {Number} id
 * @returns Objects
 */
export const getPartsSpecificOfType = async ({ queryKey }) => {
    const [, id, selectedLanguageId] = queryKey
    let result = await axios.get(
        `${PRODUCT_AND_PARTS}type-number/partsSpecificToType/${id}?language_id=${selectedLanguageId}`,
        commonHeaders
    )
    return result.data
}
export const getPartsSpecificOfFg = async ({ queryKey }) => {
    const [, id, selectedLanguageId] = queryKey
    let result = await axios.get(
        `${PRODUCT_AND_PARTS}finished-goods/partsSpecificToFinishedGoods/${id}?language_id=${selectedLanguageId}`,
        commonHeaders
    )
    return result.data
}
export const getCountrySpecificOfFg = async ({ queryKey }) => {
    const [, id] = queryKey
    let result = await axios.get(
        `${PRODUCT_AND_PARTS}fg-association-country/countries/${id}`,
        commonHeaders
    )
    return result.data
}

/** 
 * updateTypeNumber() // Edit Type Number - Get By ID
 * @param {Number} id
 * @param {Object} data
 * @returns Objects
 */

export const updateTypeNumber = async (id, data) => {
    let result = await axios.patch(
        `${PRODUCT_AND_PARTS}type-number/${id}`,
        data,
        commonHeaders
    )
    return result.data
}

/** 
 * updateComplaintsWithoutTechnicalDefects() // Edit Type Number - Get By ID
 * @param {Number} id
 * @param {Object} data
 * @returns Objects
 */

export const updateComplaintsWithoutTechnicalDefects = async (id, data) => {
    let result = await axios.patch(
        `${PRODUCT_AND_PARTS}add-examples-complaints/${id}`,
        data,
        commonHeaders
    )
    return result.data
}

export const getOrderingPartsList = async ({ queryKey }) => {
    const [_, serviceCenterID,customsearchtext,functiontype] = queryKey
    let functionCheck
    if (userType == 2) {
        functionCheck = functiontype[0]?.service_center_function?.includes("order") ? "" : "email"
    }
    else {
        let orderCheck = loggedInUserDetails?.service_center_details?.filter((orderItem) => { return orderItem?.function?.includes("order") })
        functionCheck = orderCheck?.length > 0 ? "" : "email"
    }
    let url = `${ORDER_MANAGEMENT}orders/get-part-by-org/${serviceCenterID}?search=${customsearchtext}`
    if (functionCheck !=="") {
        url += `${"&" + "function=" + functionCheck}`
    }
    let result = await axios.get(
        url,
        commonHeaders
    )
    return result.data
}

export const getPartsList = async ({ queryKey }) => {
    let result = await axios.get(
        `${PRODUCT_AND_PARTS}part-number `,
        commonHeaders
    )
    return result.data
}

export const getAllPartsNumbersInfo = async ({ queryKey }) => {
    let result = await axios.get(
        `${PRODUCT_AND_PARTS}part_number `,
        commonHeaders
    )
    return result.data
}

export const getMaterialClassList = async ({ queryKey }) => {
    try {
        let result = await axios.get(
            `${PRODUCT_AND_PARTS}material-class`,
            commonHeaders
        )
        return result.data
    } catch (error) {
        return error
    }
}

export const getProductLine = async ({ queryKey }) => {
    let result = await axios.get(
        `${PRODUCT_AND_PARTS}category`,
        commonHeaders
    )
    return result.data
}

export const createPartNumber = async (data) => {
    let result = await axios.post(
        `${PRODUCT_AND_PARTS}part-number`,
        data,
        commonHeaders
    )
    return result.data
}

export const getRegulatoryDocument = async ({ queryKey }) => {
    const [, country, language] = queryKey
    let url = `${KNOWLEDGE_DOMAIN_PATH}regulatorydocuments/${country}`
    if (language) {
        url += `${"?" + "locale=" + language}`
    }
    let result = await axios.get(url, commonHeaders)
    return result.data
}

export const getNewsListById = async ({ queryKey }) => {
    const [, id] = queryKey
    let url = `${KNOWLEDGE_DOMAIN_PATH}news/${id}`
    let result = await axios.get(url, generateCommonHeaders())
    return result.data
}

export const getNewsAndBulletinListById = async ({ queryKey }) => {
    const [, id, tabname, locale] = queryKey
    if (id && tabname && id != "" && tabname != "") {
        let url = `${KNOWLEDGE_DOMAIN_PATH}${tabname}/${id}?locale=${locale || "en-US"}`
        
        let result = await axios.get(url, generateCommonHeaders())
        return result.data
    }
}

export const getExtrasListById = async ({ queryKey }) => {
    const [, id, locale] = queryKey
    if (id  && id != "") {
        let url = `${KNOWLEDGE_DOMAIN_PATH}/extras/${id}?locale=${locale || "en-US"}`
        
        let result = await axios.get(url, generateCommonHeaders())
        return result.data
    }
}


export const getNewsListPageList = async ({ queryKey }) => {
    const [, page, limit, customsearchtext="", sortByFilterValue="", languageFilterValue=""] = queryKey
    let url = `${KNOWLEDGE_DOMAIN_PATH}news?`
    if (page && limit) {
        url += `${(url[url.length - 1] === "?" ? "" : "&") + "page=" + page}`
        url += `${(url[url.length - 1] === "?" ? "" : "&") + "limit=" + limit}`
    }
    if(languageFilterValue)
    {
        url += `${(url[url.length - 1] === "?" ? "" : "&") + "locale=" + languageFilterValue}`
    }
    if(sortByFilterValue){
        url += `${(url[url.length - 1] === "?" ? "" : "&") + "country=" + sortByFilterValue}`
    }
    if(customsearchtext) {
        url += `${(url[url.length - 1] === "?" ? "" : "&") + "text=" + customsearchtext}`
    }
    
    let result = await axios.get(url, commonHeaders)
    return result.data
}

export const getBulletinList = async () => {
    let url = `${KNOWLEDGE_DOMAIN_PATH}bulletin`
    let result = await axios.get(url, generateCommonHeaders())
    return result.data
}

export const getBulletinReadRecipientList = async ({ queryKey }) => {
    const [, page, limit, customsearchtext] = queryKey
    let url = `${KNOWLEDGE_DOMAIN_PATH}bulletin/readReceiptReport?`
    if (page && limit) {
        url += `${(url[url.length - 1] === "?" ? "" : "&") + "page=" + page}`
        url += `${(url[url.length - 1] === "?" ? "" : "&") + "limit=" + limit}`
    }
    if (customsearchtext) {
        url += `${(url[url.length - 1] === "?" ? "" : "&") + "text=" + customsearchtext}`
    }
    let result = await axios.get(url, generateCommonHeaders())
    return result.data
}


export const getBulletinListById = async ({ queryKey }) => {
    const [, id] = queryKey
    let url = `${KNOWLEDGE_DOMAIN_PATH}bulletin/${id}`
    let result = await axios.get(url, generateCommonHeaders())
    return result.data
}

export const getBulletinListPageList = async ({ queryKey }) => {
    const [, page, limit, customsearchtext="", sortByFilterValue="", languageFilterValue=""] = queryKey
    let url = `${KNOWLEDGE_DOMAIN_PATH}bulletin?`
   
    if (page && limit) {
        url = appendQueryParam(url, "page", page)
        url = appendQueryParam(url, "limit", limit)
    }
    if(languageFilterValue){
        url += `${(url[url.length - 1] === "?" ? "" : "&") + "locale=" + languageFilterValue}`
    }
    if(sortByFilterValue){
        url += `${(url[url.length - 1] === "?" ? "" : "&") + "category=" + sortByFilterValue}`
    }
    if(customsearchtext){
        url += `${(url[url.length - 1] === "?" ? "" : "&") + "text=" + customsearchtext}`
    }

    let result = await axios.get(url, commonHeaders)
    return result.data
}

export const updateReadRecipient = async (body) => {
    return await axios.post(
        `${KNOWLEDGE_DOMAIN_PATH}bulletin/markRead`,
        body,
        commonHeaders
    )
}

export const getPartDetails = async ({ queryKey }) => {
    const [, id] = queryKey
    let result = await axios.get(
        `${PRODUCT_AND_PARTS}part-number/${id}`,
        commonHeaders
    )
    return result.data
}

export const getpartOptionsBasedOnType = async ({ queryKey }) => {
    const [, id] = queryKey
    let result = await axios.get(
        `${PRODUCT_AND_PARTS}part-association-type/get-part-number-by-type-no/${id}`,
        commonHeaders
    )
    return result.data
}

export const updatePartDetails = async (id, body) => {
    let result = await axios.patch(
        `${PRODUCT_AND_PARTS}part-number/${id}`,
        body,
        commonHeaders
    )
    return result.data
}

export const getPartsArticleNumber = async ({ queryKey }) => {
    const [,filterByMaterialClass] = queryKey
 
    let url = `${PRODUCT_AND_PARTS}part-number?filterByMaterialClass=${filterByMaterialClass}`
    const result = await axios.get(url, commonHeaders)
    return result.data
}

export const getPartsListData = async ({ queryKey }) => {
    const [
        , page, limit, lang, customsearchtext, orderBy, orderByField,
        filterByMaterialClass, filterByProdLine, filterByActiveStatus
    ] = queryKey
    const buildUrl = (baseUrl, params) => {
        const queryString = new URLSearchParams(params).toString()
        return `${baseUrl}?${queryString}`
    }
    const params = {
        ...(page && { page }),
        ...(limit && { limit }),
        ...(lang && { language_id: lang }),
        ...(customsearchtext && { search: customsearchtext }),
        ...(orderBy && { orderby: orderBy }),
        ...(orderByField && { orderbyField: orderByField }),
        ...(filterByMaterialClass && { filterByMaterialClass }),
        ...(filterByProdLine && { filterByCategory: filterByProdLine }),
        ...(filterByActiveStatus && { filterByActive: filterByActiveStatus })
    }
    const url = buildUrl(`${PRODUCT_AND_PARTS}part-number`, params)
    const result = await axios.get(url, commonHeaders)
    return result.data
}

export const downloadPartsList = async (languageId, searchText,orderBy,orderByField, filterByMaterialClass, filterByProdLine, filterByActiveStatus) => {
    let url = `${PRODUCT_AND_PARTS}part-number?`
    url = appendQueryParam(url, "language_id", languageId)
    url = appendQueryParam(url, "search", searchText)
    url = appendQueryParam(url, "orderby", orderBy)
    url = appendQueryParam(url, "orderbyField", orderByField)
    url = appendQueryParam(url, "filterByMaterialClass", filterByMaterialClass)
    url = appendQueryParam(url, "filterByCategory", filterByProdLine)
    url = appendQueryParam(url, "filterByActive", filterByActiveStatus)
    let result = await axios.get(url, commonHeaders)
    return result
}

export const downloadFGAssociationCountryList = async (customsearchtext, orderBy, orderByField) => {
    let url = `${PRODUCT_AND_PARTS}fg-association-country?`

    if (customsearchtext) {
        url += `${(url[url.length - 1] === "?" ? "" : "&") + "search=" + customsearchtext
        }`
    }
    if (orderBy) {
        url += `${(url[url.length - 1] === "?" ? "" : "&") + "orderby=" + orderBy }`
    }
    if (orderByField) {
        url += `${(url[url.length - 1] === "?" ? "" : "&") + "orderbyField=" + orderByField }`
    }
    let result = await axios.get(url, commonHeaders)
    return result
}

export const getUseInstructionByTypeId = async ({ queryKey }) => {
    const [_, typeid, searchText, locale] = queryKey
    let url = `${KNOWLEDGE_DOMAIN_PATH}useinstructions/useinstruction`
    if (typeid) {
        url += `${"?" + "type_no=" + typeid}`
    }
    if (locale) {
        url += `${"&" + "locale=" + locale}`
    }
    if (searchText) {
        url += `${"&" + "filename=" + searchText}`
    }
    let result = await axios.get(
        url,
        commonHeaders
    )
    return result.data
}

export const getRepairInstructionByTypeId = async ({ queryKey }) => {
    const [, typeid, language] = queryKey
    let url = `${KNOWLEDGE_DOMAIN_PATH}repairinstructions/${typeid}`
    if (language) {
        url += `?locale=${language}`
    }
    let result = await axios.get(url, commonHeaders)
    return result.data
}
//part-typeNumber-association

export const getAssociatedPartNumbers = async ({ queryKey }) => {
    const [, page, limit, search,orderBy,orderByField, filterByTypeNumber, filterByMaterialClass, languageId] = queryKey
    let url = `${PRODUCT_AND_PARTS}part-association-type?`
    if (page && limit) {
        url = appendQueryParam(url, "page", page)
        url = appendQueryParam(url, "limit", limit)
    }
    url = appendQueryParam(url, "search", search)
    url = appendQueryParam(url, "orderby", orderBy)
    url = appendQueryParam(url, "orderbyField", orderByField)
    url = appendQueryParam(url, "filterByTypeNumber", filterByTypeNumber)
    url = appendQueryParam(url, "filterByMaterialClass", filterByMaterialClass)
    url = appendQueryParam(url, "language_id", languageId)
    if(filterByTypeNumber !==""){
        const result = await axios.get(url, commonHeaders)
        return await result.data
    }
}

export const updateAssociatePartToTypeApi = async (updatedData) => {
    const response = await axios.patch(
        `${PRODUCT_AND_PARTS}part-association-type/${updatedData.id}`,
        updatedData,
        commonHeaders
    )
    return response.data
}

export const updateTranslateRecordsPartsToType = async (updatedData) => {
    const response = await axios.post(
        `${PRODUCT_AND_PARTS}part-association-type/translations/${updatedData?.id}`,
        { language: updatedData?.languageRecords },
        commonHeaders
    )
    return response.data
}

// Create Associate Type
export const createPartTypeAssociationApi = async (updatedData) => {
    const response = await axios.post(
        `${PRODUCT_AND_PARTS}part-association-type`,
        updatedData,
        commonHeaders
    )
    return response.data
}

//get all type numebrs api
export const getTypeNumbersList = async ({ queryKey }) => {
    const [_, filterByLang] = queryKey
    let result = await axios.get(`${PRODUCT_AND_PARTS}part-association-type/getPartAssociationTypeInfo
?language_id=${filterByLang}`, commonHeaders)
    return result.data
}

export const getProductSearchResult = async ({ queryKey }) => {
    const [_, inputSearchText, orderBy, orderByField,languageId] = queryKey
    let url = `${PRODUCT_AND_PARTS}product-catalogue/search?`
    if (inputSearchText) {
        url += `${(url[url.length - 1] === "?" ? "" : "&") + "search=" + inputSearchText}`
    }
    if (orderBy) {
        url += `${(url[url.length - 1] === "?" ? "" : "&") + "orderby=" + orderBy
        }`
    }
    if (orderByField) {
        url += `${(url[url.length - 1] === "?" ? "" : "&") + "orderbyField=" + orderByField
        }`
    }
    if (languageId) {
        url += `${(url[url.length - 1] === "?" ? "" : "&") + "languageId=" + languageId}`
    }
    const result = await axios.get(url, commonHeaders)
    return result.data
    
}

export const getTranslateRecordsPartsToType = async ({ queryKey }) => {
    const [, associateId] = queryKey
    let result = await axios.get(`${PRODUCT_AND_PARTS}part-association-type/translations/${associateId}
`, commonHeaders)
    return result.data
}

// Delete Associate Part of Type
export async function deletAssociatepartOfType(id) {
    try {
        const result = await axios.delete(
            `${PRODUCT_AND_PARTS}part-association-type?Id=${id}`,
            commonHeaders
        )
        return await result.data
    } catch (error) {
        return error
    }
}

export const downloadAssociatePartToType = async (search,orderBy,orderByField, filterByTypeNumber, filterByMaterialClass, languageId) => {
    let url = `${PRODUCT_AND_PARTS}part-association-type?`
    url = appendQueryParam(url, "search", search)
    url = appendQueryParam(url, "orderby", orderBy)
    url = appendQueryParam(url, "orderbyField", orderByField)
    url = appendQueryParam(url, "filterByTypeNumber", filterByTypeNumber)
    url = appendQueryParam(url, "filterByMaterialClass", filterByMaterialClass)
    url = appendQueryParam(url, "language_id", languageId)
    const result = await axios.get(url, commonHeaders)
    return result
}
export const getGeneralExtraInstruction = async ({ queryKey }) => {
    const [, page, limit] = queryKey
    let url = `${KNOWLEDGE_DOMAIN_PATH}generalextrainstructions?`

    if (page && limit) {
        url += `${(url[url.length - 1] === "?" ? "" : "&") + "page=" + page}`
        url += `${(url[url.length - 1] === "?" ? "" : "&") + "limit=" + limit}`
    }
    let result = await axios.get(
        url,
        commonHeaders
    )
    return result.data
}

export const getBulletinByTypeNo = async ({ queryKey }) => {
    const [, typeno, language] = queryKey
    let url = `${KNOWLEDGE_DOMAIN_PATH}bulletin/typeNo/${typeno}?locale=${language || "en-US"}`
   
    let result = await axios.get(url, generateCommonHeaders())
    return result.data
}

export const getExtrasByTypeNo = async ({ queryKey }) => {
    const [, typenoExtra, language] = queryKey
    let url = `${KNOWLEDGE_DOMAIN_PATH}extras/typeNo/${typenoExtra}?locale=${language || "en-US"}`
   
    let result = await axios.get(url, generateCommonHeaders())
    return result.data
}
export async function deleteComplaintsWithoutTechnicalDefects(id) {
    try {
        const result1 = await axios.delete(
            `${PRODUCT_AND_PARTS}add-examples-complaints/${id}`,
            commonHeaders
        )
        return await result1.data
    } catch (error) {
        return error
    }
}

// uploader API

export const getUplodedDetailsByModule = async ({ queryKey }) => {
    const [, module,lastViewDays,customerNumber] = queryKey
    if (!module) {
        return []
    }
    let url = `${DOAMIN_PATH}common/upload/details/${module}?`
    if (lastViewDays) {
        url += `${url[url.length - 1] === "?" ? "" : "&"}days=${lastViewDays}`
    }
    if (customerNumber) {
        url += `${url[url.length - 1] === "?" ? "" : "&"}entityId=${customerNumber}`
    }
    let result = await axios.get(url, generateCommonHeaders())
    return result.data
}

export const getUplodedDetailsByModuleV2 = async ({ queryKey }) => {
    const [, module, viewPerPages,serviceCenterId] = queryKey
    if (!module) {
        return []
    }
    let url = `${UPLOAD_PATH}upload?module=${module}&days=${viewPerPages}`
    if(serviceCenterId){
        url =  `${UPLOAD_PATH}upload?module=${module}&days=${viewPerPages}&entityId=${serviceCenterId}`
    }
    let result = await axios.get(url, generateCommonHeaders())
    return result.data
}

export const bindOrderUpload = async () => {
    let url = `${ORDER_MANAGEMENT}orders/bind-order-upload`
    let result = await axios.get(url, generateCommonHeaders())
    return result.data
}

export const saveUploadedData = async (fileData) => {
    const headers = { ...commonHeaders }
    headers["Content-Type"] = "multipart/form-data"
    const response = await axios.post(
        `${DOAMIN_PATH}common/upload`,
        fileData,
        headers
    )
    return response.data
}

export const saveUploadedDataV2 = async (fileData) => {
    const headers = { ...commonHeaders }
    headers["Content-Type"] = "multipart/form-data"
    const response = await axios.post(
        `${UPLOAD_PATH}upload`,
        fileData,
        headers
    )
    return response.data
}

//Service Material Association 

export const getServiceMaterialAssociationListView = async ({ queryKey }) => {

    const [_, is_dropdown, language_id] = queryKey

    if (!language_id) {
        return []
    }
    let url = `${DOAMIN_PATH}service-materials?`
    if (is_dropdown) {
        url += `${url[url.length - 1] === "?" ? "" : "&"}is_dropdown=${is_dropdown}`
    }
    if (language_id) {
        url += `${url[url.length - 1] === "?" ? "" : "&"}language_id=${language_id}`
    }
    let result = await axios.get(url, commonHeaders)
    return result.data
}

export const downloadServiceMaterialAssociationList = async (currentLanguage, customSearch) => {
    let url = `${DOAMIN_PATH}service-materials?`
    if (!currentLanguage) {
        return []
    }
    url += `&language_id=${currentLanguage}`
    if (customSearch) {
        url += `&search=${customSearch}`
    }
    let result = await axios.get(url, commonHeaders)
    return result.data
}

export const createServiceMaterialAssociationList = async (body) => {
    if (body) {
        body.tenant_id = 1
    }
    let result = await axios.post(
        `${DOAMIN_PATH}service-materials`,
        body,
        commonHeaders
    )
    return result.data
}

export const getArticleDetails = async ({ queryKey }) => {
    try {
        const [, typeIds] = queryKey
        if (typeIds.length) {
            const commaSeparatedTypeIds = typeIds.join(",")
            let result = await axios.get(`${PRODUCT_AND_PARTS}type-number/articleDetails?type_ids=${commaSeparatedTypeIds}`, commonHeaders)
            return result.data
        }
        else
            return {}
    } catch (error) {
        return error
    }
}

export const getAllPriceDrivation = async ({ queryKey }) => {
    const [, page, limit, customsearchtext, filter] = queryKey
    let selectedFilter = ""
    
    if (filter.priceList.length > 0 && page && limit) {
        Object.keys(filter).forEach((key) => {           
            if (filter[key].length > 0) {
                const commaSeparatedFilterValues = filter[key].join(",")
                let filterKey = ""
                switch (key) {                    
                case "country":
                    filterKey = "country_id"
                    break
                case "salesOrg":
                    filterKey = "org_id"
                    break
                case "priceList":
                    filterKey = "pricelist_id"
                    break
                case "typeNumber":
                    filterKey = "type_id"
                    break
                case "materialClass":
                    filterKey = "material_class"
                    break
                case "articleName":
                    filterKey = "article_name"
                    break
                case "articleNo":
                    filterKey = "part_id"
                    break
                case "eanNumber":
                    filterKey = "ean"
                    break
                case "duplicate":
                    filterKey = "duplicate"
                    break
                }

                if (selectedFilter === "")
                    selectedFilter += `${filterKey}=${commaSeparatedFilterValues}`
                else
                    selectedFilter += `&${filterKey}=${commaSeparatedFilterValues}`
            }
            else if(filter?.duplicate && key === "duplicate") {
                selectedFilter += `&duplicate=${filter?.duplicate}`
            } else {
                selectedFilter += ""
            }

        })
        let result = await axios.get(
            `${PRICING_DOMAIN_PATH}price-derivation?page=${page}&limit=${limit}&search=${customsearchtext}&${selectedFilter}`,
            commonHeaders
        )
        return result.data
    }
    else {
        return {}
    }
}

export const getOriginalNos = async ({ queryKey }) => {
    const [, page, limit, customsearchtext, filter] = queryKey
    let selectedFilter = ""
    if (filter.priceList.length > 0 && page && limit) {
        Object.keys(filter).forEach((key) => {
            if (filter[key].length > 0) {
                const commaSeparatedFilterValues = filter[key].join(",")
                let filterKey = ""
                switch (key) {
                case "country":
                    filterKey = "country_id"
                    break
                case "salesOrg":
                    filterKey = "org_id"
                    break
                case "priceList":
                    filterKey = "pricelist_id"
                    break
                case "typeNumber":
                    filterKey = "type_id"
                    break
                case "materialClass":
                    filterKey = "material_class"
                    break
                case "articleName":
                    filterKey = "article_name"
                    break
                case "articleNo":
                    filterKey = "part_id"
                    break
                case "eanNumber":
                    filterKey = "ean"
                    break
                }

                if (selectedFilter === "")
                    selectedFilter += `${filterKey}=${commaSeparatedFilterValues}`
                else
                    selectedFilter += `&${filterKey}=${commaSeparatedFilterValues}`
            }
            else {
                selectedFilter += ""
            }

        })
        let result = await axios.get(
            `${PRICING_DOMAIN_PATH}nos-price-derivation?page=${page}&limit=${limit}&search=${customsearchtext}&${selectedFilter}`,
            commonHeaders
        )
        return result.data
    }
    else {
        return {}
    }
}

export const createServiceMaterialAssociationSalesOrg = async (body) => {
    let result = await axios.post(
        `${DOAMIN_PATH}service-materials/association`,
        body,
        commonHeaders
    )
    return result.data
}

export const createServiceMaterialAssociationTranslations = async (body, id) => {
    let result = await axios.post(
        `${DOAMIN_PATH}service-materials/translation/${id}`,
        body,
        commonHeaders
    )
    return result.data
}

export const getMaterialIds = async () => {
    // let result = await axios.get(`${DOAMIN_PATH}country`, commonHeaders)
    // return result.data
    return [
        {
            "id": 1,
            "material": "0081284193"
        }
    ]
}

export const getMaterialCategories = async () => {
    let result = await axios.get(`${DOAMIN_PATH}material-category/categories`, commonHeaders)
    return result.data
}

export const getCurrencyBySalesOrgId = async ({ queryKey }) => {
    const [, salesOrgId] = queryKey
    if (salesOrgId) {
        let result = await axios.get(`${DOAMIN_PATH}common/currencyPriceListSalesOrgs/${salesOrgId}`, commonHeaders)
        return result.data
    }
}

export const getServiceMaterialAssociationDetails = async ({ queryKey }) => {
    const [, materialId] = queryKey
    if (!materialId) {
        return
    }
    let url = `${DOAMIN_PATH}service-materials/${materialId}`
    let result = await axios.get(url, commonHeaders)
    return result.data
}

export const updateServiceMatrialAssociations = async (body) => {
    let result = await axios.patch(
        `${DOAMIN_PATH}service-materials/association/update`,
        body,
        commonHeaders
    )
    return result.data
}

//TroubleShoot


export const createBlockTypeNoToCountry = async (data) => {
    let result = await axios.post(
        `${PRODUCT_AND_PARTS}type-country-block`,
        data,
        commonHeaders
    )
    return result.data
}

export const getTypeCountryBlock = async ({ queryKey }) => {
    const [, page, limit, customsearchtext,orderBy,orderByField] = queryKey
    let url = `${PRODUCT_AND_PARTS}type-country-block?`
    if (page && limit) {
        url += `${(url[url.length - 1] === "?" ? "" : "&") + "page=" + page}`
        url += `${(url[url.length - 1] === "?" ? "" : "&") + "limit=" + limit}`
    }
    if (customsearchtext) {
        url += `${(url[url.length - 1] === "?" ? "" : "&") + "search=" + customsearchtext
        }`
    }
    if (orderBy) {
        url += `${(url[url.length - 1] === "?" ? "" : "&") + "orderby=" + orderBy }`
    }
    if (orderByField) {
        url += `${(url[url.length - 1] === "?" ? "" : "&") + "orderbyField=" + orderByField }`
    }
    let result = await axios.get(url, generateCommonHeaders())
    return result.data
}

export async function deletBlockType(id) {
    try {
        let result = await axios.delete(
            `${PRODUCT_AND_PARTS}type-country-block/${id}`,
            commonHeaders
        )
        return result.data
    } catch (error) {
        return error
    }
}

export const getBulletinCountryBlock = async ({ queryKey }) => {
    const [, page, limit, customsearchtext,orderBy,orderByField] = queryKey
    let url = `${PRODUCT_AND_PARTS}bulletin-country-block?`
    if (page && limit) {
        url += `${(url[url.length - 1] === "?" ? "" : "&") + "page=" + page}`
        url += `${(url[url.length - 1] === "?" ? "" : "&") + "limit=" + limit}`
    }
    if (customsearchtext) {
        url += `${(url[url.length - 1] === "?" ? "" : "&") + "search=" + customsearchtext
        }`  
    }
    if (orderBy) {
        url += `${(url[url.length - 1] === "?" ? "" : "&") + "orderby=" + orderBy }`
    }
    if (orderByField) {
        url += `${(url[url.length - 1] === "?" ? "" : "&") + "orderbyField=" + orderByField }`
    }
    let result = await axios.get(url, generateCommonHeaders())
    return result.data
}

export const createBlockBullitenToCountry = async (data) => {
    let result = await axios.post(
        `${PRODUCT_AND_PARTS}bulletin-country-block`,
        data,
        commonHeaders
    )
    return result.data
}

export async function deletBlockBulletin(id) {

    try {
        let result = await axios.delete(
            `${PRODUCT_AND_PARTS}bulletin-country-block/${id}`,
            commonHeaders
        )
        return result.data
    } catch (error) {
        return error
    }
}

export const downloadBlockBullitenOrType = async (type, customsearchtext,orderBy,orderByField) => {
    let url = null
    if (type === "typeNo") {
        url = `${PRODUCT_AND_PARTS}type-country-block?`
    } else {
        url = `${PRODUCT_AND_PARTS}bulletin-country-block?`
    }
    if (customsearchtext) {
        url += `${(url[url.length - 1] === "?" ? "" : "&") + "search=" + customsearchtext
        }`
    }
    if (orderBy) {
        url += `${(url[url.length - 1] === "?" ? "" : "&") + "orderby=" + orderBy
        }`
    }
    if (orderByField) {
        url += `${(url[url.length - 1] === "?" ? "" : "&") + "orderbyField=" + orderByField
        }`
    }
    let result = await axios.get(url, commonHeaders)
    return result?.data
}

export const getFGCountryListData = async ({ queryKey }) => {
    const [, page, limit, customsearchtext, orderBy, orderByField, filter] = queryKey

    const buildUrl = (baseUrl, params) => {
        const queryString = new URLSearchParams(params).toString()
        return `${baseUrl}?${queryString}`
    }

    const getFilterParams = (filter) => {
        const filterParams = {}

        Object.keys(filter).forEach((key) => {
            if (filter[key].length > 0) {
                filterParams[key] = filter[key].join(",")
            }
        })

        return filterParams
    }

    const params = {
        ...(page && { page }),
        ...(limit && { limit }),
        ...(customsearchtext && { search: customsearchtext }),
        ...(orderBy && { orderby: orderBy }),
        ...(orderByField && { orderbyField: orderByField }),
        ...getFilterParams(filter)
    }

    const url = buildUrl(`${PRODUCT_AND_PARTS}fg-association-country`, params)

    const result = await axios.get(url, commonHeaders)
    return result.data
}

export const createAssociationFGWithCountry = async (data) => {
    let result = await axios.post(
        `${PRODUCT_AND_PARTS}fg-association-country`,
        data,
        commonHeaders
    )
    return result.data
}

export const getTroubleShootCategories = async ({ queryKey }) => {
    const [_, page, limit, typeNo, globalLang] = queryKey
    let globalLangData = globalLang == "en" ? "en-US" : globalLang
    let url = `${KNOWLEDGE_DOMAIN_PATH}troubleshooting/categories?`
    if (page && limit && globalLangData) {
        url += `${(url[url.length - 1] === "?" ? "" : "&") + "page=" + page}`
        url += `${(url[url.length - 1] === "?" ? "" : "&") + "limit=" + limit}`
        url += `${(url[url.length - 1] === "?" ? "" : "&") + "locale=" + globalLangData}`
    } 
    if (typeNo) {
        url += `${(url[url.length - 1] === "?" ? "" : "&") + "typeno=" + typeNo}`
    }
    let result = await axios.get(url, generateCommonHeaders())
    return result?.data
}

export const getTroubleShootCategoriesByName = async ({ queryKey }) => {
    const [, page, limit, typeNo, categoryName, locale, irisCodeId] = queryKey

    const buildUrl = (baseUrl, params) => {
        const queryString = new URLSearchParams(params).toString()
        return `${baseUrl}?${queryString}`
    }

    const params = {
        ...(page && { page }),
        ...(limit && { limit }),
        ...(typeNo && { typeno: typeNo }),
        ...(categoryName && { category: categoryName }),
        ...(locale && { locale: locale === "en" ? "en-US" : locale }),
        ...(irisCodeId && { irisCodeId })
    }

    const url = buildUrl(`${KNOWLEDGE_DOMAIN_PATH}troubleshooting`, params)

    const result = await axios.get(url, generateCommonHeaders())
    return result?.data
}

export const getTroubleShootCategoriesById = async (page, limit, typeNo, categoryName, locale, irisCodeId ) => {
    let url = `${KNOWLEDGE_DOMAIN_PATH}troubleshooting?`
    if (page && limit) {
        url = appendQueryParam(url, "page", page)
        url = appendQueryParam(url, "limit", limit)
    }
    url = appendQueryParam(url, "typeno", typeNo)
    url = appendQueryParam(url, "category", categoryName)
    url = appendQueryParam(url, "irisCodeId", irisCodeId)
    if (locale) {
        let lc = locale === "en" ? "en-US" : locale
        url = appendQueryParam(url, "locale", lc)
    }
    let result = await axios.get(url, generateCommonHeaders())
    return result?.data
}

export async function getServiceMaterialCategoryList() {
    let result = await axios.get(`${DOAMIN_PATH}material-category/categories`, commonHeaders)
    return result.data
}

export async function createAssociationForServiceMaterial(data, type) {
    let url = `${DOAMIN_PATH}service-material-association`
    if (type === "TypeNoAndActionCode") {
        url = `${DOAMIN_PATH}service-material-association`
    }

    try {
        const result = await axios.post(
            url,
            data,
            commonHeaders
        )
        return await result.data
    } catch (error) {
        return error
    }
}

export async function updateAssociationForServiceMaterial(id, data) {
    try {
        const result = await axios.patch(
            `${DOAMIN_PATH}service-material-association/${id}`,
            data,
            commonHeaders
        )
        return await result.data
    } catch (error) {
        return error
    }
}

export async function deleteAssociationForServiceMaterial(id) {
    try {
        const result = await axios.delete(
            `${DOAMIN_PATH}service-material-association/${id}`,
            commonHeaders
        )
        return await result.data
    } catch (error) {
        return error
    }
}

export const downloadServiceMaterialAssociation = async (search, filter) => {
    let url = `${DOAMIN_PATH}service-material-association?`
    url = appendQueryParam(url, "search", search)
    if (Object.keys(filter).length > 0) {
        url = appendQueryParam(url, "organization_id", filter?.sales_org_id?.value)
        url = appendQueryParam(url, "action_code", filter?.action_code_id?.value)
        url = appendQueryParam(url, "category_id", filter?.category_id?.value)
        url = appendQueryParam(url, "service_material_id", filter?.service_material_id?.value)
        url = appendQueryParam(url, "type_id", filter?.type_number_id?.value)
        if (filter?.startDate) {
            url += `${url[url.length - 1] === "?" ? "" : "&"}valid_from=${onlyDateFormate(filter.startDate)
            }`
        }
        if (filter?.endDate) {
            url += `${url[url.length - 1] === "?" ? "" : "&"}valid_to=${onlyDateFormate(filter.endDate)
            }`
        }
    }
    const result = await axios.get(url, commonHeaders)
    return result
}

export const getServiceMaterialAssociation = async ({ queryKey }) => {
    const [, page, limit, search, filter] = queryKey
    let url = `${DOAMIN_PATH}service-material-association?`
    if (page && limit) {
        url = appendQueryParam(url, "page", page)
        url = appendQueryParam(url, "limit", limit)
    }
    url = appendQueryParam(url, "search", search)
    if (Object.keys(filter).length > 0) {
        url = appendQueryParam(url, "organization_id", filter?.sales_org_id?.value)
        url = appendQueryParam(url, "action_code", filter?.action_code_id?.value)
        url = appendQueryParam(url, "category_id", filter?.category_id?.value)
        url = appendQueryParam(url, "service_material_id", filter?.service_material_id?.value)
        url = appendQueryParam(url, "type_id", filter?.type_number_id?.value)
        if (filter?.startDate) {
            url += `${url[url.length - 1] === "?" ? "" : "&"}valid_from=${onlyDateFormate(filter.startDate)
            }`
        }
        if (filter?.endDate) {
            url += `${url[url.length - 1] === "?" ? "" : "&"}valid_to=${onlyDateFormate(filter.endDate)
            }`
        }
    }
    const result = await axios.get(url, commonHeaders)
    return await result.data
}

export const getServiceMaterialAssociationList = async ({ queryKey }) => {
    let result = await axios.get(`${DOAMIN_PATH}service-material-association`, commonHeaders)
    return result.data
}

export const getServiceMaterialsList = async ({ queryKey }) => {
    const [, page, limit, lang, search] = queryKey
    let url = `${DOAMIN_PATH}service-materials?`
    if (page && limit) {
        url += `${(url[url.length - 1] === "?" ? "" : "&") + "page=" + page}`
        url += `${(url[url.length - 1] === "?" ? "" : "&") + "limit=" + limit}`
    }
    if (lang) {
        url += `${(url[url.length - 1] === "?" ? "" : "&") + "language_id=" + lang}`
    }
    if (search) {
        url += `${(url[url.length - 1] === "?" ? "" : "&") + "search=" + search}`
    }
    let result = await axios.get(url, commonHeaders)
    return result.data?.data || []
}

export async function getArticleSeriesList({ queryKey }) {
    const [, page, limit, search, orderBy, orderByField] = queryKey
    let url = `${PRODUCT_AND_PARTS}product-article-series?`
    if (page && limit) {
        url += `${(url[url.length - 1] === "?" ? "" : "&") + "page=" + page}`
        url += `${(url[url.length - 1] === "?" ? "" : "&") + "limit=" + limit}`
    }
    if (search) {
        url += `${(url[url.length - 1] === "?" ? "" : "&") + "search=" + search}`
    }
    if (orderBy) {
        url += `${(url[url.length - 1] === "?" ? "" : "&") + "orderby=" + orderBy }`
    }
    if (orderByField) {
        url += `${(url[url.length - 1] === "?" ? "" : "&") + "orderbyField=" + orderByField }`
    }
    const result1 = await axios.get(url, commonHeaders)
    return await result1.data
}

export async function getInventoryStatusList({ queryKey }) {
    const [, page, limit, filterByPartNumber, filterByMaterialClass, search] = queryKey
    let url = `${ORDER_MANAGEMENT}inventory/inventory-status?`
    if (search) {
        url += `${(url[url.length - 1] === "?" ? "" : "&") + "search=" + search}`
    }
    if (page && limit) {
        url += `${(url[url.length - 1] === "?" ? "" : "&") + "page=" + page}`
        url += `${(url[url.length - 1] === "?" ? "" : "&") + "limit=" + limit}`
    }

    if (filterByPartNumber) {
        url += `${(url[url.length - 1] === "?" ? "" : "&") + "partNumber=" + filterByPartNumber}`
    }
    if (filterByMaterialClass) {
        url += `${(url[url.length - 1] === "?" ? "" : "&") + "materialClass=" + filterByMaterialClass}`
    }
    const result1 = await axios.get(url, commonHeaders)
    return await result1.data
}

export async function downloadArticleSeries(search) {
    try {
        let url = `${PRODUCT_AND_PARTS}product-article-series?`
        if (search) {
            url += `${(url[url.length - 1] === "?" ? "" : "&") + "search=" + search}`
        }
        const result = await axios.get(url, commonHeaders)
        return result
    } catch (error) {
        return error
    }
}


export async function createArticle(data) {
    try {
        const result1 = await axios.post(
            `${PRODUCT_AND_PARTS}product-article-series`,
            data,
            commonHeaders
        )
        return await result1.data
    } catch (error) {
        return error
    }
}

export async function updateArticleSeries(id, data) {
    try {
        const result1 = await axios.patch(
            `${PRODUCT_AND_PARTS}product-article-series/${id}`,
            data,
            commonHeaders
        )
        return await result1.data
    } catch (error) {
        return error
    }
}

export async function deleteArticleSeries(id) {
    try {
        const result1 = await axios.delete(
            `${PRODUCT_AND_PARTS}product-article-series/${id}`,
            commonHeaders
        )
        return await result1.data
    } catch (error) {
        return error
    }
}

export const getProductLifecycleStatusList = async ({ queryKey }) => {
    const [_, page, limit, search, filterBySalesOrg, filterByPartNo, filterByActiveStatus, filterByManualFlag,orderBy, orderByField,filterByLang] = queryKey
    let url = `${PRODUCT_AND_PARTS}product-lifecycle?`
    if (page && limit && filterByLang) {
        url = appendQueryParam(url, "page", page)
        url = appendQueryParam(url, "limit", limit)
        url = appendQueryParam(url, "languageId", filterByLang)
    }
    url = appendQueryParam(url, "search", search)
    url = appendQueryParam(url, "VKORG", filterBySalesOrg)
    url = appendQueryParam(url, "MATNR", filterByPartNo)
    url = appendQueryParam(url, "STATUS", filterByActiveStatus)
    url = appendQueryParam(url, "MANUAL_STATUS", filterByManualFlag)
    url = appendQueryParam(url, "orderby", orderBy)
    url = appendQueryParam(url, "orderbyField", orderByField)
    const result1 = await axios.get(url, commonHeaders)
    return await result1.data
}

export async function downloadLifeCycleStatusList(
    search, filterBySalesOrg, filterByPartNo, filterByActiveStatus, filterByManualFlag, orderBy, orderByField
) {
    try {
        const params = new URLSearchParams()

        const addParam = (key, value) => {
            if (value) params.append(key, value)
        }

        addParam("search", search)
        addParam("VKORG", filterBySalesOrg)
        addParam("MATNR", filterByPartNo)
        addParam("STATUS", filterByActiveStatus)
        addParam("MANUAL_STATUS", filterByManualFlag)
        addParam("orderby", orderBy)
        addParam("orderbyField", orderByField)

        const url = `${PRODUCT_AND_PARTS}product-lifecycle?${params.toString()}`

        const result = await axios.get(url, commonHeaders)
        return result
    } catch (error) {
        return error
    }
}


export async function deleteProductLifecycle(id) {
    try {
        const result1 = await axios.delete(
            `${PRODUCT_AND_PARTS}product-lifecycle/${id}`,
            commonHeaders
        )
        return await result1.data
    } catch (error) {
        return error
    }
}

export async function getAddExamplesComplaintsByCatId({ queryKey }) {
    const [,page, limit, category_id, groomingGrp, languageId, internSubGroup] = queryKey
    let categoryId = (groomingGrp === "M" && category_id === 2) ? 1 : category_id
    let url = ""
    if(internSubGroup){
        url = `${PRODUCT_AND_PARTS}add-examples-complaints?page=${page}&limit=${limit}&intern_group_id=${categoryId}&grooming_grp=${groomingGrp}&language_id=${languageId}&intern_sub_group_id=${internSubGroup}`
    } else {
        url = `${PRODUCT_AND_PARTS}add-examples-complaints?page=${page}&limit=${limit}&intern_group_id=${categoryId}&grooming_grp=${groomingGrp}&language_id=${languageId}`
    }
    const result1 = await axios.get(url, commonHeaders)
    return await result1.data
}

export async function getProductCategory() {
    let url = `${PRODUCT_AND_PARTS}category`
    const result = await axios.get(url, commonHeaders)
    return await result.data
}

export async function getProductOnSubCategoryList({ queryKey }) {
    const [, page, limit, languageId, customsearchtext, filterBySubCategory, orderBy, orderByField] = queryKey

    const buildUrl = (baseUrl, params) => {
        const queryString = new URLSearchParams(params).toString()
        return `${baseUrl}?${queryString}`
    }

    const params = {
        ...(page && limit && { page, limit }),
        ...(languageId && { languageId }),
        ...(customsearchtext && { search: customsearchtext }),
        ...(orderBy && { orderby: orderBy }),
        ...(orderByField && { orderbyField: orderByField })
    }

    const url = buildUrl(`${PRODUCT_AND_PARTS}product-catalogue/type-data/${filterBySubCategory}`, params)

    const result = await axios.get(url, commonHeaders)
    return result.data
}

export async function getOverviewOnTypeNumber({ queryKey }) {
    const [, page, limit, languageId, customsearchtext, countryId,
        filterBySubCategory,
        orderBy, orderByField] = queryKey

    const buildUrl = (baseUrl, params) => {
        const queryString = new URLSearchParams(params).toString()
        return `${baseUrl}?${queryString}`
    }

    const params = {
        ...(page && { page }),
        ...(limit && { limit }),
        ...(languageId && { languageId }),
        ...(countryId && { countryId }),
        ...(customsearchtext && { search: customsearchtext }),
        ...(orderBy && { orderby: orderBy }),
        ...(orderByField && { orderbyField: orderByField })
    }

    const url = buildUrl(`${PRODUCT_AND_PARTS}product-catalogue/overview/${filterBySubCategory}`, params)

    const result = await axios.get(url, commonHeaders)
    return result.data
}

export const downloadOverViewProductList = async (languageId, countryId, currentTypeNoSpecific,orderBy,orderByField) => {
    let url= `${PRODUCT_AND_PARTS}product-catalogue/overview/${currentTypeNoSpecific}?countryId=${countryId}&languageId=${languageId}`
    if (orderBy) {
        url += `${(url[url.length - 1] === "?" ? "" : "&") + "orderby=" + orderBy
        }`
    }
    if(orderByField) {
        url += `${(url[url.length - 1] === "?" ? "" : "&") + "orderbyField=" + orderByField
        }`
    }
    let result = await axios.get(url,commonHeaders)
    return result
}


export const getRegulatoryDocsList = async ({ queryKey }) => {
    const [, page, limit, customsearchtext, languageFilterValue] = queryKey
    let url = `${KNOWLEDGE_DOMAIN_PATH}regulatorydocuments/Germany?`
    if (page && limit) {
        url += `${(url[url.length - 1] === "?" ? "" : "&") + "page=" + page}`
        url += `${(url[url.length - 1] === "?" ? "" : "&") + "limit=" + limit}`
    }
    if (languageFilterValue) {
        url += `${(url[url.length - 1] === "?" ? "" : "&") + "locale=" + languageFilterValue}`
    }
    if (customsearchtext) {
        url += `${(url[url.length - 1] === "?" ? "" : "&") + "search=" + customsearchtext}`
    }

    let result = await axios.get(url, commonHeaders)
    return result.data
}

export const getRegulatoryDocumentById = async ({ queryKey }) => {
    const [, id, language] = queryKey
    let url = `${KNOWLEDGE_DOMAIN_PATH}regulatorydocuments/id/${id}`
    if (language) {
        url += `${"?" + "locale=" + language}`
    }
    let result = await axios.get(url, commonHeaders)
    return result.data
}

export const getGeneralExtraInstructionDocsList = async ({ queryKey }) => {
    const [, page, limit, customsearchtext, languageFilterValue] = queryKey
    let url = `${KNOWLEDGE_DOMAIN_PATH}generalextrainstructions?`
    if (page && limit) {
        url += `${(url[url.length - 1] === "?" ? "" : "&") + "page=" + page}`
        url += `${(url[url.length - 1] === "?" ? "" : "&") + "limit=" + limit}`
    }
    if (languageFilterValue) {
        url += `${(url[url.length - 1] === "?" ? "" : "&") + "locale=" + languageFilterValue}`
    }
    if (customsearchtext) {
        url += `${(url[url.length - 1] === "?" ? "" : "&") + "search=" + customsearchtext}`
    }

    let result = await axios.get(url, commonHeaders)
    return result.data
}

export const getGeneralExtraInstructionDocumentById = async ({ queryKey }) => {
    const [, id, language] = queryKey
    let url = `${KNOWLEDGE_DOMAIN_PATH}generalextrainstructions/details?id=${id}`
    if (language) {
        url += `&locale=${language}`
    }
    let result = await axios.get(url, commonHeaders)
    return result.data
}

export const getServiceConceptDocumentByTypeId = async ({ queryKey }) => {

    const [, typeid, language] = queryKey
    let url = `${KNOWLEDGE_DOMAIN_PATH}serviceconcept/${typeid}`
    if (language) {
        url += `?locale=${language}`
    }
    let result = await axios.get(url, commonHeaders)
    return result.data
}

export const getAssociatedFGListWithParts = async ({ queryKey }) => {
    try {
        const [, page, limit, search, orderBy, orderByField, filterByTypeNumber, filterByIsAssociatedFlag, filterByPartNumber, languageId] = queryKey
        let url = `${PRODUCT_AND_PARTS}fg-association-part?`
        if (page && limit) {
            url = appendQueryParam(url, "page", page)
            url = appendQueryParam(url, "limit", limit)
        }
        url = appendQueryParam(url, "search", search)
        url = appendQueryParam(url, "orderby", orderBy)
        url = appendQueryParam(url, "orderbyField", orderByField)
        url = appendQueryParam(url, "type_id", filterByTypeNumber)
        url = appendQueryParam(url, "is_associated", filterByIsAssociatedFlag)
        url = appendQueryParam(url, "part_id", filterByPartNumber)
        url = appendQueryParam(url, "language_id", languageId)
        if(filterByTypeNumber !==""){
            const result = await axios.get(url, commonHeaders)
            return await result.data

        }
    } catch (error) {
        return error
    }
}

export const getFinishedGoodsNoList = async ({ queryKey }) => {
    const [, filterByTypeNumber] = queryKey
    let result = await axios.get(`${PRODUCT_AND_PARTS}finished_goods_number_by_type/${filterByTypeNumber}
`, commonHeaders)
    return result.data
}

export const createFgPartNoAssociationApi = async (updatedData) => {
    const response = await axios.post(
        `${PRODUCT_AND_PARTS}fg-association-part`,
        updatedData,
        commonHeaders
    )
    return response.data
}

export async function deleteAssociationOfFgWithParts(id) {
    try {
        const result1 = await axios.delete(
            `${PRODUCT_AND_PARTS}fg-association-part/${id}`,
            commonHeaders
        )
        return await result1.data
    } catch (error) {
        return error
    }
}
/**
 * getSparePartsList() // Get Type Number List Record
 * @param {Onject} queryKey 
 * @returns Objects Either Success or Reject
 */

export async function getSparePartsList({ queryKey }) {
    const [_, page, limit, languageId, search, filterByMaterialClass, filterByPositionNumber, typeNumber, isPaginationEnabled, typeRecords,baseSalesOrgCode, priceList, orderBy,orderByField] = queryKey
    if(!typeNumber) {
        return
    }
    //NOTE: isPaginationEnabled // Enabled for special-tools
    const pathName = isPaginationEnabled ? "special-tools" : "spare-parts"
    // Check if user coming from Warranty Screen then need to pass repair date and sales org to get Part Details Data
    let url
    if (typeRecords?.repairDate && typeRecords.salesOrg && typeRecords.serviceCenterID) {
        url = `${PRODUCT_AND_PARTS}product-catalogue/${pathName}/${typeNumber}?sales_orgs=${typeRecords.salesOrg}&repair_date=${typeRecords.repairDate}&service_center_id=${typeRecords.serviceCenterID}`
    }
    else {
        url = `${PRODUCT_AND_PARTS}product-catalogue/${pathName}/${typeNumber}?`
    }
    if (page && limit && isPaginationEnabled) {
        url = appendQueryParam(url, "page", page)
        url = appendQueryParam(url, "limit", limit)
    }
    url = appendQueryParam(url, "languageId", languageId)
    url = appendQueryParam(url, "search", search)
    url = appendQueryParam(url, "filterByMaterialClass", filterByMaterialClass)
    url = appendQueryParam(url, "filterByPositionNumber", filterByPositionNumber)
    url = appendQueryParam(url, "orderby", orderBy)
    url = appendQueryParam(url, "orderbyField", orderByField)
    url = appendQueryParam(url, "sales_org_id", baseSalesOrgCode)
    const result = await axios.get(url, commonHeaders)
    return await result.data
}


/**
 * hotSpotImageUpload() // Drawaing Image Upload
 * @returns Objects Either Success or Reject
 */

export const hotSpotImageUpload = async (data) => {
    let result = await axios.post(
        `${PRODUCT_AND_PARTS}product-catalogue/hotspots_image`,
        data,
        commonHeaders
    )
    return result.data
}

export const hotSpotImageUpDate = async (data, imgageId) => {
    let result = await axios.patch(
        `${PRODUCT_AND_PARTS}product-catalogue/update_hotspots_image/${imgageId}`,
        data,
        commonHeaders
    )
    return result.data
}

/**
 * getHotSpotImage() // Drawaing Image Fetch
 * @returns Objects Either Success or Reject
 */

export const getHotSpotImage = async ({ queryKey }) => {
    const [, typeNumberId] = queryKey

    let result = await axios.get(
        `${PRODUCT_AND_PARTS}product-catalogue/hotspot-image/${typeNumberId}`,
        commonHeaders
    )
    return result.data
}

export const getProductCataLogePriceList = async ({ queryKey }) => {
    const [_, loggedInuserID] = queryKey

    let result = await axios.get(
        `${PRODUCT_AND_PARTS}product-catalogue/price-list/${loggedInuserID}`,
        commonHeaders
    )
    return result.data
}



/**
 * getHotSpotPosition() // Get Hot Spot Position
 * @returns Objects Either Success or Reject
 */

export const getHotSpotPosition = async ({ queryKey }) => {
    const [, typeNumberId] = queryKey

    let result = await axios.get(
        `${PRODUCT_AND_PARTS}product-catalogue/hotspot-positions/${typeNumberId}`,
        commonHeaders
    )
    return result.data
}
/**
 * createHotSpot() // Create Hot Spot
 * @returns Objects Either Success or Reject
 */

export const createHotSpot = async (data) => {
    let result = await axios.post(
        `${PRODUCT_AND_PARTS}product-catalogue/hotspots`,
        data,
        commonHeaders
    )
    return result.data
}

/**
 * getAllHotSpots() // Get All Hot Spots of Doc Image after passing the image id 
 * @returns Objects Either Success or Reject
 */

export const getAllHotSpots = async ({ queryKey }) => {
    const [, imageID] = queryKey
    let result = await axios.get(
        `${PRODUCT_AND_PARTS}product-catalogue/all-hotspots/${imageID}`,

        commonHeaders
    )
    return result.data
}

/**
 * updateHptSpot() // Update Hot Spot 
 * @returns Objects Either Success or Reject
 */

export const updateHotSpot = async (id, data) => {
    let result = await axios.patch(
        `${PRODUCT_AND_PARTS}product-catalogue/hotspots/${id}`,
        data,
        commonHeaders
    )
    return result.data
}

/**
 * deleteHotSpot() // Update Hot Spot 
 * @returns Objects Either Success or Reject
 */

export const deleteHotSpot = async (id) => {
    let result = await axios.delete(
        `${PRODUCT_AND_PARTS}product-catalogue/remove-hotspot/${id}`,
        commonHeaders
    )
    return result.data
}

/**
 * deleteHotSpotImage() // Delete HotSpot Image
 * @returns Objects Either Success or Reject
 */

export const deleteHotSpotImage = async (id) => {
    let result = await axios.delete(
        `${PRODUCT_AND_PARTS}product-catalogue/remove-hotspot-image/${id}`,
        commonHeaders
    )
    return result.data
}

export const updateHotSpotImage = async (id) => {
    let result = await axios.patch(
        `${PRODUCT_AND_PARTS}product-catalogue/update_hotspots_image/${id}`,
        commonHeaders
    )
    return result.data
}


/**
 * downloadSpareParts() // Get Type Number List Record
 * @returns Objects Either Success or Reject
 */

export async function downloadSpareParts(languageId, typeId, typeRecords) {
    let url
    if (typeRecords?.repairDate && typeRecords.salesOrg) {
        url = `${PRODUCT_AND_PARTS}product-catalogue/spare-parts/${typeId}?sales_orgs=${typeRecords.salesOrg}&repair_date=${typeRecords.repairDate}&languageId=${languageId}`
    } else {
        url = `${PRODUCT_AND_PARTS}product-catalogue/spare-parts/${typeId}?languageId=${languageId}`
    }
    const result = await axios.get(url, commonHeaders)
    return await result.data
}

export const downloadAssociatedPartList = async (search,orderBy,orderByField, filterByTypeNumber, filterByIsAssociatedFlag, filterByFpcNumber, languageId) => {
    let url = `${PRODUCT_AND_PARTS}fg-association-part/parts-association?type_id=${filterByTypeNumber}`
    url = appendQueryParam(url, "search", search)
    url = appendQueryParam(url, "orderby", orderBy)
    url = appendQueryParam(url, "orderbyField", orderByField)
    url = appendQueryParam(url, "finished_goods_id", filterByFpcNumber)
    url = appendQueryParam(url, "is_associated", filterByIsAssociatedFlag)
    url = appendQueryParam(url, "language_id", languageId)
    const result = await axios.get(url, commonHeaders)
    return result
}

export const filterAssociatedPartList = async (typeId, finishedGoodsId, isAssociatedFlag) => {
    let result = await axios.get(
        `${PRODUCT_AND_PARTS}fg-association-part/parts-association?type_id=${typeId}&finished_goods_id=${finishedGoodsId}&is_associated=${isAssociatedFlag}`,
        commonHeaders
    )
    return result
}

export const getAssociatedPartsWithFg = async ({ queryKey }) => {
    try {
        const [, page, limit, search,orderBy,orderByField, filterByTypeNumber, filterByIsAssociatedFlag, filterByFpcNumber, languageId] = queryKey
        let url = `${PRODUCT_AND_PARTS}fg-association-part/parts-association?`
        if (page && limit) {
            url = appendQueryParam(url, "page", page)
            url = appendQueryParam(url, "limit", limit)
        }
        url = appendQueryParam(url, "search", search)
        url = appendQueryParam(url, "orderby", orderBy)
        url = appendQueryParam(url, "orderbyField", orderByField)
        url = appendQueryParam(url, "type_id", filterByTypeNumber)
        url = appendQueryParam(url, "finished_goods_id", filterByFpcNumber)
        url = appendQueryParam(url, "is_associated", filterByIsAssociatedFlag)
        url = appendQueryParam(url, "language_id", languageId)
        if(filterByTypeNumber !==""){
            const result = await axios.get(url, commonHeaders)
            return await result.data
        }
    } catch (error) {
        return error
    }
}

export async function downloadAssociatedFgList(search, orderBy, orderByField, filterByTypeNumber,
    filterByIsAssociatedFlag, filterByPartNumber, languageId) {
    const params = new URLSearchParams({ type_id: filterByTypeNumber })

    const addParam = (key, value) => {
        if (value) params.append(key, value)
    }

    addParam("search", search)
    addParam("orderby", orderBy)
    addParam("orderbyField", orderByField)
    addParam("is_associated", filterByIsAssociatedFlag)
    addParam("part_id", filterByPartNumber)
    addParam("language_id", languageId)

    const url = `${PRODUCT_AND_PARTS}fg-association-part?${params.toString()}`

    try {
        const result = await axios.get(url, commonHeaders)
        return result
    } catch (error) {
        return error
    }
}

export const filterAssociatedFgList = async (typeId, partId, isAssociatedFlag) => {
    let result = await axios.get(
        `${PRODUCT_AND_PARTS}fg-association-part?type_id=${typeId}&part_id=${partId}&is_associated=${isAssociatedFlag}`,
        commonHeaders
    )
    return result
}


export const getTypeNumbersListAll = async () => {
    let result = await axios.get(`${PRODUCT_AND_PARTS}type_number
`, commonHeaders)
    return result.data
}

export const getFinishedGoodsListAll = async (typeId) => {
    let result = await axios.get(
        `${PRODUCT_AND_PARTS}finished_goods_number_by_type/${typeId}`,
        commonHeaders
    )
    return result
}

export const getPartNumbersFgList = async ({ queryKey }) => {
    const [, filterByTypeNumber, language_id] = queryKey
    let result = ""
    if(language_id !==undefined){
        result = await axios.get(`${PRODUCT_AND_PARTS}part-association-type?filterByTypeNumber=${filterByTypeNumber}&language_id=${language_id !==null ? language_id : selecteLangId}`, commonHeaders)
    }
    else{
        result = await axios.get(`${PRODUCT_AND_PARTS}part-association-type?filterByTypeNumber=${filterByTypeNumber}&language_id=${language_id !==undefined ? language_id : selecteLangId}`, commonHeaders)
    }
    return result.data
}

// Parcel Condition
export const getParcelConditionList = async ({ queryKey }) => {
    const [, language_id, search] = queryKey
    if (!language_id) {
        return []
    }
    let url = `${DOAMIN_PATH}parcel-condition?language_id=${language_id}`
    if (search) {
        url += `&search=${search}`
    }
    let result = await axios.get(url, commonHeaders)
    return result.data
}

export const downloadParcelConditionList = async (currentLanguage, customSearch) => {
    let url = `${DOAMIN_PATH}parcel-condition`
    if (!currentLanguage) {
        return []
    }
    url += `?language_id=${currentLanguage}`
    if (customSearch) {
        url += `&search=${customSearch}`
    }
    let result = await axios.get(url, commonHeaders)
    return result.data
}

export const getParcelConditionByid = async ({ queryKey }) => {
    const [, id] = queryKey
    if (!id) {
        return {}
    }
    let url = `${DOAMIN_PATH}parcel-condition/${id}`
    let result = await axios.get(url, commonHeaders)
    return result.data
}

export const createParcelCondition = async (body) => {
    let result = await axios.post(
        `${DOAMIN_PATH}parcel-condition`,
        body,
        commonHeaders
    )
    return result.data
}

export const updateParcelCondition = async (id, body) => {
    let result = await axios.patch(
        `${DOAMIN_PATH}parcel-condition/${id}`,
        body,
        commonHeaders
    )
    return result.data
}

// Block Maintenance
export const getBlockMaintenanceList = async ({ queryKey }) => {
    const [, language_id, search] = queryKey
    if (!language_id) {
        return []
    }
    let url = `${DOAMIN_PATH}block-maintenance?language_id=${language_id}`
    if (search) {
        url += `&search=${search}`
    }
    let result = await axios.get(url, commonHeaders)
    return result.data
}

export const downloadBlockMaintenanceList = async (currentLanguage, customSearch) => {
    let url = `${DOAMIN_PATH}block-maintenance`
    if (!currentLanguage) {
        return []
    }
    url += `?language_id=${currentLanguage}`
    if (customSearch) {
        url += `&search=${customSearch}`
    }
    let result = await axios.get(url, commonHeaders)
    return result.data
}

export const getBlockMaintenanceByid = async ({ queryKey }) => {
    const [, id] = queryKey
    if (!id) {
        return {}
    }
    let url = `${DOAMIN_PATH}block-maintenance/${id}`
    let result = await axios.get(url, commonHeaders)
    return result.data
}

export const createBlockMaintenance = async (body) => {
    let result = await axios.post(
        `${DOAMIN_PATH}block-maintenance`,
        body,
        commonHeaders
    )
    return result.data
}

export const updateBlockMaintenance = async (id, body) => {
    let result = await axios.patch(
        `${DOAMIN_PATH}block-maintenance/${id}`,
        body,
        commonHeaders
    )
    return result.data
}

// Parcel Content Status
export const getParcelContentStatusList = async ({ queryKey }) => {
    const [, language_id, search] = queryKey
    if (!language_id) {
        return []
    }
    let url = `${DOAMIN_PATH}parcel-content-status?language_id=${language_id}`
    if (search) {
        url += `&search=${search}`
    }
    let result = await axios.get(url, commonHeaders)
    return result.data
}

export const downloadParcelContentStatusList = async (currentLanguage, customSearch) => {
    let url = `${DOAMIN_PATH}parcel-content-status`
    if (!currentLanguage) {
        return []
    }
    url += `?language_id=${currentLanguage}`
    if (customSearch) {
        url += `&search=${customSearch}`
    }
    let result = await axios.get(url, commonHeaders)
    return result.data
}

export const getParcelContentStatusByid = async ({ queryKey }) => {
    const [, id] = queryKey
    if (!id) {
        return {}
    }
    let url = `${DOAMIN_PATH}parcel-content-status/${id}`
    let result = await axios.get(url, commonHeaders)
    return result.data
}


export const createParcelContentStatus = async (body) => {
    let result = await axios.post(
        `${DOAMIN_PATH}parcel-content-status`,
        body,
        commonHeaders
    )
    return result.data
}

export const updateParcelContentStatus = async (id, body) => {
    let result = await axios.patch(
        `${DOAMIN_PATH}parcel-content-status/${id}`,
        body,
        commonHeaders
    )
    return result.data
}


// Warranty
export const getAllMasterData = async ({ queryKey }) => {
    const [, salesCode, languageID, type_id, service_center_id] = queryKey
    const URL = type_id ? `${DOAMIN_PATH}common/master_data_details/${salesCode}?language_id=${languageID}&type_id=${type_id}&service_center_id=${service_center_id}` : 
        `${DOAMIN_PATH}common/master_data_details/${salesCode}?language_id=${languageID}&service_center_id=${service_center_id}`
    let result = await axios.get(URL, commonHeaders)
    return result.data
}
// Create Ticket and use for upload document 
export const createWarrantyTicket = async (body, endPointName) => {
    let result = await axios.post(
        `${WARRANTY_MANAGEMENT}warranty/${endPointName}`,
        body,
        commonHeaders
    )
    return result.data
}


/**
 * downloadBulkTicketList() // Get Type Number List Record
 * @returns Objects Either Success or Reject
 */

export async function downloadBulkTicketList(languageId, bulkId) {
    let url = `${WARRANTY_MANAGEMENT}warranty/bulk_inspection/${bulkId}?languageId=${languageId}`
    const result = await axios.get(url, commonHeaders)
    return await result.data
}

/**
 * getRejectedReviewComment() // Get Rejected or Review Comment
 * @returns Objects Either Success or Reject
 */

export async function getRejectedReviewComment({ queryKey }) {
    const [, endPoint, bulkId, status_id, userType, languageId] = queryKey
    if(!bulkId) {
        return
    }
    let url
    if(endPoint == "action_comments") {
        url = `${WARRANTY_MANAGEMENT}warranty/${endPoint}/${bulkId}?language_id=${languageId}`
    } else {
        url = `${WARRANTY_MANAGEMENT}warranty/${endPoint}/${bulkId}`
    }
    
    const result = await axios.get(url, commonHeaders)
    return await result.data    
    
}

// Update Comments Internal
export const updateInternalNote = async (body) => {
    let result = await axios.post(
        `${WARRANTY_MANAGEMENT}warranty/internal_comments`,
        body,
        commonHeaders
    )
    return result.data
}

// Update Comments External
export const updateExternalComments = async (body) => {
    let result = await axios.post(
        `${WARRANTY_MANAGEMENT}warranty/update_status`,
        body,
        commonHeaders
    )
    return result.data
}

export async function deletWarrantyTicket(id) {
    try {
        let result = await axios.delete(
            `${WARRANTY_MANAGEMENT}warranty/warranty_ticket/${id}`,
            commonHeaders
        )
        return result.data
    } catch (error) {
        return error
    }
}
// send for approval process
export const warrantyTicketStatusForApproval = async (data) => {
    let result = await axios.post(
        `${WARRANTY_MANAGEMENT}submit-ticket`,
        data,
        commonHeaders
    )
    return result.data
}
// GET Ticket Status of approval process
export const getWarrantyTicketStatusForApproval = async (data) => {
    let result = await axios.post(
        `${WARRANTY_MANAGEMENT}submit-ticket/get-tickets-status`,
        data,
        commonHeaders
    )
    return result.data
}
// send for performa invoice process
export const warrantyPerformaStatusForApproval = async (data) => {
    let result = await axios.post(
        `${WARRANTY_MANAGEMENT}warranty-invoice/update_invoice_warranty_status`,
        data,
        commonHeaders
    )
    return result.data
}

// send for invoice process
export const warrantyTicketForInvoiceProcess = async (data) => {
    let result = await axios.post(
        `${WARRANTY_MANAGEMENT}warranty-invoice`,
        data,
        commonHeaders
    )
    return result.data
}

// Get Uploaded Document
export const getUploadedDocument = async ({ queryKey }) => {
    const [, ticket_id] = queryKey
    if(ticket_id) {
        let result = await axios.get(
            `${WARRANTY_MANAGEMENT}warranty/uploaded_file/${ticket_id}`,
            commonHeaders
        )
        return result.data
    }
}
// Delete Uploaded Document
export const deleteUploadedDocument = async (id) => {
    let result = await axios.delete(
        `${WARRANTY_MANAGEMENT}warranty/uploaded_file/${id}`,
        commonHeaders
    )
    return result.data
}

// Get Common Call Type Number and part Number By Sales Org 
export const getTypeNumberBySalesOrg = async ({ queryKey }) => {
    const [, endPoint, salesID] = queryKey
    let result = await axios.get(
        `${PRODUCT_AND_PARTS}${endPoint}${salesID}`,
        commonHeaders
    )
    return result.data
}
// Warranty - Edit Screen
export const getTicketDetails= async ({ queryKey }) => {
    const [, ticketNumner, isInvoiceRejected, language_id, repairTicketApp] = queryKey
    let url = isInvoiceRejected
        ? `${WARRANTY_MANAGEMENT}warranty/${ticketNumner}?is_invoice_rejected=${isInvoiceRejected}`
        : `${WARRANTY_MANAGEMENT}warranty/${ticketNumner}?language_id=${language_id}`
    if (repairTicketApp) {
        url += `${(url[url.length - 1] === "?" ? "" : "&") + "app=" + repairTicketApp
        }`
    }

    let result = await axios.get(url, commonHeaders)
    return result.data
}
// Warranty - Address - Validation Configuration
export const getAddressConfguration= async ({ queryKey }) => {
    const [, countryId] = queryKey
    let result = await axios.get(
        `${DOAMIN_PATH}warranty-configuration/byCountry/${countryId}`,
        commonHeaders
    )
    return result.data
}

// Warranty get All parts Number based on Type ID // Get All part Number Based on type Number
export const getAllPartNumberBasedonTypeNumber= async ({ queryKey }) => {
    const [, typeNumbers_ID, salesOrg, languageID] = queryKey

    if(!typeNumbers_ID && !languageID) {
        return
    }
    let result = await axios.get(
        `${PRODUCT_AND_PARTS}product-catalogue/all-spare-parts?type_numbers=${typeNumbers_ID}&sales_orgs=${salesOrg}&language_id=${languageID}`,
        commonHeaders
    )
    return result.data
}

// Warranty Get All Bulk Ticket List
export const getAllBulkTicketList= async ({ queryKey }) => {
    const [, bulk_id, page, limit, orderBy, orderByField] = queryKey

    if(!bulk_id) { 
        return
    }
    let url = page
        ? `${WARRANTY_MANAGEMENT}warranty/bulk_inspection/${bulk_id}?page=${page}&limit=${limit}`
        : `${WARRANTY_MANAGEMENT}warranty/bulk_inspection/${bulk_id}`
    if (orderBy) {
        url += `${(url[url.length - 1] === "?" ? "" : "&") + "orderBy=" + orderBy
        }`
    }
    if (orderByField) {
        url += `${(url[url.length - 1] === "?" ? "" : "&") + "orderByField=" + orderByField
        }`
    }
    let result = await axios.get(url,commonHeaders)
    return result.data
}

// Warranty findALlBulkTicketInspection Find All Bul Ticket On
export const findALlBulkTicketInspection= async () => {
    let result = await axios.get(
        `${WARRANTY_MANAGEMENT}/warranty/warranty_find_all_bulk_inspection`,
        commonHeaders
    )
    return result.data
}
// Retailer Name
export const getRetailerList = async ({ queryKey }) => {
    const [, search,salesID] = queryKey
    let url = `${DOAMIN_PATH}retailer`
    if (search) {
        url += `?search=${search}`
    }
    if(salesID) {
        url += `?so_codes=${salesID}`
    }
    let result = await axios.get(url, commonHeaders)
    return result.data
}

export const getRetailerDetailsByid = async ({ queryKey }) => {
    const [, id] = queryKey
    if (!id) {
        return {}
    }
    let url = `${DOAMIN_PATH}retailer/${id}`
    let result = await axios.get(url, commonHeaders)
    return result.data
}

export const createRetailer = async (body) => {
    let result = await axios.post(
        `${DOAMIN_PATH}retailer`,
        body,
        commonHeaders
    )
    return result.data
}

export const updateRetailer = async (id, body) => {
    let result = await axios.patch(
        `${DOAMIN_PATH}retailer/${id}`,
        body,
        commonHeaders
    )
    return result.data
}

export const getAssociatedMaterialListWithSalesOrg = async ({ queryKey })=> {
    const [, salesOrg] = queryKey
    let url = `${DOAMIN_PATH}service-material-association/service-material/`
       
    if (salesOrg) {
        url += salesOrg
    }
    const result = await axios.get(url, commonHeaders)
    return result.data
  
}
export const getAllListNosTMCPrice = async ({ queryKey }) => {
    const [, page, limit, customsearchtext, filter] = queryKey
    let selectedFilter = ""
    Object.keys(filter).forEach((key) => {
        if (filter[key].length > 0 || filter[key] != "") {
            let commaSeparatedFilterValues = ""

            let filterKey = ""
            switch (key) {
            case "salesOrg":
                filterKey = "salesOrg"
                commaSeparatedFilterValues = filter[key].join(",")
                break
            case "countryList":
                filterKey = "country"
                commaSeparatedFilterValues = filter[key].join(",")
                break
            case "plantList":
                filterKey = "plantId"
                commaSeparatedFilterValues = filter[key].join(",")
                break
            case "articleNumber":
                filterKey = "articleNumber"
                commaSeparatedFilterValues = filter[key].join(",")
                break
            case "sapBoxList":
                filterKey = "sapBoxId"
                commaSeparatedFilterValues = filter[key].join(",")
                break
            case "tmc":
                filterKey = "tmc"
                commaSeparatedFilterValues = filter[key]
                break
            case "fiscalYear":
                filterKey = "fiscalYear"
                commaSeparatedFilterValues = format(filter[key], "yyyy-MM-dd")
                break
            case "source":
                filterKey = "source"
                commaSeparatedFilterValues = filter[key].join(",")
                break
            case "currency":
                filterKey = "currency"
                commaSeparatedFilterValues = filter[key].join(",")
                break
            case "type":
                filterKey = "type"
                commaSeparatedFilterValues = filter[key]
                break
            }

            if (selectedFilter === "")
                selectedFilter += `${filterKey}=${commaSeparatedFilterValues}`
            else
                selectedFilter += `&${filterKey}=${commaSeparatedFilterValues}`
        }
        else {
            selectedFilter += ""
        }

    })


    let result = await axios.get(
        `${PRICING_DOMAIN_PATH}tmc-product-sold?page=${page}&limit=${limit}&search=${customsearchtext}&${selectedFilter}`,
        commonHeaders
    )
    return result.data
}

export const updateNOSTMCPriceApi = async (updatedData) => {
    const result = await axios.patch(
        `${PRICING_DOMAIN_PATH}tmc-product-sold/${updatedData.id}`,
        updatedData,
        commonHeaders
    )
    return result.data
}

export const getSAPBoxIdListAPI = async () => {
    let result = await axios.get(
        `${PRICING_DOMAIN_PATH}tmc-mapping/sap-box-ids`, commonHeaders

    )
    return result.data
}

export const downloadNosTMCPriceList = async (customsearchtext, filter) => {
    let selectedFilter = ""
    Object.keys(filter).forEach((key) => {
        if (filter[key].length > 0 || filter[key] != "") {
            let commaSeparatedFilterValues = ""
            let filterKey = ""
            switch (key) {
            case "salesOrg":
                filterKey = "salesOrg"
                commaSeparatedFilterValues = filter[key].join(",")
                break
            case "countryList":
                filterKey = "country"
                commaSeparatedFilterValues = filter[key].join(",")
                break
            case "plantList":
                filterKey = "plantId"
                commaSeparatedFilterValues = filter[key].join(",")
                break
            case "articleNumber":
                filterKey = "articleNumber"
                commaSeparatedFilterValues = filter[key].join(",")
                break
            case "sapBoxList":
                filterKey = "sapBoxId"
                commaSeparatedFilterValues = filter[key].join(",")
                break
            case "tmc":
                filterKey = "tmc"
                commaSeparatedFilterValues = filter[key]
                break
            case "fiscalYear":
                filterKey = "fiscalYear"
                commaSeparatedFilterValues = format(filter[key], "yyyy-MM-dd")
                break
            case "source":
                filterKey = "source"
                commaSeparatedFilterValues = filter[key].join(",")
                break
            case "currency":
                filterKey = "currency"
                commaSeparatedFilterValues = filter[key].join(",")
                break
            }
            if (selectedFilter === "")
                selectedFilter += `${filterKey}=${commaSeparatedFilterValues}`
            else
                selectedFilter += `&${filterKey}=${commaSeparatedFilterValues}`
        }
        else {
            selectedFilter += ""
        }
    })
    let result = await axios.get(
        `${PRICING_DOMAIN_PATH}tmc-product-sold?search=${customsearchtext}&${selectedFilter}`,
        commonHeaders
    )
    return result
}

// Country Attribute Config.

// Address Validation
export const getAddressConfigurationList = async ({ queryKey }) => {
    const [, sales_country_ids] = queryKey
    let url = `${DOAMIN_PATH}address-configuration?sales_country_ids=${sales_country_ids}`

    let result = await axios.get(url, commonHeaders)
    return result.data
}

export const getAddressConfigurationAttributes = async ({ queryKey }) => {
    let url = `${DOAMIN_PATH}address-configuration/attributes`
    let result = await axios.get(url, commonHeaders)
    return result.data
}

export const getAddressConfigurationByCountryId = async ({ queryKey }) => {
    const [, country_id] = queryKey
    if (!country_id) {
        return {}
    }
    let url = `${DOAMIN_PATH}address-configuration/${country_id}`
    let result = await axios.get(url, commonHeaders)
    return result.data
}

export const createAddressValidationConfig = async (body) => {
    let result = await axios.post(
        `${DOAMIN_PATH}address-configuration`,
        body,
        commonHeaders
    )
    return result.data
}

export const updateAddressValidationConfig = async (id, body) => {
    let result = await axios.patch(
        `${DOAMIN_PATH}address-configuration/${id}`,
        body,
        commonHeaders
    )
    return result.data
}

// Device Color
export const getDeviceColor = async ({ queryKey }) => {
    const [, language_id] = queryKey
    let url = `${DOAMIN_PATH}device-color?language_id=${language_id}`
    let result = await axios.get(url, commonHeaders)
    return result.data
}

// check Repeated Repair
export const getRepeatedRepair = async ({ queryKey }) => {
    const [, payload] = queryKey
    const { first_name, last_name, email, phone, mobile, ean, type_number_id } = payload
    let url = `${WARRANTY_MANAGEMENT}warranty/is_repeated_repair?type_number_id=${type_number_id}`
    if (first_name) {
        url += `&first_name=${ first_name}`
    }
    if(last_name) {
        url += `&last_name=${last_name}`
    }
    if(mobile) {
        url += `&mobile=${mobile}`
    }
    if(phone) {
        url += `&phone=${phone}`
    }
    if(email) {
        url += `&email=${email}`
    }
    if(ean) {
        url += `&ean=${ean}`
    }
 
    if(email && type_number_id && ean || (first_name && last_name && phone && mobile && type_number_id && ean)) {
        let result = await axios.get(url, commonHeaders)
        return result.data
    }
}

export const getAdvanceSearchResult = async ({ queryKey }) => {
    const [_, payload] = queryKey
    const { typenumber_id, type_description, part_number, part_description, fg, fg_description, ean } = payload
    let url = `${PRODUCT_AND_PARTS}product-catalogue/advance-search`
    if (typenumber_id) {
        url += `?typenumber_id=${ typenumber_id}`
    }
    if (type_description) {
        url += `&type_description=${ type_description}`
    }
    if(part_number) {
        url += `&last_name=${part_number}`
    }
    if(part_description) {
        url += `&mobile=${part_description}`
    }
    if(fg) {
        url += `&phone=${fg}`
    }
    if(fg_description) {
        url += `&email=${fg_description}`
    }
    if(ean) {
        url += `&ean=${ean}`
    }

    let result = await axios.get(url, commonHeaders)
    return result.data
   
}




//Warranty Attributes 

export const getWarrantyConfigurationList = async ({ queryKey }) => {
    const [, sales_country_ids] = queryKey
    let url = `${DOAMIN_PATH}warranty-configuration?sales_country_ids=${sales_country_ids}`
    let result = await axios.get(url, commonHeaders)
    return result.data
}

export const getWarrantyConfigurationAttributes = async ({ queryKey }) => {
    let url = `${DOAMIN_PATH}warranty-configuration/attributes`
    let result = await axios.get(url, commonHeaders)
    return result.data
}

export const getBulkInspectionAttributes = async () => {
    let url = `${DOAMIN_PATH}warranty-configuration/bulk-inspection-attributes`
    let result = await axios.get(url, commonHeaders)
    return result.data
}

export const getWarrantyConfigurationByCountryId = async ({ queryKey }) => {
    const [, country_id] = queryKey
    if (!country_id) {
        return {}
    }
    let url = `${DOAMIN_PATH}warranty-configuration/${country_id}`
    let result = await axios.get(url, commonHeaders)
    return result.data
}

export const createWarrantyValidationConfig = async (body) => {
    let result = await axios.post(
        `${DOAMIN_PATH}warranty-configuration`,
        body,
        commonHeaders
    )
    return result.data
}

export const updateWarrantyValidationConfig = async (id, body) => {
    let result = await axios.patch(
        `${DOAMIN_PATH}warranty-configuration/${id}`,
        body,
        commonHeaders
    )
    return result.data
}
export async function getOrderHistory({ queryKey }) {
    const [, filterByPartNumber,scNameList, ohFromdate,ohTodate,dayRangeValue] = queryKey
    let url = `${ORDER_MANAGEMENT}orders/order-history?`
    if (filterByPartNumber) {
        url += `${(url[url.length - 1] === "?" ? "" : "&") + "partNumber=" + filterByPartNumber}`
    }
    if (scNameList) {
        url += `${(url[url.length - 1] === "?" ? "" : "&") + "serviceCenterid=" + scNameList}`
    }
    if (ohFromdate) {
        url += `${(url[url.length - 1] === "?" ? "" : "&") + "fromDate=" + ohFromdate}`
    }
    if (ohTodate) {
        url += `${(url[url.length - 1] === "?" ? "" : "&") + "toDate=" + ohTodate}`
    }
    if (dayRangeValue) {
        url += `${(url[url.length - 1] === "?" ? "" : "&") + "daysRange=" + dayRangeValue}`
    }
    const result = await axios.get(url, commonHeaders)
    return await result.data
}

export const getserviceCenterName = async () => {
    let url = `${ORDER_MANAGEMENT}orders/service-center-associated-org`
    let result = await axios.get(url, commonHeaders)
    return result.data
} 
export const getOrderDetailsData = async ({ queryKey }) => {
    const [, page, limit, customsearchtext,orderId,SAPOrderId] = queryKey
    let url = `${ORDER_MANAGEMENT}orders/get-order-detail?`
    if (page && limit) {
        url += `${(url[url.length - 1] === "?" ? "" : "&") + "page=" + page}`
        url += `${(url[url.length - 1] === "?" ? "" : "&") + "limit=" + limit}`
    }
    if (customsearchtext) {
        url += `${(url[url.length - 1] === "?" ? "" : "&") + "search=" + customsearchtext
        }`
    }
    if (orderId) {
        url += `${(url[url.length - 1] === "?" ? "" : "&") + "order_id=" + orderId
        }`
    }
    if (SAPOrderId) {
        url += `${(url[url.length - 1] === "?" ? "" : "&") + "sap_order_no=" + SAPOrderId
        }`
    }
    let result = await axios.get(url, commonHeaders)
    return result.data
}

export const createAutoApprovalRule = async (data) => {
    let result = await axios.post(
        `${WARRANTY_MANAGEMENT}warranty-workflow-rule`,
        data,
        commonHeaders
    )
    return result.data
}

export const updateAutoApprovalRule = async (payload) => {
    let result = await axios.patch(
        `${WARRANTY_MANAGEMENT}warranty-workflow-rule/${payload?.id}`,
        payload,
        commonHeaders
    )
    return result.data
}

export const getWarrantyAttributes = async () => {
    let result = await axios.get(
        `${WARRANTY_MANAGEMENT}warranty-workflow-rule/operatorsAttributesRules`,
        commonHeaders
    )
    return result?.data
}

export const getPredefinedRules = async () => {
    let result = await axios.get(
        `${WARRANTY_MANAGEMENT}common/predefined_rules`,
        commonHeaders
    )
    return result?.data
}

export const downloadWarrantyWorkflowRules = async (languageId, search, salesOrg, showOnlyActiveRules, isGlobal) => {
    let url = `${WARRANTY_MANAGEMENT}warranty-workflow-rule?`
    url = appendQueryParam(url, "language_id", languageId)
    url = appendQueryParam(url, "search", search)
    url = appendQueryParam(url, "sales_org", salesOrg)
    url = appendQueryParam(url, "is_active", showOnlyActiveRules)
    if (isGlobal) {
        url += `${(url[url.length - 1] === "?" ? "" : "&") + "is_global=" + isGlobal}`
    }
    if(isGlobal === false) {
        url += `${(url[url.length - 1] === "?" ? "" : "&") + "is_global=" + isGlobal}`
    }
    const result = await axios.get(url, commonHeaders)
    return result?.data
}



export const getWarrantyWorkflowRules = async ({ queryKey }) => {
    const [, page, limit, languageId, search, salesOrg, showOnlyActiveRules, isGlobal, orderBy, orderByField] = queryKey
    let url = `${WARRANTY_MANAGEMENT}warranty-workflow-rule?`
    if (page && limit) {
        url = appendQueryParam(url, "page", page)
        url = appendQueryParam(url, "limit", limit)
    }
    url = appendQueryParam(url, "language_id", languageId)
    url = appendQueryParam(url, "search", search)
    url = appendQueryParam(url, "sales_org", salesOrg)
    url = appendQueryParam(url, "is_active", showOnlyActiveRules)
    url = appendQueryParam(url, "orderby", orderBy)
    url = appendQueryParam(url, "orderbyField", orderByField)
    if (isGlobal) {
        url += `${(url[url.length - 1] === "?" ? "" : "&") + "is_global=" + isGlobal}`
    }
    if(isGlobal === false) {
        url += `${(url[url.length - 1] === "?" ? "" : "&") + "is_global=" + isGlobal}`
    }
    const result = await axios.get(url, commonHeaders)
    return await result.data
}

export const getOrderAddressData = async ({ queryKey }) => {
    const [,SCId] = queryKey
    let url = `${ORDER_MANAGEMENT}/secondary-sc-address?`
    if (SCId) {
        url += `${(url[url.length - 1] === "?" ? "" : "&") + "service_center_id=" + SCId
        }`
    }
    let result = await axios.get(url, commonHeaders)
    return result.data

}

export const getClaimCreateFormData = async ({ queryKey }) => {
    const [, orderId] = queryKey
    let url = `${ORDER_MANAGEMENT}claim-form/claimOrderData?`
    if (orderId) {
        url += `${(url[url.length - 1] === "?" ? "" : "&") + "orderId=" + orderId
        }`
    }
    let result = await axios.get(url, commonHeaders)
    return result.data
}

export const sendClaimForm = async (formData) => {
    let result = await axios.post(
        `${ORDER_MANAGEMENT}claim-form`,
        formData,
        commonHeaders
    )
    return result.data
}

export const getPartPrice = async ({ queryKey }) => {
    const [, partNo] = queryKey
    let url = `${ORDER_MANAGEMENT}claim-form/partPrice?`
    if (partNo) {
        url += `${(url[url.length - 1] === "?" ? "" : "&") + "partNumber=" + partNo
        }`
    }
    let result = await axios.get(url, commonHeaders)
    return result?.data
}

export const createSecondarySCAddress = async (data) => {
    let result = await axios.post(
        `${ORDER_MANAGEMENT}secondary-sc-address`,
        data,
        commonHeaders
    )
    return result.data
}

export const getAddressDetails = async ({ queryKey }) => {
    const [, id] = queryKey
    let result = await axios.get(
        `${ORDER_MANAGEMENT}secondary-sc-address/${id}`,
        commonHeaders
    )
    return result?.data?.data
}

export const updateAddressDetails = async (id, updatedData) => {
    let result = await axios.patch(
        `${ORDER_MANAGEMENT}secondary-sc-address/${id}`,
        updatedData,
        commonHeaders
    )
    return result.data
}

export async function deleteOrderAddress(id) {
    try {
        const result = await axios.delete(
            `${ORDER_MANAGEMENT}secondary-sc-address/${id}`,
            commonHeaders
        )
        return await result.data
    } catch (error) {
        return error
    }
}

// Warranty policy
export const getWarrantyPolicyList = async ({ queryKey }) => {
    const [, language_id, filter, search] = queryKey
    if (!language_id) {
        return []
    }
    let url = `${DOAMIN_PATH}warranty-policy?language_id=${language_id}`
    if (search) {
        url += `&search=${search}`
    }
    Object.keys(filter || {}).forEach((key) => {
        url += `&${key}=${filter[key]}`
    })
    let result = await axios.get(url, commonHeaders)
    return result.data
}

export const getWarrantyPolicyByid = async ({ queryKey }) => {
    const [, id] = queryKey
    if (!id) {
        return {}
    }
    let url = `${DOAMIN_PATH}warranty-policy/${id}`
    let result = await axios.get(url, commonHeaders)
    return result.data
}

export const createWarrantyPolicy = async (body) => {
    let result = await axios.post(
        `${DOAMIN_PATH}warranty-policy`,
        body,
        commonHeaders
    )
    return result.data
}

export const updateWarrantyPolicy = async (id, body) => {
    let result = await axios.patch(
        `${DOAMIN_PATH}warranty-policy/${id}`,
        body,
        commonHeaders
    )
    return result.data
}

export const removeWarrantyPolicy = async (id) => {
    let result = await axios.delete(
        `${DOAMIN_PATH}warranty-policy/${id}`,
        commonHeaders
    )
    return result.data
}

export const updateWarrantyPolicyActiveStatus = async (id, body) => {
    let result = await axios.post(
        `${DOAMIN_PATH}warranty-policy/${id}`,
        body,
        commonHeaders
    )
    return result.data
}

export const getInvoiceHistory = async (data) => {
    let result = await axios.post(
        `${WARRANTY_MANAGEMENT}warranty-invoice/findAll-invoice-warranty-history`,
        data,
        commonHeaders
    )
    return result.data
}

export async function getAllowedMaterialsList({ queryKey }) {
    const [, page, limit, sales_org_id, search] = queryKey
    let url = `${DOAMIN_PATH}allowed-materials?`
    if (page && limit) {
        url += `${(url[url.length - 1] === "?" ? "" : "&") + "page=" + page}`
        url += `${(url[url.length - 1] === "?" ? "" : "&") + "limit=" + limit}`
    }
    if (sales_org_id) {
        url += `${(url[url.length - 1] === "?" ? "" : "&") + "sales_org_id=" + sales_org_id}`
    }
    if (search) {
        url += `${(url[url.length - 1] === "?" ? "" : "&") + "search=" + search}`
    }
    const result1 = await axios.get(url, commonHeaders)
    return await result1.data
}

export async function createAllowedMaterials(data) {
    try {
        const result1 = await axios.post(
            `${DOAMIN_PATH}allowed-materials`,
            data,
            commonHeaders
        )
        return await result1.data
    } catch (error) {
        return error
    }
}

export async function updateAllowedMaterials(id, data) {
    try {
        const result1 = await axios.put(
            `${DOAMIN_PATH}allowed-materials/${id}`,
            data,
            commonHeaders
        )
        return await result1.data
    } catch (error) {
        return error
    }
}

export async function downloadAllowedMaterials(search,saleOrg) {
    try {
        let url = `${DOAMIN_PATH}allowed-materials?`
        if (search) {
            url += `${(url[url.length - 1] === "?" ? "" : "&") + "search=" + search}`
        }
        if (saleOrg) {
            url += `${(url[url.length - 1] === "?" ? "" : "&") + "sales_org_id=" + saleOrg}`
        }
        const result = await axios.get(url, commonHeaders)
        return result
    } catch (error) {
        return error
    }
}

export async function deleteAllowedMaterials(id) {
    try {
        const result1 = await axios.delete(
            `${DOAMIN_PATH}allowed-materials/${id}`,
            commonHeaders
        )
        return await result1.data
    } catch (error) {
        return error
    }
}


//Reject Maintanence
export const getRejectMaintenanceList = async ({ queryKey }) => {
    const [, language_id, search] = queryKey
    if (!language_id) {
        return []
    }
    let url = `${DOAMIN_PATH}reject-maintenance?language_id=${language_id}`
    if (search) {
        url += `&search=${search}`
    }
    let result = await axios.get(url, commonHeaders)
    return result.data
}

export const downloadRejectMaintenanceList = async (currentLanguage, customSearch) => {
    let url = `${DOAMIN_PATH}reject-maintenance`
    if (!currentLanguage) {
        return []
    }
    url += `?language_id=${currentLanguage}`
    if (customSearch) {
        url += `&search=${customSearch}`
    }
    let result = await axios.get(url, commonHeaders)
    return result.data
}

export const updateRejectMaintenance = async (id, body) => {
    let result = await axios.patch(
        `${DOAMIN_PATH}reject-maintenance/${id}`,
        body,
        commonHeaders
    )
    return result.data
}

export const createRejectMaintenance = async (body) => {
    let result = await axios.post(
        `${DOAMIN_PATH}reject-maintenance`,
        body,
        commonHeaders
    )
    return result.data
}

export const getRejectMaintenanceByid = async ({ queryKey }) => {
    const [, id] = queryKey
    if (!id) {
        return {}
    }
    let url = `${DOAMIN_PATH}reject-maintenance/${id}`
    let result = await axios.get(url, commonHeaders)
    return result.data
}

export async function deletPriceMatrix(id) {
    try {
        const result1 = await axios.delete(
            `${PRICING_DOMAIN_PATH}price-matrix-exception/${id}`,
            commonHeaders
        )
        return await result1.data
    } catch (error) {
        return error
    }
}

//Pay For Performance - PFP

export const getAllInternSubGrp = async ({ queryKey }) => {
    let result = await axios.get(
        `${PRODUCT_AND_PARTS}subCategory`,
        commonHeaders
    )
    return result?.data
}

export const getTransCostMaterial = async ({ queryKey }) => {
    const [, id] = queryKey
    let result = await axios.get(
        `${DOAMIN_PATH}common/trans-cost-material-list/${id}`,
        commonHeaders
    )
    return result.data
}

export const getTypeOfRepairList = async ({ queryKey }) => {
    const [, lang, customsearchtext] = queryKey
    let url = `${DOAMIN_PATH}repair-type?`
    if (lang) {
        url += `${(url[url.length - 1] === "?" ? "" : "&") + "language_id=" + lang
        }`
    }
    if (customsearchtext) {
        url += `${(url[url.length - 1] === "?" ? "" : "&") + "search=" + customsearchtext
        }`
    }
    let result = await axios.get(url, commonHeaders)
    return result?.data?.result
}

export const getTypeOfRepair = async ({ queryKey }) => {
    const [, code] = queryKey
    let result = await axios.get(
        `${DOAMIN_PATH}repair-type/${code}`,
        commonHeaders
    )
    return result?.data?.data
}

export const createTypeOfRepair = async (data) => {
    const response = await axios.post(
        `${DOAMIN_PATH}repair-type`,
        data,
        commonHeaders
    )
    return response.data
}

export const updateTypeOfRepair = async (id, data) => {
    const response = await axios.patch(
        `${DOAMIN_PATH}repair-type/${id}`,
        data,
        commonHeaders
    )
    return response.data
}

export const getReasonForImpossibilityList = async ({ queryKey }) => {
    const [, lang, customsearchtext] = queryKey
    let url = `${DOAMIN_PATH}repair-impossibility-reason?`
    if (lang) {
        url += `${(url[url.length - 1] === "?" ? "" : "&") + "language_id=" + lang
        }`
    }
    if (customsearchtext) {
        url += `${(url[url.length - 1] === "?" ? "" : "&") + "search=" + customsearchtext
        }`
    }
    let result = await axios.get(url, commonHeaders)
    return result?.data?.result
}

export const getReasonForImpossibility = async ({ queryKey }) => {
    const [, code] = queryKey
    let result = await axios.get(
        `${DOAMIN_PATH}repair-impossibility-reason/${code}`,
        commonHeaders
    )
    return result?.data?.data
}

export const createReasonForImpossibility = async (data) => {
    const response = await axios.post(
        `${DOAMIN_PATH}repair-impossibility-reason`,
        data,
        commonHeaders
    )
    return response.data
}

export const updateReasonForImpossibility = async (id, data) => {
    const response = await axios.patch(
        `${DOAMIN_PATH}repair-impossibility-reason/${id}`,
        data,
        commonHeaders
    )
    return response.data
}

// Warranty - Sample Collection Get Api
export const getSampleCollectionData = async ({ queryKey }) => {
    const [, language_id, page, limit, country_id, intern_group_id, search, type_ids, product_categories, orderBy, orderByField] = queryKey

    let url = `${DOAMIN_PATH}sample-collection?status=1&language_id=${language_id}`

    if (page && limit) {
        url += `${(url[url.length - 1] === "?" ? "" : "&") + "page=" + page}`
        url += `${(url[url.length - 1] === "?" ? "" : "&") + "limit=" + limit}`
    }
    if (country_id) {
        url += `&country_id=${country_id}`
    }

    if (intern_group_id) {
        url += `&intern_group_id=${intern_group_id}`
    }

    if (search) {
        url += `&search=${search}`
    }

    if (type_ids) {
        url += `&type_id=${type_ids}`
    }
    if (product_categories) {
        url += `&product_categories=${product_categories}`
    }

    if (orderBy) {
        url += `&orderBy=${orderBy}`
    }

    if (orderByField) {
        url += `&orderByField=${orderByField}`
    }
    let result = await axios.get(url,commonHeaders)
    return result.data
}

// Warranty - Sample Collection Download 
export const getSampleCollectionDataDownload = async ({ queryKey }) => {
    const [, language_id, country_id] = queryKey
    let url = `${DOAMIN_PATH}sample-collection?status=1&language_id=${language_id}&country_id=${country_id}`
    let result = await axios.get(url,commonHeaders)
    return result.data
}

// Sample collection

export const getSampleCollectionList = async ({ queryKey }) => {
    const [, language_id, filter] = queryKey
    if (!language_id) {
        return []
    }
    let url = `${DOAMIN_PATH}sample-collection?language_id=${language_id}`
    Object.keys(filter || {}).forEach((key) => {
        if(filter[key]) {
            url += `&${key}=${filter[key]}`
        }
    })
    let result = await axios.get(url, commonHeaders)
    return result.data
}


export const saveSampleCollection = async (payloadAsForm) => {
    const headers = { ...commonHeaders }
    headers["Content-Type"] = "multipart/form-data"
    const response = await axios.post(
        `${DOAMIN_PATH}sample-collection`,
        payloadAsForm,
        headers
    )
    return response.data
}

export const removeSampleCollection = async (id) => {
    let result = await axios.delete(
        `${DOAMIN_PATH}sample-collection/${id}`,
        commonHeaders
    )
    return result.data
}

export const updateSampleCollection = async (id, body) => {
    const headers = { ...commonHeaders }
    headers["Content-Type"] = "multipart/form-data"
    let result = await axios.patch(
        `${DOAMIN_PATH}sample-collection/${id}`,
        body,
        headers
    )
    return result.data
}

export const getSampleCollectionByid = async ({ queryKey }) => {
    const [, id] = queryKey
    if (!id) {
        return {}
    }
    let url = `${DOAMIN_PATH}sample-collection/${id}`
    let result = await axios.get(url, commonHeaders)
    return result.data
}
export const getPayForPerformacePCMAll = async ({ queryKey }) => {
    const [, page, limit, search, appliedFilter, orderBy,orderByField] = queryKey
    let url = `${WARRANTY_MANAGEMENT}pay-for-performance-configuration?page=${page}&limit=${limit}`
    if (search) {
        url += `&search=${search}`
    }
    if (appliedFilter?.startDate) {
        url += `&validity_from=${appliedFilter?.startDate}`
    }
    if (appliedFilter?.endDate) {
        url += `&validity_to=${appliedFilter?.endDate}`
    }
    if (appliedFilter?.salesOrg) {
        url += `&sales_org=${appliedFilter?.salesOrg}`
    }
    if (appliedFilter?.status) {
        url += `&status=${appliedFilter?.status}`
    }
    if (orderBy) {
        url += `${(url[url.length - 1] === "?" ? "" : "&") + "orderby=" + orderBy }`
    }
    if (orderByField) {
        url += `${(url[url.length - 1] === "?" ? "" : "&") + "orderbyField=" + orderByField }`
    }
    if (appliedFilter?.fromCurrency) {
        url += `&from_currency=${appliedFilter?.fromCurrency}`
    }
    if (appliedFilter?.toCurrency) {
        url += `&to_currency=${appliedFilter?.toCurrency}`
    }
    let result = await axios.get(
        url,
        commonHeaders
    )
    return result.data
   
}

export const getPopOperator = async () => {
    let result = await axios.get(`${WARRANTY_MANAGEMENT}pay-for-performance-configuration/pop-operators`, commonHeaders)
    return result.data
}

export const editPerformanceConfig = async ({ queryKey }) => {
    const [, id] = queryKey
    let result = await axios.get(`${WARRANTY_MANAGEMENT}pay-for-performance-configuration/${id}`, commonHeaders)
    return result.data
}

export const CreatePerformanceConfig = async (body) => {
    try {
        return await axios.post(
            `${WARRANTY_MANAGEMENT}pay-for-performance-configuration`,
            body,
            commonHeaders
        )
    } catch (error) {
        return error
    }
}
export const updatePerformanceConfig = async (body,id) => {
    return await axios.patch(
        `${WARRANTY_MANAGEMENT}pay-for-performance-configuration/${id}`,
        body,
        commonHeaders
    )
}

export const getPFPReportList = async ({ queryKey }) => {
    const [, page, limit, search, orderBy, orderByField, filter] = queryKey
    
    const buildUrl = (baseUrl, params) => {
        const queryString = new URLSearchParams(params).toString()
        return `${baseUrl}?${queryString}`
    }

    const params = {
        ...(page && { page }),
        ...(limit && { limit }),
        ...(search && { search }),
        ...(orderBy && { orderby: orderBy }),
        ...(orderByField && { orderbyField: orderByField }),
        ...(filter?.sales_org_id?.value && { sales_org: filter.sales_org_id.label }),
        ...(filter?.startDate && { validity_from: onlyDateFormate(filter.startDate) }),
        ...(filter?.endDate && { validity_to: onlyDateFormate(filter.endDate) })
    }

    const url = buildUrl(`${WARRANTY_MANAGEMENT}pay-performance-report`, params)

    try {
        const result = await axios.get(url, commonHeaders)
        return result?.data
    } catch (error) {
        return error
    }
}

export const getCreateReportList = async ({ queryKey }) => {
    const { page, limit, languageId, search, orderBy, orderByField } = queryKey[1]

    const buildUrl = (baseUrl, params) => {
        const queryString = new URLSearchParams(params).toString()
        return `${baseUrl}?${queryString}`
    }

    const params = {
        ...(page && { page }),
        ...(limit && { limit }),
        ...(languageId && { language_id: languageId }),
        ...(search && { search }),
        ...(orderBy && { orderby: orderBy }),
        ...(orderByField && { orderbyField: orderByField })
    }

    const url = buildUrl(`${WARRANTY_MANAGEMENT}create-report`, params)

    try {
        const result = await axios.get(url, commonHeaders)
        return result?.data
    } catch (error) {
        return error
    }
}

export const getPFPDetailReportList = async ({ queryKey }) => {
    const { page, limit, languageId, search, orderBy, orderByField, from_period, to_period, sales_org } = queryKey[1]

    const buildUrl = (baseUrl, params) => {
        const queryString = new URLSearchParams(params).toString()
        return `${baseUrl}?${queryString}`
    }

    const params = {
        ...(page && { page }),
        ...(limit && { limit }),
        ...(languageId && { language_id: languageId }),
        ...(search && { search }),
        ...(orderBy && { orderby: orderBy }),
        ...(orderByField && { orderbyField: orderByField }),
        ...(from_period && { validity_from: from_period }),
        ...(to_period && { validity_to: to_period }),
        ...(sales_org && { sales_org })
    }

    const url = buildUrl(`${WARRANTY_MANAGEMENT}pay-performance-detailed-report`, params)

    try {
        const result = await axios.get(url, commonHeaders)
        return result?.data
    } catch (error) {
        return error
    }
}


export const createPFPReport = async (data) => {
    let result = await axios.post(
        `${WARRANTY_MANAGEMENT}create-report`,
        data,
        commonHeaders
    )
    return result.data
}

export const downloadPFPConfigList = async (customsearchtext) => {
    // get partial page data or full page data
    let url = `${WARRANTY_MANAGEMENT}pay-for-performance-configuration?`
    if (customsearchtext) {
        url += `${(url[url.length - 1] === "?" ? "" : "&") + "search=" + customsearchtext
        }`
    }
    
    let result = await axios.get(
        url,
        commonHeaders
    )

    return result.data
}

export const downloadPayPerfomenceDetails = async (customsearchtext, salesOrgCode, from_period, to_period) => {
    // get partial page data or full page data
    let url = `${WARRANTY_MANAGEMENT}pay-performance-detailed-report?`
    if (customsearchtext) {
        url += `${(url[url.length - 1] === "?" ? "" : "&") + "search=" + customsearchtext
        }`
    }
     if (salesOrgCode) {
        url += `${(url[url.length - 1] === "?" ? "" : "&") + "sales_org=" + salesOrgCode
        }`
    }
     if (from_period) {
        url += `${(url[url.length - 1] === "?" ? "" : "&") + "validity_from=" + from_period
        }`
    }
     if (to_period) {
        url += `${(url[url.length - 1] === "?" ? "" : "&") + "validity_to=" + to_period
        }`
    }
    
    let result = await axios.get(
        url,
        commonHeaders
    )

    return result.data
}

export const createPFPDetailReport = async (data) => {
    let result = await axios.post(
        `${WARRANTY_MANAGEMENT}pay-performance-detailed-report`,
        data,
        commonHeaders
    )
    return result.data
}
export const updateActiveStatus = async (body,id) => {
    return await axios.patch(
        `${WARRANTY_MANAGEMENT}pay-for-performance-configuration/updateActiveStatus/${id}`,
        body,
        commonHeaders
    )
}
export async function downloadPFPReport(search, filter) {
    try {
        let url = `${WARRANTY_MANAGEMENT}pay-performance-report?`
        if (search) {
            url += `${(url[url.length - 1] === "?" ? "" : "&") + "search=" + search}`
        }
        if(filter?.sales_org_id?.value) {
            url += `${(url[url.length - 1] === "?" ? "" : "&") + "sales_org=" + filter.sales_org_id.label}`
        }
        if(filter?.startDate) {
            url += `${(url[url.length - 1] === "?" ? "" : "&") + "validity_from=" + onlyDateFormate(filter.startDate)}`
        }
        if(filter?.endDate) {
            url += `${(url[url.length - 1] === "?" ? "" : "&") + "validity_to=" + onlyDateFormate(filter.endDate)}`
        }
        const result = await axios.get(url, commonHeaders)
        return result?.data
    } catch (error) {
        return error
    }
}

// reports api
export const getReportAnalytics = async ({ queryKey }) => {
    const [, filter] = queryKey
    let url = `${REPORTING_SERVICE_DOMAIN_PATH}warranty-dashboard?`
    if (filter["salesOrg"]?.length) {
        url += `${url[url.length - 1] === "?" ? "" : "&"
        }sales_orgs=${filter.salesOrg?.map((e) => e.value)}`
    }
    if (filter["brand"]?.length) {
        url += `${url[url.length - 1] === "?" ? "" : "&"
        }brand=${filter.brand?.map((e) => e.value)}`
    }
    if (filter["warrantyType"]?.length) {
        url += `${url[url.length - 1] === "?" ? "" : "&"
        }warranty_type=${filter.warrantyType?.map((e) => e.value)}`
    }
    if (filter["from"]?.length) {
        url += `${url[url.length - 1] === "?" ? "" : "&"
        }period_from=${filter.from}`
    }
    if (filter["to"]?.length) {
        url += `${url[url.length - 1] === "?" ? "" : "&"
        }period_to=${filter.to}`
    }
    let result = await axios.get(url, commonHeaders)
    return result.data
}

export const getServiceCenterFactSheet = async ({ queryKey }) => {
    const [, filter] = queryKey
    let url = `${REPORTING_SERVICE_DOMAIN_PATH}warranty-dashboard/factsheet?`
    if (filter["salesOrg"]?.length) {
        url += `${url[url.length - 1] === "?" ? "" : "&"
        }sales_org=${filter.salesOrg}`
    }
    if (filter["pServiceCenter"]) {
        url += `${url[url.length - 1] === "?" ? "" : "&"
        }pri_service_center=${filter.pServiceCenter}`
    }
    if (filter["year"]?.length) {
        url += `${url[url.length - 1] === "?" ? "" : "&"
        }year=${filter.year}`
    }
    if (filter["period"]?.length) {
        url += `${url[url.length - 1] === "?" ? "" : "&"
        }period_from=${filter.period}`
    }
    let result = await axios.get(url, commonHeaders)
    return result.data
}

export const getDetailedReport = async ({ queryKey }) => {
    const [, id ]= queryKey
    let result = await axios.get(`${WARRANTY_MANAGEMENT}pay-performance-report/details/${id}`, commonHeaders)
    return result.data
}

// Warranty NOS and Materials
export const getNOSReport = async ({ queryKey }) => {
    const [_, page, limit, orderBy, orderByField, period, type] = queryKey
    let url = `${REPORTING_SERVICE_DOMAIN_PATH}nos-report?type=${type}`
    
    if (page && limit) {
        url += `${(url[url.length - 1] === "?" ? "" : "&") + "page=" + page}`
        url += `${(url[url.length - 1] === "?" ? "" : "&") + "limit=" + limit}`
    }
    
    if (orderBy) {
        url += `&orderBy=${orderBy}`
    }

    if (orderByField) {
        url += `&orderByField=${orderByField}`
    }

    if (period) {
        url += `&period=${period}`
    }
    let result = await axios.get(url, commonHeaders)
    return result.data
}

export const downloadNOSReport = async (id) => {
    let url = `${REPORTING_SERVICE_DOMAIN_PATH}nos-report/${id}`
    let result = await axios.get(url, commonHeaders)
    return result.data
}

export const generateNOSReport = async (data) => {
    let result = await axios.post(
        `${REPORTING_SERVICE_DOMAIN_PATH}nos-report`,
        data,
        commonHeaders
    )
    return result.data
}

// Warranty - Device Registration Get Api
export const getDeviceRegistrationList = async (page, limit, response, orderBy, orderByField) => {
    let url = `${DEVICE_REGISTRATION}device-registration/find_all_device_registration?page=${page}&limit=${limit}`

    if (response.consumer_id) {
        url += `&consumer_id=${response.consumer_id}`
    }

    if (response.email) {
        url += `&email=${encodeURIComponent(response.email)}`
    }

    if (response.phone_number) {
        url += `&phone_number=${response.phone_number}`
    }
    if (response.device_type_code) {
        url += `&device_type_code=${response.device_type_code.label}`
    }
    if (response.first_name) {
        url += `&first_name=${response.first_name}`
    }
    if (response.last_name) {
        url += `&last_name=${response.last_name}`
    }
    if (response.city) {
        url += `&city=${response.city}`
    }
    if (response.country) {
        url += `&country=${response.country?.code || response?.country?.code}`
    }
    if (response.postal_area_code) {
        url += `&postal_code=${response.postal_area_code}`
    }
    if (response.brand) {
        url += `&brand=${response.brand}`
    }
    if (orderBy) {
        url += `&orderBy=${orderBy}`
    }

    if (orderByField) {
        url += `&orderByField=${orderByField}`
    }
    let result = await axios.get(url,commonHeaders)
    return result.data
}

// Warranty - Device Registration Get Api By Counsumer ID
export const getDeviceRegistrationDetails = async ({ queryKey }) => {
    const [, consumer_id ]= queryKey
    if(!consumer_id) {
        return
    }
    let url = `${DEVICE_REGISTRATION}device-registration/find_by_consumer_id?consumer_id=${consumer_id}`

    let result = await axios.get(url,commonHeaders)
    return result.data
}

export const getUserDetails = async ({ queryKey }) => {
    const [_, headers] = queryKey
    let result = await axios.get(`${USER_MANAGEMENT_DOMAIN_PATH}user-context`, headers )
    return result.data
}

export const getExternalUserDetails = async (headers) => {
    let result = await axios.get(`${USER_MANAGEMENT_DOMAIN_PATH}user-context`, headers )
    return result.data
}

export const getRefreshToken = async ({ queryKey }) => {
    const [_] = queryKey
    let result = await axios.get(`${USER_MANAGEMENT_DOMAIN_PATH}refresh-auth`, commonHeaders )
    return result.data
}

export const getMasterDataForAAR = async ({ queryKey }) => {
    const [, languageID] = queryKey
    const URL = `${DOAMIN_PATH}common/master_data_details/0?language_id=${languageID}`
    let result = await axios.get(URL, commonHeaders)
    return result.data
}

export async function deletePriceList(id) {
    try {
        const result = await axios.delete(
            `${PRICING_DOMAIN_PATH}price-list/${id}`,
            commonHeaders
        )
        return await result.data
    } catch (error) {
        return error
    }
}

export const UpdateListPrice = async (data) => {
    let payload = {
        "ids" : data.ids,
        "active": data.active
    }
    let result = await axios.patch(
        `${PRICING_DOMAIN_PATH}list-price-upload`,
        payload,
        commonHeaders
    )
    return result.data
}
